// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod'

/**
 * AcceptPartnerUserInviteRequest
 */
export const AcceptPartnerUserInviteRequestSchema = z.object({
  email: z.email(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  name: z.string().min(2).max(255),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  timezone: z.string().nullish(),
  token: z.string().min(1)
})

export type AcceptPartnerUserInviteRequest = z.output<typeof AcceptPartnerUserInviteRequestSchema>

/**
 * AcceptedPaymentMethodType
 */
export const AcceptedPaymentMethodTypeSchema = z.enum(['card', 'link'])

export type AcceptedPaymentMethodType = z.output<typeof AcceptedPaymentMethodTypeSchema>

/**
 * AccountSessionComponent
 */
export const AccountSessionComponentSchema = z.enum([
  'account_onboarding',
  'account_management',
  'tax_settings'
])

export type AccountSessionComponent = z.output<typeof AccountSessionComponentSchema>

/**
 * AgeGroupSummary
 */
export const AgeGroupSummarySchema = z.strictObject({
  code: z.string(),
  description: z.string().nullable(),
  id: z.int(),
  max_age: z.int().nullable(),
  min_age: z.int().nullable(),
  name: z.string(),
  slug: z.string()
})

export type AgeGroupSummary = z.output<typeof AgeGroupSummarySchema>

/**
 * ApiErrorCode
 */
export const ApiErrorCodeSchema = z.enum([
  'INVALID_REQUEST',
  'AUTHENTICATION_REQUIRED',
  'AUTHORIZATION_DENIED',
  'STEP_UP_REQUIRED',
  'PASSWORD_CONFIRMATION_REQUIRED',
  'ADMIN_PANEL_REDIRECT_REQUIRED',
  'RESOURCE_NOT_FOUND',
  'METHOD_NOT_ALLOWED',
  'CONFLICT',
  'VALIDATION_ERROR',
  'BUSINESS_RULE_VIOLATION',
  'RATE_LIMITED',
  'EXTERNAL_SERVICE_ERROR',
  'SERVICE_UNAVAILABLE',
  'SESSION_EXPIRED',
  'INTERNAL_ERROR'
])

export type ApiErrorCode = z.output<typeof ApiErrorCodeSchema>

/**
 * ApiProblemReason
 */
export const ApiProblemReasonSchema = z.enum([
  'PAYMENT_PROCESSING_FAILED',
  'MENU_ITEM_UNAVAILABLE',
  'MENU_AVAILABILITY_VIOLATION',
  'ACCOUNT_INACTIVE',
  'STORE_ONBOARDING_INVALID_STATUS',
  'STORE_ONBOARDING_INCOMPLETE',
  'STORE_TEMPORARILY_CLOSED',
  'ROW_LOCK_TIMEOUT',
  'ORDER_MODIFICATION_PROPOSAL_STALE',
  'PHONE_NOT_SET',
  'PHONE_VERIFICATION_DISABLED',
  'PHONE_ALREADY_VERIFIED',
  'PHONE_VERIFICATION_CODE_INVALID',
  'PHONE_VERIFICATION_CODE_EXPIRED',
  'PHONE_VERIFICATION_RESEND_COOLDOWN',
  'PHONE_VERIFICATION_LANDLINE_UNSUPPORTED',
  'STEP_UP_REQUIRED',
  'PASSWORD_CONFIRMATION_REQUIRED',
  'TWO_FACTOR_NOT_ENABLED',
  'PASSWORD_RESET_LINK_INVALID',
  'ADMIN_PANEL_REDIRECT_REQUIRED',
  'ORDER_PAYMENT_METHOD_NOT_ATTACHED',
  'ORDER_PAYMENT_METHOD_NOT_USABLE',
  'ORDER_PAYMENT_METHOD_VALUE_INVALID',
  'PAYMENT_METHOD_DATA_INCOMPLETE',
  'INCOMPLETE_CARD_DETAILS',
  'UNSUPPORTED_PAYMENT_METHOD_TYPE',
  'ORDER_NOT_CANCELLABLE',
  'ORDER_AUTO_DECLINE_TOO_EARLY',
  'ORDER_NOT_AWAITING_PAYMENT',
  'ORDER_NOT_ELIGIBLE_FOR_PAYMENT_RETRY',
  'MERCHANT_ONBOARDING_CYCLE',
  'PAYMENT_ATTEMPT_IN_FLIGHT',
  'LEGAL_AGREEMENT_DOCUMENT_NOT_AVAILABLE',
  'LEGAL_AGREEMENT_NOT_ACCEPTED',
  'ASSET_STORAGE_UNAVAILABLE',
  'BRAND_SETUP_REQUIRED',
  'CONNECT_BUSINESS_TYPE_CHANGE_BLOCKED',
  'CONNECT_REONBOARDING_NOT_ACKNOWLEDGED'
])

export type ApiProblemReason = z.output<typeof ApiProblemReasonSchema>

/**
 * AssignMenuCategoriesRequest
 */
export const AssignMenuCategoriesRequestSchema = z.object({
  category_ids: z.array(z.int()).min(1).optional()
})

export type AssignMenuCategoriesRequest = z.output<typeof AssignMenuCategoriesRequestSchema>

/**
 * AssignMenuItemCategoryRequest
 */
export const AssignMenuItemCategoryRequestSchema = z.object({
  menu_category_id: z.int()
})

export type AssignMenuItemCategoryRequest = z.output<typeof AssignMenuItemCategoryRequestSchema>

/**
 * AssignMenuItemCustomizationGroupsRequest
 */
export const AssignMenuItemCustomizationGroupsRequestSchema = z.object({
  customization_group_ids: z.array(z.int()).optional(),
  customization_groups: z
    .array(
      z.object({
        id: z.int(),
        sort_order: z.int().gte(0).optional()
      })
    )
    .optional()
})

export type AssignMenuItemCustomizationGroupsRequest = z.output<
  typeof AssignMenuItemCustomizationGroupsRequestSchema
>

/**
 * AssignStoreMenusRequest
 */
export const AssignStoreMenusRequestSchema = z.object({
  menu_ids: z.array(z.int().gte(1)).max(500)
})

export type AssignStoreMenusRequest = z.output<typeof AssignStoreMenusRequestSchema>

/**
 * AuditActivityChangeResource
 */
export const AuditActivityChangeResourceSchema = z.object({
  key: z.string(),
  new_value: z.string().nullable(),
  old_value: z.string().nullable()
})

export type AuditActivityChangeResource = z.output<typeof AuditActivityChangeResourceSchema>

/**
 * AuditActivityPropertyResource
 */
export const AuditActivityPropertyResourceSchema = z.object({
  key: z.string(),
  value: z.union([z.string(), z.number(), z.boolean()]).nullable()
})

export type AuditActivityPropertyResource = z.output<typeof AuditActivityPropertyResourceSchema>

/**
 * AvatarUploadRequest
 */
export const AvatarUploadRequestSchema = z.object({
  avatar: z.string().min(1)
})

export type AvatarUploadRequest = z.output<typeof AvatarUploadRequestSchema>

/**
 * BrandDetailStore
 */
export const BrandDetailStoreSchema = z.strictObject({
  city: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  slug: z.string(),
  state: z.string().nullable(),
  status: z.string()
})

export type BrandDetailStore = z.output<typeof BrandDetailStoreSchema>

/**
 * BrandImageSlot
 *
 * The image a brand carries: its logo or its cover. The value is the `brands` column that stores the path.
 *
 */
export const BrandImageSlotSchema = z.enum(['logo', 'cover'])

export type BrandImageSlot = z.output<typeof BrandImageSlotSchema>

/**
 * BrandPublicStoreEntry
 */
export const BrandPublicStoreEntrySchema = z.strictObject({
  address: z.string().nullable(),
  average_rating: z.number().nullable(),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  delivery_available: z.boolean(),
  delivery_fee: z.number(),
  description: z.string().nullable(),
  dine_in_available: z.boolean(),
  formatted_address: z.string().nullable(),
  id: z.int(),
  logo: z.string().nullable(),
  minimum_order: z.number(),
  name: z.string(),
  pickup_available: z.boolean(),
  review_count: z.int().nullable(),
  slug: z.string(),
  state: z.string().nullable(),
  zip: z.string().nullable()
})

export type BrandPublicStoreEntry = z.output<typeof BrandPublicStoreEntrySchema>

/**
 * BrandPublicRecord
 */
export const BrandPublicRecordSchema = z.strictObject({
  cover: z.string().nullable(),
  description: z.string().nullable(),
  id: z.int(),
  is_featured: z.boolean(),
  logo: z.string().nullable(),
  name: z.string(),
  slug: z.string(),
  stores: z.array(BrandPublicStoreEntrySchema),
  stores_count: z.int(),
  website: z.string().nullable()
})

export type BrandPublicRecord = z.output<typeof BrandPublicRecordSchema>

/**
 * BrandStatus
 */
export const BrandStatusSchema = z.enum(['pending', 'active', 'inactive'])

export type BrandStatus = z.output<typeof BrandStatusSchema>

/**
 * BrandStoreSearchEntry
 */
export const BrandStoreSearchEntrySchema = z.strictObject({
  address: z.string().nullable(),
  average_rating: z.number().nullable(),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  delivery_fee: z.number(),
  dine_in_available: z.boolean(),
  distance_miles: z.number().nullable(),
  formatted_address: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  review_count: z.int().nullable(),
  slug: z.string(),
  state: z.string().nullable()
})

export type BrandStoreSearchEntry = z.output<typeof BrandStoreSearchEntrySchema>

/**
 * BrandStoreSearchQuery
 */
export const BrandStoreSearchQuerySchema = z.strictObject({
  bbox: z.string().nullable(),
  lat: z.number().nullable(),
  lng: z.number().nullable(),
  q: z.string()
})

export type BrandStoreSearchQuery = z.output<typeof BrandStoreSearchQuerySchema>

/**
 * BrandStoreSearchPage
 */
export const BrandStoreSearchPageSchema = z.strictObject({
  count: z.int(),
  query: BrandStoreSearchQuerySchema,
  results: z.array(BrandStoreSearchEntrySchema)
})

export type BrandStoreSearchPage = z.output<typeof BrandStoreSearchPageSchema>

/**
 * BrandSummary
 */
export const BrandSummarySchema = z.strictObject({
  cover: z.string().nullable(),
  id: z.int(),
  logo: z.string().nullable(),
  name: z.string(),
  slug: z.string(),
  status: z.string()
})

export type BrandSummary = z.output<typeof BrandSummarySchema>

/**
 * BrandWebsiteCandidate
 */
export const BrandWebsiteCandidateSchema = z.strictObject({
  brand_id: z.int(),
  brand_name: z.string(),
  website: z.string()
})

export type BrandWebsiteCandidate = z.output<typeof BrandWebsiteCandidateSchema>

/**
 * CartFeeConfig
 */
export const CartFeeConfigSchema = z.strictObject({
  auto_apply: z.boolean(),
  fixed_amount: z.number(),
  percentage: z.number(),
  type: z.string()
})

export type CartFeeConfig = z.output<typeof CartFeeConfigSchema>

/**
 * CartGratuity
 */
export const CartGratuitySchema = z.strictObject({
  dine_in_percentage: z.number()
})

export type CartGratuity = z.output<typeof CartGratuitySchema>

/**
 * CartItemCustomizationView
 */
export const CartItemCustomizationViewSchema = z.strictObject({
  group_id: z.int().nullable(),
  group_name: z.string().nullable(),
  option_id: z.int().nullable(),
  option_name: z.string().nullable(),
  price_adjustment: z.number()
})

export type CartItemCustomizationView = z.output<typeof CartItemCustomizationViewSchema>

/**
 * CartItemMenuItemView
 */
export const CartItemMenuItemViewSchema = z.strictObject({
  image: z.string().nullable(),
  minimum_guest_count: z.int()
})

export type CartItemMenuItemView = z.output<typeof CartItemMenuItemViewSchema>

/**
 * CartItemStoreView
 */
export const CartItemStoreViewSchema = z.strictObject({
  address: z.string().nullable(),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  name: z.string(),
  slug: z.string(),
  state: z.string().nullable(),
  zip: z.string().nullable()
})

export type CartItemStoreView = z.output<typeof CartItemStoreViewSchema>

/**
 * CartItemView
 */
export const CartItemViewSchema = z.strictObject({
  customization_cost: z.number(),
  customization_count: z.int(),
  customizations: z.array(CartItemCustomizationViewSchema),
  id: z.int(),
  is_package: z.boolean(),
  item_name: z.string(),
  menu_ids: z.array(z.int()),
  menu_item: CartItemMenuItemViewSchema,
  menu_item_id: z.int(),
  price_per_person: z.number().nullable(),
  quantity: z.int(),
  serves_count: z.string().nullable(),
  special_instructions: z.string().nullable(),
  store: CartItemStoreViewSchema,
  total_price: z.number(),
  unit_price: z.number()
})

export type CartItemView = z.output<typeof CartItemViewSchema>

/**
 * CartStoreGroup
 */
export const CartStoreGroupSchema = z.strictObject({
  address: z.string().nullable(),
  application_fee: z.number(),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  delivery_fee: z.number(),
  item_count: z.int(),
  items: z.array(CartItemViewSchema),
  minimum_order: z.number(),
  pickup_instructions: z.string().nullable(),
  sales_tax: z.number(),
  sales_tax_percentage: z.number(),
  sales_tax_rate: z.number(),
  state: z.string().nullable(),
  store_id: z.int(),
  store_name: z.string(),
  store_slug: z.string(),
  subtotal: z.number(),
  zip: z.string().nullable()
})

export type CartStoreGroup = z.output<typeof CartStoreGroupSchema>

/**
 * CartSummaryStore
 */
export const CartSummaryStoreSchema = z.strictObject({
  delivery_fee: z.number(),
  item_count: z.int(),
  store_id: z.int(),
  store_name: z.string(),
  subtotal: z.number()
})

export type CartSummaryStore = z.output<typeof CartSummaryStoreSchema>

/**
 * CartSummary
 */
export const CartSummarySchema = z.strictObject({
  application_fee: CartFeeConfigSchema,
  delivery_fee: CartFeeConfigSchema,
  item_count: z.int(),
  store_count: z.int().gte(0),
  stores: z.array(CartSummaryStoreSchema),
  subtotal: z.number()
})

export type CartSummary = z.output<typeof CartSummarySchema>

/**
 * CartTotals
 */
export const CartTotalsSchema = z.strictObject({
  item_count: z.int(),
  store_count: z.int().gte(0),
  subtotal: z.number()
})

export type CartTotals = z.output<typeof CartTotalsSchema>

/**
 * CartIndex
 */
export const CartIndexSchema = z.strictObject({
  application_fee: CartFeeConfigSchema,
  delivery_fee: CartFeeConfigSchema,
  gratuity: CartGratuitySchema,
  stores: z.array(CartStoreGroupSchema),
  summary: CartTotalsSchema
})

export type CartIndex = z.output<typeof CartIndexSchema>

/**
 * CategoryType
 */
export const CategoryTypeSchema = z.enum([
  'cuisine',
  'food_type',
  'service_type',
  'specialty',
  'dietary'
])

export type CategoryType = z.output<typeof CategoryTypeSchema>

/**
 * CategoryDto
 */
export const CategoryDtoSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  is_active: z.boolean(),
  name: z.string(),
  slug: z.string(),
  sort_order: z.int(),
  type: CategoryTypeSchema
})

export type CategoryDto = z.output<typeof CategoryDtoSchema>

/**
 * ChangeBusinessTypeRequest
 */
export const ChangeBusinessTypeRequestSchema = z.object({
  acknowledge_reonboarding: z.boolean().optional(),
  business_type: z.enum(['individual', 'company', 'non_profit', 'government_entity'])
})

export type ChangeBusinessTypeRequest = z.output<typeof ChangeBusinessTypeRequestSchema>

/**
 * CheckPhoneVerificationRequest
 */
export const CheckPhoneVerificationRequestSchema = z.object({
  code: z
    .string()
    .min(1)
    .regex(/^[0-9]{4,10}$/)
})

export type CheckPhoneVerificationRequest = z.output<typeof CheckPhoneVerificationRequestSchema>

/**
 * CityState
 */
export const CityStateSchema = z.strictObject({
  city: z.string().nullable(),
  state: z.string().nullable()
})

export type CityState = z.output<typeof CityStateSchema>

/**
 * ClassificationSummary
 */
export const ClassificationSummarySchema = z.strictObject({
  code: z.string(),
  description: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type ClassificationSummary = z.output<typeof ClassificationSummarySchema>

/**
 * ClientLogLevel
 */
export const ClientLogLevelSchema = z.enum(['error', 'warn', 'info', 'debug'])

export type ClientLogLevel = z.output<typeof ClientLogLevelSchema>

/**
 * ClientLogRequest
 */
export const ClientLogRequestSchema = z.object({
  entries: z
    .array(
      z.strictObject({
        context: z
          .record(z.string(), z.union([z.string(), z.number(), z.boolean()]).nullable())
          .nullish(),
        duration_ms: z.int().gte(0).nullish(),
        event: z
          .string()
          .min(1)
          .max(100)
          .regex(/^(?:[a-z][a-z0-9_]*|[A-Za-z][A-Za-z0-9]*\.[A-Za-z][A-Za-z0-9_]*)$/),
        level: ClientLogLevelSchema,
        message: z.string().nullish()
      })
    )
    .min(1)
    .max(50)
})

export type ClientLogRequest = z.output<typeof ClientLogRequestSchema>

/**
 * ClosureCode
 */
export const ClosureCodeSchema = z.enum(['STORE_TEMPORARILY_CLOSED', 'STORE_CLOSURE_UPCOMING'])

export type ClosureCode = z.output<typeof ClosureCodeSchema>

/**
 * ConfirmPasswordRequest
 */
export const ConfirmPasswordRequestSchema = z.object({
  password: z.string().min(1)
})

export type ConfirmPasswordRequest = z.output<typeof ConfirmPasswordRequestSchema>

/**
 * ConfirmTwoFactorAuthenticationRequest
 */
export const ConfirmTwoFactorAuthenticationRequestSchema = z.object({
  code: z.string().min(1)
})

export type ConfirmTwoFactorAuthenticationRequest = z.output<
  typeof ConfirmTwoFactorAuthenticationRequestSchema
>

/**
 * ConfirmTwoFactorRequest
 */
export const ConfirmTwoFactorRequestSchema = z.object({
  code: z.string().nullish(),
  recovery_code: z.string().nullish()
})

export type ConfirmTwoFactorRequest = z.output<typeof ConfirmTwoFactorRequestSchema>

/**
 * ConnectAccountStage
 *
 * Where a Connect account stands, derived from its onboarding row.
 *
 */
export const ConnectAccountStageSchema = z.enum([
  'type_unset',
  'type_set',
  'details_submitted',
  'active'
])

export type ConnectAccountStage = z.output<typeof ConnectAccountStageSchema>

/**
 * ConnectBusinessType
 *
 * A Connect account's provider `business_type`; `UNSET` is an account whose business type is not chosen yet.
 *
 */
export const ConnectBusinessTypeSchema = z.enum([
  'unset',
  'individual',
  'company',
  'non_profit',
  'government_entity'
])

export type ConnectBusinessType = z.output<typeof ConnectBusinessTypeSchema>

/**
 * ConnectBusinessTypeChangeBlocker
 *
 * Why an onboarding's business type cannot change.
 *
 */
export const ConnectBusinessTypeChangeBlockerSchema = z.enum([
  'none',
  'inherited_account',
  'payouts_exist',
  'connected_stores',
  'provider_refused'
])

export type ConnectBusinessTypeChangeBlocker = z.output<
  typeof ConnectBusinessTypeChangeBlockerSchema
>

/**
 * ConnectBusinessTypeChangeMode
 *
 * How an onboarding's business type can change right now.
 *
 */
export const ConnectBusinessTypeChangeModeSchema = z.enum([
  'in_place',
  'replace_account',
  'blocked'
])

export type ConnectBusinessTypeChangeMode = z.output<typeof ConnectBusinessTypeChangeModeSchema>

/**
 * ConnectBusinessTypeChange
 */
export const ConnectBusinessTypeChangeSchema = z.strictObject({
  blocker: ConnectBusinessTypeChangeBlockerSchema,
  mode: ConnectBusinessTypeChangeModeSchema
})

export type ConnectBusinessTypeChange = z.output<typeof ConnectBusinessTypeChangeSchema>

/**
 * ContactLeadReceipt
 */
export const ContactLeadReceiptSchema = z.strictObject({
  id: z.int()
})

export type ContactLeadReceipt = z.output<typeof ContactLeadReceiptSchema>

/**
 * ContactLeadStoreRequest
 */
export const ContactLeadStoreRequestSchema = z.object({
  email: z.email().max(255),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  hubspotutk: z.string().optional(),
  last_name: z.string().min(1).max(255),
  message: z.string().min(1).max(5000),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/),
  recaptcha_token: z.string().optional()
})

export type ContactLeadStoreRequest = z.output<typeof ContactLeadStoreRequestSchema>

/**
 * ContactRecord
 */
export const ContactRecordSchema = z.strictObject({
  email: z.string().nullable(),
  fax: z.string().nullable(),
  id: z.int(),
  phone: z.string().nullable()
})

export type ContactRecord = z.output<typeof ContactRecordSchema>

/**
 * ContactSummary
 */
export const ContactSummarySchema = z.strictObject({
  email: z.string().nullable(),
  fax: z.string().nullable(),
  id: z.int(),
  phone: z.string().nullable()
})

export type ContactSummary = z.output<typeof ContactSummarySchema>

/**
 * CreateAccountSessionRequest
 */
export const CreateAccountSessionRequestSchema = z.object({
  component: AccountSessionComponentSchema.optional()
})

export type CreateAccountSessionRequest = z.output<typeof CreateAccountSessionRequestSchema>

/**
 * CreateStoreRequest
 *
 * Create New Store - Step 1: Details (creates as draft); city/state/zip/coordinates resolve from the address.
 */
export const CreateStoreRequestSchema = z.object({
  address: z.string().min(1).max(500),
  brand_id: z.int().nullish(),
  city: z.string().max(255).nullish(),
  coordinates: z
    .array(
      z.object({
        latitude: z.number().gte(-90).lte(90),
        longitude: z.number().gte(-180).lte(180)
      })
    )
    .max(1)
    .optional(),
  cover: z.string().nullish(),
  description: z.string().max(5000).nullish(),
  email: z.email().max(255),
  logo: z.string().nullish(),
  name: z.string().min(1).max(255),
  partner_id: z.int().gte(1).optional(),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/),
  seating_capacity: z.int().gte(1).lte(100000).nullish(),
  state: z.string().max(100).nullish(),
  website: z.url().max(500).nullish(),
  zip: z.string().max(20).nullish()
})

export type CreateStoreRequest = z.output<typeof CreateStoreRequestSchema>

/**
 * Currency
 *
 * Every currency this deployment settles payments in; the persisted lowercase form.
 *
 */
export const CurrencySchema = z.enum(['usd'])

export type Currency = z.output<typeof CurrencySchema>

/**
 * CustomHoursDto
 */
export const CustomHoursDtoSchema = z.strictObject({
  day_of_week: z.string(),
  end_time: z.string().nullable(),
  is_enabled: z.boolean(),
  start_time: z.string().nullable()
})

export type CustomHoursDto = z.output<typeof CustomHoursDtoSchema>

/**
 * CustomerProposedPricing
 */
export const CustomerProposedPricingSchema = z.strictObject({
  application_fee: z.number(),
  delivery_fee: z.number(),
  subtotal: z.number(),
  tax: z.number(),
  tip: z.number(),
  total: z.number()
})

export type CustomerProposedPricing = z.output<typeof CustomerProposedPricingSchema>

/**
 * CustomizationDTO
 */
export const CustomizationDtoSchema = z.strictObject({
  group_id: z.int().nullable(),
  group_name: z.string().nullable(),
  option_id: z.int().nullable(),
  option_name: z.string().nullable(),
  price_adjustment: z.string()
})

export type CustomizationDto = z.output<typeof CustomizationDtoSchema>

/**
 * CustomizationGroupMenuSummary
 */
export const CustomizationGroupMenuSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  store_names: z.array(z.string())
})

export type CustomizationGroupMenuSummary = z.output<typeof CustomizationGroupMenuSummarySchema>

/**
 * CustomizationGroupStatus
 */
export const CustomizationGroupStatusSchema = z.enum(['draft', 'published'])

export type CustomizationGroupStatus = z.output<typeof CustomizationGroupStatusSchema>

/**
 * CustomizationGroupOptionSummaryDto
 */
export const CustomizationGroupOptionSummaryDtoSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  options_count: z.int(),
  sort_order: z.int(),
  status: CustomizationGroupStatusSchema
})

export type CustomizationGroupOptionSummaryDto = z.output<
  typeof CustomizationGroupOptionSummaryDtoSchema
>

/**
 * CustomizationPricingModel
 */
export const CustomizationPricingModelSchema = z.enum(['each', 'weight', 'percentage'])

export type CustomizationPricingModel = z.output<typeof CustomizationPricingModelSchema>

/**
 * CustomizationResource
 */
export const CustomizationResourceSchema = z.object({
  group_id: z.int().nullable(),
  group_name: z.string().nullable(),
  option_id: z.int().nullable(),
  option_name: z.string().nullable(),
  price_adjustment: z.number()
})

export type CustomizationResource = z.output<typeof CustomizationResourceSchema>

/**
 * DashboardAffectedBrand
 */
export const DashboardAffectedBrandSchema = z.strictObject({
  brand_id: z.int(),
  brand_name: z.string(),
  route: z.string()
})

export type DashboardAffectedBrand = z.output<typeof DashboardAffectedBrandSchema>

/**
 * DashboardOrderDatesResult
 */
export const DashboardOrderDatesResultSchema = z.strictObject({
  dates: z.array(z.string()),
  month: z.int(),
  year: z.int()
})

export type DashboardOrderDatesResult = z.output<typeof DashboardOrderDatesResultSchema>

/**
 * DashboardSearchResultItem
 */
export const DashboardSearchResultItemSchema = z.strictObject({
  category: z.string(),
  id: z.string(),
  name: z.string(),
  url: z.string()
})

export type DashboardSearchResultItem = z.output<typeof DashboardSearchResultItemSchema>

/**
 * DashboardStoreMissingMenu
 */
export const DashboardStoreMissingMenuSchema = z.strictObject({
  route: z.string(),
  store_id: z.int(),
  store_name: z.string()
})

export type DashboardStoreMissingMenu = z.output<typeof DashboardStoreMissingMenuSchema>

/**
 * DashboardStoreReviewGoogleStatus
 */
export const DashboardStoreReviewGoogleStatusSchema = z.strictObject({
  connected: z.boolean(),
  enabled: z.boolean(),
  external_id: z.string().nullable(),
  last_synced_at: z.string().nullable()
})

export type DashboardStoreReviewGoogleStatus = z.output<
  typeof DashboardStoreReviewGoogleStatusSchema
>

/**
 * DashboardStoreReviewOrder
 */
export const DashboardStoreReviewOrderSchema = z.strictObject({
  id: z.int(),
  order_number: z.string()
})

export type DashboardStoreReviewOrder = z.output<typeof DashboardStoreReviewOrderSchema>

/**
 * DashboardTaskCode
 */
export const DashboardTaskCodeSchema = z.enum([
  'CREATE_STORE',
  'CREATE_FIRST_MENU',
  'SETUP_PARTNER_PAYOUT_ACCOUNT',
  'VERIFY_EMAIL',
  'COMPLETE_STORE_SETUP',
  'UPLOAD_LOGO_COVER',
  'INVITE_TEAM_MEMBERS',
  'ADD_ANOTHER_STORE',
  'SET_UP_BRAND',
  'ACCEPT_MSA',
  'ENABLE_MFA'
])

export type DashboardTaskCode = z.output<typeof DashboardTaskCodeSchema>

/**
 * DashboardTaskCodeResource
 */
export const DashboardTaskCodeResourceSchema = z.object({
  code: DashboardTaskCodeSchema,
  params: z
    .object({
      can_submit: z.boolean(),
      store_name: z.string()
    })
    .optional()
})

export type DashboardTaskCodeResource = z.output<typeof DashboardTaskCodeResourceSchema>

/**
 * DashboardTaskCompletionResource
 */
export const DashboardTaskCompletionResourceSchema = z.object({
  completed: z.int(),
  percentage: z.number(),
  total: z.int()
})

export type DashboardTaskCompletionResource = z.output<typeof DashboardTaskCompletionResourceSchema>

/**
 * DayOfWeek
 */
export const DayOfWeekSchema = z.enum([
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
])

export type DayOfWeek = z.output<typeof DayOfWeekSchema>

/**
 * DeliveryContactType
 */
export const DeliveryContactTypeSchema = z.enum(['me', 'someone_else'])

export type DeliveryContactType = z.output<typeof DeliveryContactTypeSchema>

/**
 * DietaryOptionType
 */
export const DietaryOptionTypeSchema = z.enum(['restriction', 'preference', 'allergy'])

export type DietaryOptionType = z.output<typeof DietaryOptionTypeSchema>

/**
 * DietaryOptionDto
 */
export const DietaryOptionDtoSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  slug: z.string(),
  type: DietaryOptionTypeSchema
})

export type DietaryOptionDto = z.output<typeof DietaryOptionDtoSchema>

/**
 * DietaryOptionSummaryDto
 */
export const DietaryOptionSummaryDtoSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string(),
  type: DietaryOptionTypeSchema
})

export type DietaryOptionSummaryDto = z.output<typeof DietaryOptionSummaryDtoSchema>

/**
 * DirectorSummary
 */
export const DirectorSummarySchema = z.strictObject({
  contacts: z.array(ContactSummarySchema),
  description: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type DirectorSummary = z.output<typeof DirectorSummarySchema>

/**
 * DuplicateMenuRequest
 */
export const DuplicateMenuRequestSchema = z.object({
  store_ids: z.array(z.int()).min(1)
})

export type DuplicateMenuRequest = z.output<typeof DuplicateMenuRequestSchema>

/**
 * DuplicatedMenuDto
 */
export const DuplicatedMenuDtoSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  store_ids: z.array(z.int())
})

export type DuplicatedMenuDto = z.output<typeof DuplicatedMenuDtoSchema>

/**
 * EmailLegalAgreementRequest
 *
 * The one to ten addresses a legal agreement is emailed to; the agreement itself is named by the route.
 */
export const EmailLegalAgreementRequestSchema = z.object({
  emails: z.array(z.email().min(1).max(254)).min(1).max(10)
})

export type EmailLegalAgreementRequest = z.output<typeof EmailLegalAgreementRequestSchema>

/**
 * EventGender
 */
export const EventGenderSchema = z.enum(['Boys', 'Girls', 'Coed'])

export type EventGender = z.output<typeof EventGenderSchema>

/**
 * EventOrganizationSummary
 */
export const EventOrganizationSummarySchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  logo: z.string().nullable(),
  name: z.string(),
  slug: z.string(),
  website: z.string().nullable()
})

export type EventOrganizationSummary = z.output<typeof EventOrganizationSummarySchema>

/**
 * EventSlugSummary
 */
export const EventSlugSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type EventSlugSummary = z.output<typeof EventSlugSummarySchema>

/**
 * EventStatus
 */
export const EventStatusSchema = z.enum(['upcoming', 'active', 'past', 'cancelled'])

export type EventStatus = z.output<typeof EventStatusSchema>

/**
 * EventTaxonomySummary
 */
export const EventTaxonomySummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type EventTaxonomySummary = z.output<typeof EventTaxonomySummarySchema>

/**
 * EventSearchResult
 */
export const EventSearchResultSchema = z.strictObject({
  address: z.string().nullable(),
  age_groups: z.array(EventTaxonomySummarySchema),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  distance_miles: z.number().nullable(),
  event_date: z.string(),
  event_end: z.string().nullable(),
  event_start: z.string().nullable(),
  event_time: z.string().nullable(),
  event_type: EventTaxonomySummarySchema.nullable(),
  gender: EventGenderSchema.nullable(),
  id: z.int(),
  is_featured: z.boolean(),
  latitude: z.number().nullable(),
  logo: z.string().nullable(),
  longitude: z.number().nullable(),
  name: z.string(),
  organization: EventOrganizationSummarySchema.nullable(),
  slug: z.string(),
  special_requirements: z.string().nullable(),
  sport_type: EventTaxonomySummarySchema.nullable(),
  state: z.string().nullable(),
  status: EventStatusSchema,
  teams: z.int().nullable(),
  updated_at: z.string().nullable(),
  zip: z.string().nullable()
})

export type EventSearchResult = z.output<typeof EventSearchResultSchema>

/**
 * EventTypeSummary
 */
export const EventTypeSummarySchema = z.strictObject({
  code: z.string(),
  description: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type EventTypeSummary = z.output<typeof EventTypeSummarySchema>

/**
 * ExternalAccountResource
 */
export const ExternalAccountResourceSchema = z.object({
  account_holder_name: z.string().nullable(),
  account_holder_type: z.string().nullable(),
  bank_name: z.string().nullable(),
  country: z.string().nullable(),
  currency: z.string().nullable(),
  failure_code: z.string().nullable(),
  fingerprint: z.string().nullable(),
  id: z.string().nullable(),
  is_default: z.boolean(),
  last4: z.string().nullable(),
  object: z.string().nullable(),
  status: z.string().nullable()
})

export type ExternalAccountResource = z.output<typeof ExternalAccountResourceSchema>

/**
 * FavoriteStoreEntry
 */
export const FavoriteStoreEntrySchema = z.strictObject({
  address: z.string().nullable(),
  average_rating: z.number(),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  delivery_fee: z.number(),
  id: z.int(),
  is_favorite: z.literal(true),
  is_featured: z.boolean(),
  is_reliability_superstar: z.boolean(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  name: z.string(),
  review_count: z.int(),
  slug: z.string(),
  state: z.string().nullable(),
  zip: z.string().nullable()
})

export type FavoriteStoreEntry = z.output<typeof FavoriteStoreEntrySchema>

/**
 * FavoriteStorePage
 */
export const FavoriteStorePageSchema = z.strictObject({
  current_page: z.int(),
  from: z.int().nullable(),
  items: z.array(FavoriteStoreEntrySchema),
  last_page: z.int(),
  per_page: z.int(),
  to: z.int().nullable(),
  total: z.int()
})

export type FavoriteStorePage = z.output<typeof FavoriteStorePageSchema>

/**
 * FavoriteStoreToggleRequest
 */
export const FavoriteStoreToggleRequestSchema = z.object({
  store_id: z.int().gte(1)
})

export type FavoriteStoreToggleRequest = z.output<typeof FavoriteStoreToggleRequestSchema>

/**
 * FavoriteToggleResult
 */
export const FavoriteToggleResultSchema = z.strictObject({
  is_favorite: z.boolean()
})

export type FavoriteToggleResult = z.output<typeof FavoriteToggleResultSchema>

/**
 * FieldErrorCode
 */
export const FieldErrorCodeSchema = z.enum([
  'FIELD_REQUIRED',
  'FIELD_INVALID_FORMAT',
  'FIELD_INVALID_TYPE',
  'FIELD_TOO_SHORT',
  'FIELD_TOO_LONG',
  'FIELD_OUT_OF_RANGE',
  'FIELD_ALREADY_EXISTS',
  'FIELD_NOT_FOUND',
  'FIELD_MUST_MATCH',
  'FIELD_INVALID_ENUM_VALUE',
  'FIELD_UPLOAD_FAILED',
  'FIELD_INVALID_CREDENTIALS',
  'FIELD_MUST_ACCEPT',
  'FIELD_NOT_ALLOWED',
  'FIELD_TOO_FEW',
  'FIELD_TOO_MANY',
  'FIELD_TOO_SMALL',
  'FIELD_TOO_LARGE',
  'FIELD_FILE_TOO_LARGE',
  'FIELD_INVALID_FILE_TYPE',
  'FIELD_WRONG_LENGTH',
  'FIELD_DATE_TOO_EARLY',
  'FIELD_DATE_TOO_LATE',
  'FIELD_DUPLICATE_VALUE',
  'FIELD_INCORRECT_CURRENT_PASSWORD',
  'FIELD_REQUIRED_WITH',
  'FIELD_REQUIRED_WITHOUT',
  'FIELD_UNAVAILABLE',
  'FIELD_ORDER_NOT_MODIFIABLE',
  'FIELD_MODIFICATION_PENDING',
  'FIELD_NO_CHANGES',
  'FIELD_INVALID_STATUS_TRANSITION',
  'FIELD_BLOCKED_BY_OPEN_ORDERS',
  'FIELD_OVERLAPS',
  'FIELD_INVALID_TOKEN',
  'FIELD_INVALID_CODE',
  'FIELD_CAPTCHA_EXPIRED',
  'FIELD_CAPTCHA_INVALID',
  'FIELD_CAPTCHA_LOW_SCORE',
  'FIELD_PASSWORD_MISSING_LETTER',
  'FIELD_PASSWORD_MISSING_MIXED_CASE',
  'FIELD_PASSWORD_MISSING_NUMBER',
  'FIELD_PASSWORD_MISSING_SYMBOL',
  'FIELD_PASSWORD_COMPROMISED'
])

export type FieldErrorCode = z.output<typeof FieldErrorCodeSchema>

/**
 * ApiProblem
 */
export const ApiProblemSchema = z.object({
  code: ApiErrorCodeSchema,
  detail: z.string(),
  field_issues: z
    .array(
      z.object({
        code: FieldErrorCodeSchema,
        params: z
          .record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.array(z.string())]))
          .optional(),
        source: z.strictObject({
          pointer: z.string()
        })
      })
    )
    .optional(),
  instance: z.string(),
  params: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])).optional(),
  reason: ApiProblemReasonSchema.optional(),
  request_id: z.uuid(),
  retry_after_seconds: z.int().gte(0).optional(),
  retryable: z.boolean().optional(),
  status: z.int(),
  title: z.string(),
  type: z.url()
})

export type ApiProblem = z.output<typeof ApiProblemSchema>

/**
 * ForgotPasswordRequest
 */
export const ForgotPasswordRequestSchema = z.object({
  email: z.email().min(1),
  'g-recaptcha-response': z.string().optional(),
  recaptcha_token: z.string().optional()
})

export type ForgotPasswordRequest = z.output<typeof ForgotPasswordRequestSchema>

/**
 * GeocodingPlaceType
 */
export const GeocodingPlaceTypeSchema = z.enum([
  'address',
  'region',
  'place',
  'neighborhood',
  'poi',
  'postcode'
])

export type GeocodingPlaceType = z.output<typeof GeocodingPlaceTypeSchema>

/**
 * GoogleReviewUserRef
 */
export const GoogleReviewUserRefSchema = z.strictObject({
  email: z.string().nullable(),
  id: z.int().nullable(),
  last_name: z.string().nullable(),
  name: z.string()
})

export type GoogleReviewUserRef = z.output<typeof GoogleReviewUserRefSchema>

/**
 * GoogleReviewEntry
 */
export const GoogleReviewEntrySchema = z.strictObject({
  created_at: z.string().nullable(),
  google_maps_uri: z.string().nullable(),
  helpful_count: z.int(),
  id: z.int().nullable(),
  is_helpful: z.boolean(),
  is_verified: z.boolean(),
  language_code: z.string().nullable(),
  photos: z.array(z.string()),
  rating: z.int(),
  review: z.string().nullable(),
  reviewed_at: z.string().nullable(),
  source: z.string(),
  status: z.string(),
  title: z.string().nullable(),
  user: GoogleReviewUserRefSchema
})

export type GoogleReviewEntry = z.output<typeof GoogleReviewEntrySchema>

/**
 * GuestCartMigration
 */
export const GuestCartMigrationSchema = z.strictObject({
  migrated_count: z.int()
})

export type GuestCartMigration = z.output<typeof GuestCartMigrationSchema>

/**
 * GuestFavoritesSyncResult
 */
export const GuestFavoritesSyncResultSchema = z.strictObject({
  added: z.int(),
  synced_ids: z.array(z.int()),
  total_favorites: z.int()
})

export type GuestFavoritesSyncResult = z.output<typeof GuestFavoritesSyncResultSchema>

/**
 * LeadStatus
 */
export const LeadStatusSchema = z.enum(['pending', 'contacted', 'converted', 'declined'])

export type LeadStatus = z.output<typeof LeadStatusSchema>

/**
 * LeadTimeType
 */
export const LeadTimeTypeSchema = z.enum(['hours', 'same_day', 'day_before', 'multiple_days'])

export type LeadTimeType = z.output<typeof LeadTimeTypeSchema>

/**
 * LegalAgreementOrder
 */
export const LegalAgreementOrderSchema = z.strictObject({
  id: z.int(),
  order_number: z.string()
})

export type LegalAgreementOrder = z.output<typeof LegalAgreementOrderSchema>

/**
 * LegalAgreementPartner
 */
export const LegalAgreementPartnerSchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type LegalAgreementPartner = z.output<typeof LegalAgreementPartnerSchema>

/**
 * LegalAgreementSignatory
 */
export const LegalAgreementSignatorySchema = z.strictObject({
  name: z.string()
})

export type LegalAgreementSignatory = z.output<typeof LegalAgreementSignatorySchema>

/**
 * LegalAgreementType
 */
export const LegalAgreementTypeSchema = z.enum([
  'partner_agreement',
  'beo_agreement',
  'terms_and_conditions',
  'privacy_policy'
])

export type LegalAgreementType = z.output<typeof LegalAgreementTypeSchema>

/**
 * LegalAgreementUser
 */
export const LegalAgreementUserSchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type LegalAgreementUser = z.output<typeof LegalAgreementUserSchema>

/**
 * LegalClause
 */
export const LegalClauseSchema = z.strictObject({
  body: z.string(),
  title: z.string()
})

export type LegalClause = z.output<typeof LegalClauseSchema>

/**
 * BeoAgreementTerms
 */
export const BeoAgreementTermsSchema = z.strictObject({
  clauses: z.array(LegalClauseSchema),
  title: z.string(),
  version: z.string()
})

export type BeoAgreementTerms = z.output<typeof BeoAgreementTermsSchema>

/**
 * LegalTermsType
 *
 * The platform legal texts anyone may read before signing in.
 *
 */
export const LegalTermsTypeSchema = z.enum(['terms_and_conditions', 'privacy_policy'])

export type LegalTermsType = z.output<typeof LegalTermsTypeSchema>

/**
 * LoginChallengeResult
 */
export const LoginChallengeResultSchema = z.strictObject({
  challenge_token: z.string(),
  two_factor: z.boolean()
})

export type LoginChallengeResult = z.output<typeof LoginChallengeResultSchema>

/**
 * LoginRequest
 */
export const LoginRequestSchema = z.object({
  email: z.string().min(1),
  guest_token: z.string().nullish(),
  password: z.string().min(1),
  remember: z.boolean().optional(),
  timezone: z.string().nullish()
})

export type LoginRequest = z.output<typeof LoginRequestSchema>

/**
 * LoginResult
 */
export const LoginResultSchema = z.strictObject({
  token: z.string(),
  two_factor: z.boolean()
})

export type LoginResult = z.output<typeof LoginResultSchema>

/**
 * LoginResultWithoutToken
 */
export const LoginResultWithoutTokenSchema = z.strictObject({
  two_factor: z.boolean()
})

export type LoginResultWithoutToken = z.output<typeof LoginResultWithoutTokenSchema>

/**
 * LogoutOtherSessionsRequest
 */
export const LogoutOtherSessionsRequestSchema = z.object({
  password: z.string().min(1)
})

export type LogoutOtherSessionsRequest = z.output<typeof LogoutOtherSessionsRequestSchema>

/**
 * MarkNotificationAsReadRequest
 */
export const MarkNotificationAsReadRequestSchema = z.object({
  notification_id: z.uuid()
})

export type MarkNotificationAsReadRequest = z.output<typeof MarkNotificationAsReadRequestSchema>

/**
 * MenuAssignmentOptionDto
 */
export const MenuAssignmentOptionDtoSchema = z.strictObject({
  id: z.int(),
  is_assigned: z.boolean(),
  is_current_menu: z.boolean(),
  name: z.string(),
  store_ids: z.array(z.int()),
  type_ids: z.array(z.int()),
  types: z.array(
    z.object({
      id: z.int(),
      name: z.string(),
      slug: z.string()
    })
  )
})

export type MenuAssignmentOptionDto = z.output<typeof MenuAssignmentOptionDtoSchema>

/**
 * MenuAvailability
 */
export const MenuAvailabilitySchema = z.enum(['always', 'scheduled', 'time-based', 'seasonal'])

export type MenuAvailability = z.output<typeof MenuAvailabilitySchema>

/**
 * MenuAvailabilityMode
 */
export const MenuAvailabilityModeSchema = z.enum(['sync', 'custom'])

export type MenuAvailabilityMode = z.output<typeof MenuAvailabilityModeSchema>

/**
 * MenuCatalogCounts
 */
export const MenuCatalogCountsSchema = z.strictObject({
  categories: z.int(),
  items: z.int(),
  menus: z.int(),
  modifiers: z.int()
})

export type MenuCatalogCounts = z.output<typeof MenuCatalogCountsSchema>

/**
 * MenuCategoryOptionDto
 */
export const MenuCategoryOptionDtoSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  label: z.string(),
  menu_ids: z.array(z.int()),
  menus: z.array(
    z.object({
      id: z.int(),
      name: z.string()
    })
  ),
  name: z.string()
})

export type MenuCategoryOptionDto = z.output<typeof MenuCategoryOptionDtoSchema>

/**
 * MenuCategoryStatus
 */
export const MenuCategoryStatusSchema = z.enum(['active', 'inactive'])

export type MenuCategoryStatus = z.output<typeof MenuCategoryStatusSchema>

/**
 * MenuCustomizationGroupOptionDto
 */
export const MenuCustomizationGroupOptionDtoSchema = z.strictObject({
  display_name: z.string(),
  id: z.int(),
  label: z.string(),
  menus: z.array(CustomizationGroupMenuSummarySchema),
  name: z.string()
})

export type MenuCustomizationGroupOptionDto = z.output<typeof MenuCustomizationGroupOptionDtoSchema>

/**
 * MenuCustomizationOptionManagementDto
 */
export const MenuCustomizationOptionManagementDtoSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  is_available: z.boolean(),
  name: z.string(),
  price_adjustment: z.number().nullable(),
  sort_order: z.int()
})

export type MenuCustomizationOptionManagementDto = z.output<
  typeof MenuCustomizationOptionManagementDtoSchema
>

/**
 * MenuFormDefaults
 */
export const MenuFormDefaultsSchema = z.strictObject({
  tag_ids: z.array(z.int()),
  type_ids: z.array(z.int())
})

export type MenuFormDefaults = z.output<typeof MenuFormDefaultsSchema>

/**
 * MenuFormOption
 */
export const MenuFormOptionSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string(),
  value: z.string()
})

export type MenuFormOption = z.output<typeof MenuFormOptionSchema>

/**
 * MenuFormOptions
 */
export const MenuFormOptionsSchema = z.strictObject({
  defaults: MenuFormDefaultsSchema,
  tags: z.array(MenuFormOptionSchema),
  types: z.array(MenuFormOptionSchema)
})

export type MenuFormOptions = z.output<typeof MenuFormOptionsSchema>

/**
 * MenuItemAllergenRecord
 */
export const MenuItemAllergenRecordSchema = z.strictObject({
  label: z.string(),
  note: z.string().nullable(),
  trace: z.boolean()
})

export type MenuItemAllergenRecord = z.output<typeof MenuItemAllergenRecordSchema>

/**
 * MenuItemCategoryRef
 */
export const MenuItemCategoryRefSchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type MenuItemCategoryRef = z.output<typeof MenuItemCategoryRefSchema>

/**
 * MenuItemCustomizationGroupAssignmentDto
 */
export const MenuItemCustomizationGroupAssignmentDtoSchema = z.strictObject({
  id: z.int(),
  is_required: z.boolean(),
  max_selections: z.int(),
  min_selections: z.int(),
  name: z.string(),
  options_count: z.int(),
  sort_order: z.int(),
  status: z.string()
})

export type MenuItemCustomizationGroupAssignmentDto = z.output<
  typeof MenuItemCustomizationGroupAssignmentDtoSchema
>

/**
 * MenuItemDietaryInfoRecord
 */
export const MenuItemDietaryInfoRecordSchema = z.strictObject({
  active: z.boolean(),
  label: z.string(),
  limit: z.int().nullable(),
  score: z.number().nullable()
})

export type MenuItemDietaryInfoRecord = z.output<typeof MenuItemDietaryInfoRecordSchema>

/**
 * MenuItemDietaryOptionSummary
 */
export const MenuItemDietaryOptionSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string(),
  type: z.string()
})

export type MenuItemDietaryOptionSummary = z.output<typeof MenuItemDietaryOptionSummarySchema>

/**
 * MenuItemManagementCategoryRefDto
 */
export const MenuItemManagementCategoryRefDtoSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  name: z.string()
})

export type MenuItemManagementCategoryRefDto = z.output<
  typeof MenuItemManagementCategoryRefDtoSchema
>

/**
 * MenuItemMenuContextDto
 */
export const MenuItemMenuContextDtoSchema = z.strictObject({
  menu_ids: z.array(z.int()),
  primary_menu_id: z.int()
})

export type MenuItemMenuContextDto = z.output<typeof MenuItemMenuContextDtoSchema>

/**
 * MenuItemOptionDto
 */
export const MenuItemOptionDtoSchema = z.strictObject({
  description: z.string(),
  id: z.int(),
  image: z.string().nullable(),
  is_featured: z.boolean(),
  name: z.string(),
  price: z.number(),
  status: z.string()
})

export type MenuItemOptionDto = z.output<typeof MenuItemOptionDtoSchema>

/**
 * MenuCategoryItemOptionDto
 */
export const MenuCategoryItemOptionDtoSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  items: z.array(MenuItemOptionDtoSchema),
  name: z.string()
})

export type MenuCategoryItemOptionDto = z.output<typeof MenuCategoryItemOptionDtoSchema>

/**
 * MenuItemPriceType
 */
export const MenuItemPriceTypeSchema = z.enum(['each', 'group_tray', 'per_person'])

export type MenuItemPriceType = z.output<typeof MenuItemPriceTypeSchema>

/**
 * MenuItemStatus
 */
export const MenuItemStatusSchema = z.enum(['draft', 'published'])

export type MenuItemStatus = z.output<typeof MenuItemStatusSchema>

/**
 * MenuItemWeightUnit
 */
export const MenuItemWeightUnitSchema = z.enum(['g', 'kg', 'oz', 'lb'])

export type MenuItemWeightUnit = z.output<typeof MenuItemWeightUnitSchema>

/**
 * MenuItemLevelOptionsDto
 */
export const MenuItemLevelOptionsDtoSchema = z.strictObject({
  categories: z.array(
    z.object({
      id: z.int(),
      name: z.string()
    })
  ),
  customization_groups: z.array(CustomizationGroupOptionSummaryDtoSchema),
  defaults: z.object({
    individual_packaging_available: z.literal(false),
    is_featured: z.literal(false),
    is_package: z.literal(false),
    menu_category_id: z.int().nullable(),
    price_type: z.literal('each'),
    weight_unit: z.literal('lb')
  }),
  dietary_attributes: z.array(DietaryOptionSummaryDtoSchema),
  price_types: z.array(MenuItemPriceTypeSchema),
  weight_units: z.array(MenuItemWeightUnitSchema)
})

export type MenuItemLevelOptionsDto = z.output<typeof MenuItemLevelOptionsDtoSchema>

/**
 * MenuItemOptionsDto
 */
export const MenuItemOptionsDtoSchema = z.strictObject({
  categories: z.array(
    z.object({
      id: z.union([z.int(), z.string()]),
      name: z.string()
    })
  ),
  customization_groups: z.array(CustomizationGroupOptionSummaryDtoSchema),
  defaults: z.object({
    category: z.union([z.int(), z.enum(['all'])]),
    individual_packaging_available: z.literal(false),
    is_featured: z.literal(false),
    is_package: z.literal(false),
    price_type: z.literal('each'),
    weight_unit: z.literal('lb')
  }),
  dietary_attributes: z.array(DietaryOptionSummaryDtoSchema),
  price_types: z.array(MenuItemPriceTypeSchema),
  weight_units: z.array(MenuItemWeightUnitSchema)
})

export type MenuItemOptionsDto = z.output<typeof MenuItemOptionsDtoSchema>

/**
 * MenuItemPartnerCreateOptionsDto
 */
export const MenuItemPartnerCreateOptionsDtoSchema = z.strictObject({
  categories: z.array(
    z.object({
      id: z.union([z.int(), z.string()]),
      name: z.string()
    })
  ),
  customization_groups: z.array(CustomizationGroupOptionSummaryDtoSchema),
  defaults: z.object({
    category: z.union([z.int(), z.enum(['all'])]),
    individual_packaging_available: z.literal(false),
    is_featured: z.literal(false),
    is_package: z.literal(false),
    menu_id: z.int().nullable(),
    price_type: z.literal('each'),
    weight_unit: z.literal('lb')
  }),
  dietary_attributes: z.array(DietaryOptionSummaryDtoSchema),
  menus: z.array(
    z.object({
      id: z.int(),
      name: z.string()
    })
  ),
  price_types: z.array(MenuItemPriceTypeSchema),
  weight_units: z.array(MenuItemWeightUnitSchema)
})

export type MenuItemPartnerCreateOptionsDto = z.output<typeof MenuItemPartnerCreateOptionsDtoSchema>

/**
 * MenuOptionSummary
 */
export const MenuOptionSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type MenuOptionSummary = z.output<typeof MenuOptionSummarySchema>

/**
 * MenuCategoryDetail
 */
export const MenuCategoryDetailSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  items: z.array(MenuOptionSummarySchema),
  menus: z.array(MenuOptionSummarySchema),
  name: z.string(),
  status: z.string()
})

export type MenuCategoryDetail = z.output<typeof MenuCategoryDetailSchema>

/**
 * MenuOptionSummaryDto
 */
export const MenuOptionSummaryDtoSchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type MenuOptionSummaryDto = z.output<typeof MenuOptionSummaryDtoSchema>

/**
 * MenuCategoryManagementDto
 */
export const MenuCategoryManagementDtoSchema = z.strictObject({
  activity_metric: z.string(),
  assigned_items_count: z.int(),
  delivery_items_count: z.int().nullable(),
  description: z.string().nullable(),
  duplicate_name_count: z.int(),
  id: z.int(),
  is_assigned: z.boolean(),
  items: z.array(MenuItemOptionDtoSchema).nullable(),
  menu_ids: z.array(z.int()),
  menus: z.array(MenuOptionSummaryDtoSchema),
  name: z.string(),
  status: z.string(),
  usage_count: z.int().nullable()
})

export type MenuCategoryManagementDto = z.output<typeof MenuCategoryManagementDtoSchema>

/**
 * MenuCustomizationGroupManagementDto
 */
export const MenuCustomizationGroupManagementDtoSchema = z.strictObject({
  allow_multiple_selections: z.boolean(),
  allow_repeated_selection: z.boolean(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  display_name: z.string(),
  duplicate_name_count: z.int(),
  id: z.int(),
  is_required: z.boolean(),
  linked_items: z.array(MenuOptionSummaryDtoSchema),
  max_per_option: z.union([z.int(), z.enum(['Infinity'])]),
  max_selections: z.int(),
  max_total_selections: z.union([z.int(), z.enum(['Infinity'])]),
  menus: z.array(CustomizationGroupMenuSummarySchema),
  min_selections: z.int(),
  name: z.string(),
  note: z.string().nullable(),
  options: z.array(MenuCustomizationOptionManagementDtoSchema).nullable(),
  options_count: z.int(),
  selection_type: z.string(),
  sort_order: z.int(),
  status: CustomizationGroupStatusSchema,
  updated_at: z.string().nullable()
})

export type MenuCustomizationGroupManagementDto = z.output<
  typeof MenuCustomizationGroupManagementDtoSchema
>

/**
 * MenuItemPlacementDto
 */
export const MenuItemPlacementDtoSchema = z.strictObject({
  menu_category: MenuOptionSummaryDtoSchema.nullable(),
  menu_category_id: z.int(),
  menu_id: z.int(),
  sort_order: z.int()
})

export type MenuItemPlacementDto = z.output<typeof MenuItemPlacementDtoSchema>

/**
 * MenuOverviewCategoryItemDto
 */
export const MenuOverviewCategoryItemDtoSchema = z.strictObject({
  description: z.string().nullable(),
  image: z.string().nullable(),
  item_id: z.int(),
  item_name: z.string(),
  order: z.int(),
  price: z.number(),
  status: z.string()
})

export type MenuOverviewCategoryItemDto = z.output<typeof MenuOverviewCategoryItemDtoSchema>

/**
 * MenuOverviewCategoryDto
 */
export const MenuOverviewCategoryDtoSchema = z.strictObject({
  category_id: z.int(),
  category_name: z.string(),
  items: z.array(MenuOverviewCategoryItemDtoSchema),
  order: z.int()
})

export type MenuOverviewCategoryDto = z.output<typeof MenuOverviewCategoryDtoSchema>

/**
 * MenuOverviewDto
 */
export const MenuOverviewDtoSchema = z.strictObject({
  availability_mode: z.string(),
  categories: z.array(MenuOverviewCategoryDtoSchema).nullable(),
  custom_hours: z.array(CustomHoursDtoSchema),
  menu_id: z.int(),
  schedule: z.array(CustomHoursDtoSchema),
  sync_with_store_hours: z.boolean()
})

export type MenuOverviewDto = z.output<typeof MenuOverviewDtoSchema>

/**
 * MenuStatus
 */
export const MenuStatusSchema = z.enum(['active', 'draft', 'published', 'unpublished'])

export type MenuStatus = z.output<typeof MenuStatusSchema>

export const CreateMenuRequestSchema = z.intersection(
  z.unknown(),
  z.object({
    availability: MenuAvailabilitySchema.nullish(),
    availability_mode: MenuAvailabilityModeSchema.nullish(),
    available_from: z.iso.date().nullish(),
    available_until: z.iso.date().nullish(),
    custom_hours: z
      .array(
        z.object({
          day_of_week: DayOfWeekSchema.optional(),
          end_time: z
            .string()
            .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
            .nullish(),
          is_enabled: z.boolean().optional(),
          start_time: z
            .string()
            .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
            .nullish()
        })
      )
      .nullish(),
    description: z.string().max(500).nullish(),
    menu_type_ids: z.array(z.int()).min(1).optional(),
    name: z.string().min(1).max(255),
    partner_id: z.string().optional(),
    schedule: z
      .array(
        z.object({
          day_of_week: DayOfWeekSchema.optional(),
          end_time: z
            .string()
            .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
            .optional(),
          is_enabled: z.boolean().optional(),
          start_time: z
            .string()
            .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
            .optional()
        })
      )
      .nullish(),
    sort_order: z.int().gte(0).nullish(),
    status: MenuStatusSchema.nullish(),
    store_id: z.string().optional(),
    store_ids: z.array(z.int()).optional(),
    sync_with_store_hours: z.boolean().optional(),
    tag_ids: z.array(z.int()).optional(),
    tags: z.array(z.string()).optional(),
    type_ids: z.array(z.int()).min(1).optional(),
    types: z.array(z.string()).min(1).optional()
  })
)

export type CreateMenuRequest = z.output<typeof CreateMenuRequestSchema>

/**
 * MenuStoreRef
 */
export const MenuStoreRefSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type MenuStoreRef = z.output<typeof MenuStoreRefSchema>

/**
 * MenuTagSummary
 */
export const MenuTagSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type MenuTagSummary = z.output<typeof MenuTagSummarySchema>

/**
 * MenuTagSummaryDto
 */
export const MenuTagSummaryDtoSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type MenuTagSummaryDto = z.output<typeof MenuTagSummaryDtoSchema>

/**
 * MenuTypeSummary
 */
export const MenuTypeSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type MenuTypeSummary = z.output<typeof MenuTypeSummarySchema>

/**
 * MenuBasicOverview
 */
export const MenuBasicOverviewSchema = z.strictObject({
  availability: z.string(),
  availability_mode: z.string(),
  days: z.array(z.string()),
  description: z.string().nullable(),
  end_time: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  partner_id: z.int().nullable(),
  start_time: z.string().nullable(),
  status: z.string(),
  store_ids: z.array(z.int()),
  stores: z.array(MenuStoreRefSchema),
  tag_ids: z.array(z.int()),
  tags: z.array(MenuTagSummarySchema),
  total_categories: z.int(),
  total_customizations: z.int(),
  total_items: z.int(),
  type_ids: z.array(z.int()),
  types: z.array(MenuTypeSummarySchema)
})

export type MenuBasicOverview = z.output<typeof MenuBasicOverviewSchema>

/**
 * MenuTypeSummaryDto
 */
export const MenuTypeSummaryDtoSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type MenuTypeSummaryDto = z.output<typeof MenuTypeSummaryDtoSchema>

/**
 * MerchantAccountStatus
 */
export const MerchantAccountStatusSchema = z.enum([
  'not_started',
  'information_needed',
  'under_review',
  'active',
  'restricted',
  'payouts_paused'
])

export type MerchantAccountStatus = z.output<typeof MerchantAccountStatusSchema>

/**
 * MsaArtifactStatus
 */
export const MsaArtifactStatusSchema = z.enum(['pending', 'ready', 'failed'])

export type MsaArtifactStatus = z.output<typeof MsaArtifactStatusSchema>

/**
 * AcceptedBeoAgreement
 */
export const AcceptedBeoAgreementSchema = z.strictObject({
  accepted_at: z.string(),
  created_at: z.string(),
  document_status: MsaArtifactStatusSchema,
  effective_at: z.string(),
  id: z.string(),
  order: LegalAgreementOrderSchema,
  signatory: LegalAgreementSignatorySchema,
  status: z.literal('accepted'),
  terms: BeoAgreementTermsSchema,
  type: z.literal('beo_agreement')
})

export type AcceptedBeoAgreement = z.output<typeof AcceptedBeoAgreementSchema>

/**
 * NotificationChannel
 */
export const NotificationChannelSchema = z.enum(['email', 'sms', 'in_app'])

export type NotificationChannel = z.output<typeof NotificationChannelSchema>

/**
 * NotificationChannelAssignment
 */
export const NotificationChannelAssignmentSchema = z.strictObject({
  assigned: z.boolean(),
  channel: NotificationChannelSchema,
  enabled: z.boolean()
})

export type NotificationChannelAssignment = z.output<typeof NotificationChannelAssignmentSchema>

/**
 * NotificationChannelDefinition
 */
export const NotificationChannelDefinitionSchema = z.strictObject({
  channel: NotificationChannelSchema,
  driver: z.string(),
  is_active: z.boolean()
})

export type NotificationChannelDefinition = z.output<typeof NotificationChannelDefinitionSchema>

/**
 * NotificationChannelSetting
 */
export const NotificationChannelSettingSchema = z.strictObject({
  channel: NotificationChannelSchema,
  enabled: z.boolean()
})

export type NotificationChannelSetting = z.output<typeof NotificationChannelSettingSchema>

/**
 * NotificationInboxClear
 */
export const NotificationInboxClearSchema = z.strictObject({
  deleted_count: z.int(),
  unread_count: z.int()
})

export type NotificationInboxClear = z.output<typeof NotificationInboxClearSchema>

/**
 * NotificationInboxDto
 */
export const NotificationInboxDtoSchema = z.strictObject({
  action: z
    .object({
      code: z.string()
    })
    .nullable(),
  action_label: z.string().nullable(),
  action_url: z.string(),
  body: z.string().nullable(),
  created_at: z.string().nullable(),
  entity_id: z.int().nullable(),
  entity_type: z.string(),
  expires_at: z.string().nullable(),
  id: z.string(),
  is_read: z.boolean(),
  meta: z.record(z.string(), z.union([z.number(), z.string()]).nullable()),
  params: z
    .record(z.string(), z.union([z.string(), z.number(), z.boolean()]).nullable())
    .nullable(),
  read_at: z.string().nullable(),
  reason: z.string().nullable(),
  schema_version: z.int(),
  severity: z.string(),
  template_code: z.string().nullable(),
  title: z.string().nullable(),
  type: z.string()
})

export type NotificationInboxDto = z.output<typeof NotificationInboxDtoSchema>

/**
 * NotificationInboxMarkAllRead
 */
export const NotificationInboxMarkAllReadSchema = z.strictObject({
  unread_count: z.int(),
  updated_count: z.int()
})

export type NotificationInboxMarkAllRead = z.output<typeof NotificationInboxMarkAllReadSchema>

/**
 * NotificationInboxUnreadCount
 */
export const NotificationInboxUnreadCountSchema = z.strictObject({
  unread_count: z.int()
})

export type NotificationInboxUnreadCount = z.output<typeof NotificationInboxUnreadCountSchema>

/**
 * NotificationPreferencesUpdateRequest
 */
export const NotificationPreferencesUpdateRequestSchema = z.object({
  notification_settings: z.object({
    email: z
      .object({
        enabled: z.boolean().optional(),
        types: z
          .object({
            daily_summary: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            new_order: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            new_store_review: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_declined: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_request_received: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_updates: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payment_completed: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payment_request: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payout_received: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            store_updates: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            weekly_report: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish()
          })
          .optional()
      })
      .optional(),
    email_enabled: z.boolean().optional(),
    email_types: z
      .object({
        daily_summary: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        new_order: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        new_store_review: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_declined: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_request_received: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_updates: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payment_completed: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payment_request: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payout_received: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        store_updates: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        weekly_report: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish()
      })
      .optional(),
    in_app: z
      .object({
        enabled: z.boolean().optional(),
        types: z
          .object({
            daily_summary: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            new_order: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            new_store_review: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_declined: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_request_received: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_updates: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payment_completed: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payment_request: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payout_received: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            store_updates: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            weekly_report: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish()
          })
          .optional()
      })
      .optional(),
    in_app_enabled: z.boolean().optional(),
    in_app_types: z
      .object({
        daily_summary: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        new_order: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        new_store_review: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_declined: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_request_received: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_updates: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payment_completed: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payment_request: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payout_received: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        store_updates: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        weekly_report: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish()
      })
      .optional(),
    quiet_hours_enabled: z.boolean().optional(),
    quiet_hours_end: z
      .string()
      .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
      .optional(),
    quiet_hours_start: z
      .string()
      .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
      .optional(),
    sms: z
      .object({
        enabled: z.boolean().optional(),
        types: z
          .object({
            daily_summary: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            new_order: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            new_store_review: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_declined: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_request_received: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            order_updates: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payment_completed: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payment_request: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            payout_received: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            store_updates: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish(),
            weekly_report: z
              .object({
                enabled: z.boolean().optional()
              })
              .nullish()
          })
          .optional()
      })
      .optional(),
    sms_enabled: z.boolean().optional(),
    sms_types: z
      .object({
        daily_summary: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        new_order: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        new_store_review: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_declined: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_request_received: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        order_updates: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payment_completed: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payment_request: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        payout_received: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        store_updates: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish(),
        weekly_report: z
          .object({
            enabled: z.boolean().optional()
          })
          .nullish()
      })
      .optional()
  })
})

export type NotificationPreferencesUpdateRequest = z.output<
  typeof NotificationPreferencesUpdateRequestSchema
>

/**
 * NotificationQuietHours
 */
export const NotificationQuietHoursSchema = z.strictObject({
  enabled: z.boolean(),
  end: z.string(),
  start: z.string()
})

export type NotificationQuietHours = z.output<typeof NotificationQuietHoursSchema>

/**
 * NotificationType
 */
export const NotificationTypeSchema = z.enum([
  'new_order',
  'order_updates',
  'order_request_received',
  'payment_request',
  'payment_completed',
  'order_declined',
  'payout_received',
  'new_store_review',
  'store_updates',
  'daily_summary',
  'weekly_report'
])

export type NotificationType = z.output<typeof NotificationTypeSchema>

/**
 * NotificationTypeAssignment
 */
export const NotificationTypeAssignmentSchema = z.strictObject({
  channels: z.array(NotificationChannelAssignmentSchema),
  type: NotificationTypeSchema
})

export type NotificationTypeAssignment = z.output<typeof NotificationTypeAssignmentSchema>

/**
 * NotificationCategoryAssignment
 */
export const NotificationCategoryAssignmentSchema = z.strictObject({
  key: z.string(),
  types: z.array(NotificationTypeAssignmentSchema)
})

export type NotificationCategoryAssignment = z.output<typeof NotificationCategoryAssignmentSchema>

/**
 * NotificationPreferenceAssignments
 */
export const NotificationPreferenceAssignmentsSchema = z.strictObject({
  active_channels: z.array(NotificationChannelSettingSchema),
  categories: z.array(NotificationCategoryAssignmentSchema),
  quiet_hours: NotificationQuietHoursSchema
})

export type NotificationPreferenceAssignments = z.output<
  typeof NotificationPreferenceAssignmentsSchema
>

/**
 * NotificationTypeDefinition
 */
export const NotificationTypeDefinitionSchema = z.strictObject({
  disabled_channels: z.array(NotificationChannelSchema),
  required_channels: z.array(NotificationChannelSchema),
  type: NotificationTypeSchema
})

export type NotificationTypeDefinition = z.output<typeof NotificationTypeDefinitionSchema>

/**
 * NotificationCategoryDefinition
 */
export const NotificationCategoryDefinitionSchema = z.strictObject({
  key: z.string(),
  types: z.array(NotificationTypeDefinitionSchema)
})

export type NotificationCategoryDefinition = z.output<typeof NotificationCategoryDefinitionSchema>

/**
 * NotificationPreferenceCatalog
 */
export const NotificationPreferenceCatalogSchema = z.strictObject({
  categories: z.array(NotificationCategoryDefinitionSchema),
  channels: z.array(NotificationChannelDefinitionSchema)
})

export type NotificationPreferenceCatalog = z.output<typeof NotificationPreferenceCatalogSchema>

/**
 * NotificationTypeSetting
 */
export const NotificationTypeSettingSchema = z.strictObject({
  channels: z.array(NotificationChannelSettingSchema),
  type: NotificationTypeSchema
})

export type NotificationTypeSetting = z.output<typeof NotificationTypeSettingSchema>

/**
 * NotificationCategorySetting
 */
export const NotificationCategorySettingSchema = z.strictObject({
  key: z.string(),
  types: z.array(NotificationTypeSettingSchema)
})

export type NotificationCategorySetting = z.output<typeof NotificationCategorySettingSchema>

/**
 * NotificationPreferenceSettings
 */
export const NotificationPreferenceSettingsSchema = z.strictObject({
  active_channels: z.array(NotificationChannelSettingSchema),
  categories: z.array(NotificationCategorySettingSchema),
  quiet_hours: NotificationQuietHoursSchema
})

export type NotificationPreferenceSettings = z.output<typeof NotificationPreferenceSettingsSchema>

/**
 * OrderItemMenuItemSummary
 */
export const OrderItemMenuItemSummarySchema = z.strictObject({
  id: z.int(),
  minimum_guest_count: z.int(),
  name: z.string()
})

export type OrderItemMenuItemSummary = z.output<typeof OrderItemMenuItemSummarySchema>

/**
 * OrderItemMenuItemSummaryResource
 */
export const OrderItemMenuItemSummaryResourceSchema = z.object({
  id: z.int(),
  minimum_guest_count: z.int(),
  name: z.string()
})

export type OrderItemMenuItemSummaryResource = z.output<
  typeof OrderItemMenuItemSummaryResourceSchema
>

/**
 * OrderLedgerMetadata
 */
export const OrderLedgerMetadataSchema = z.strictObject({
  reason: z.string().nullable()
})

export type OrderLedgerMetadata = z.output<typeof OrderLedgerMetadataSchema>

/**
 * OrderListSection
 *
 * The dashboard order-list tabs: scheduled orders still ahead, pending requests, and orders already behind.
 *
 */
export const OrderListSectionSchema = z.enum(['upcoming', 'requests', 'past'])

export type OrderListSection = z.output<typeof OrderListSectionSchema>

/**
 * OrderModificationAction
 */
export const OrderModificationActionSchema = z.enum(['approve', 'reject'])

export type OrderModificationAction = z.output<typeof OrderModificationActionSchema>

/**
 * OrderModificationRequestLineItem
 */
export const OrderModificationRequestLineItemSchema = z.strictObject({
  customizations: z.array(CustomizationDtoSchema),
  item_name: z.string().nullable(),
  menu_item_id: z.int(),
  quantity: z.int(),
  special_instructions: z.string().nullable(),
  total_price: z.number(),
  unit_price: z.number()
})

export type OrderModificationRequestLineItem = z.output<
  typeof OrderModificationRequestLineItemSchema
>

/**
 * OrderModificationRequestLineItemResource
 */
export const OrderModificationRequestLineItemResourceSchema = z.object({
  customizations: z.array(CustomizationResourceSchema),
  item_name: z.string().nullable(),
  menu_item_id: z.int(),
  quantity: z.int(),
  special_instructions: z.string().nullable(),
  total_price: z.number(),
  unit_price: z.number()
})

export type OrderModificationRequestLineItemResource = z.output<
  typeof OrderModificationRequestLineItemResourceSchema
>

/**
 * OrderModificationRequestStatus
 */
export const OrderModificationRequestStatusSchema = z.enum([
  'pending_partner',
  'applied',
  'rejected',
  'cancelled'
])

export type OrderModificationRequestStatus = z.output<typeof OrderModificationRequestStatusSchema>

/**
 * OrderPartySummary
 */
export const OrderPartySummarySchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type OrderPartySummary = z.output<typeof OrderPartySummarySchema>

/**
 * OrderLedgerEntryDTO
 */
export const OrderLedgerEntryDtoSchema = z.strictObject({
  action: z.string(),
  action_type: z.string(),
  created_at: z.iso.datetime({ offset: true }).nullable(),
  description: z.string().nullable(),
  field_name: z.string(),
  id: z.int(),
  metadata: OrderLedgerMetadataSchema.nullable(),
  new_value: z.string().nullable(),
  old_value: z.string().nullable(),
  user: OrderPartySummarySchema.nullable()
})

export type OrderLedgerEntryDto = z.output<typeof OrderLedgerEntryDtoSchema>

/**
 * OrderPartySummaryResource
 */
export const OrderPartySummaryResourceSchema = z.object({
  id: z.int(),
  name: z.string()
})

export type OrderPartySummaryResource = z.output<typeof OrderPartySummaryResourceSchema>

/**
 * OrderLedgerResource
 */
export const OrderLedgerResourceSchema = z.object({
  action: z.string(),
  action_type: z.string(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  field_name: z.string(),
  id: z.int(),
  metadata: OrderLedgerMetadataSchema.nullable(),
  new_value: z.string().nullable(),
  old_value: z.string().nullable(),
  user: OrderPartySummaryResourceSchema.nullable()
})

export type OrderLedgerResource = z.output<typeof OrderLedgerResourceSchema>

/**
 * OrderPaymentMethodStatus
 *
 * Whether an order has a payment method attached, for `payment_method.status` on the wire.
 *
 */
export const OrderPaymentMethodStatusSchema = z.enum(['not_attached', 'attached'])

export type OrderPaymentMethodStatus = z.output<typeof OrderPaymentMethodStatusSchema>

/**
 * NotAttachedPaymentMethodSummary
 */
export const NotAttachedPaymentMethodSummarySchema = z.strictObject({
  status: OrderPaymentMethodStatusSchema
})

export type NotAttachedPaymentMethodSummary = z.output<typeof NotAttachedPaymentMethodSummarySchema>

/**
 * OrderRequesterSummary
 */
export const OrderRequesterSummarySchema = z.strictObject({
  booked_by: z.string().nullable(),
  id: z.int(),
  is_organizer: z.boolean(),
  name: z.string()
})

export type OrderRequesterSummary = z.output<typeof OrderRequesterSummarySchema>

/**
 * OrderRequesterSummaryResource
 */
export const OrderRequesterSummaryResourceSchema = z.object({
  booked_by: z.string().nullable(),
  id: z.int(),
  is_organizer: z.boolean(),
  name: z.string()
})

export type OrderRequesterSummaryResource = z.output<typeof OrderRequesterSummaryResourceSchema>

/**
 * OrderSortField
 */
export const OrderSortFieldSchema = z.enum(['created_at', 'requested_date', 'requested_time'])

export type OrderSortField = z.output<typeof OrderSortFieldSchema>

/**
 * OrderStatus
 */
export const OrderStatusSchema = z.enum([
  'Accepted',
  'Cancelled',
  'Declined',
  'Completed',
  'Confirmed',
  'Delivered',
  'Payment Failed',
  'in_progress',
  'Pending',
  'Preparing',
  'Ready'
])

export type OrderStatus = z.output<typeof OrderStatusSchema>

/**
 * OrderType
 */
export const OrderTypeSchema = z.enum(['delivery', 'pickup', 'dine_in'])

export type OrderType = z.output<typeof OrderTypeSchema>

/**
 * CheckoutRequest
 */
export const CheckoutRequestSchema = z.intersection(
  z.unknown(),
  z.object({
    delivery_address: z.string().min(1).max(500),
    delivery_business_name: z.string().max(255).nullish(),
    delivery_contact_person: z.string().max(255).nullish(),
    delivery_contact_phone: z
      .string()
      .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
      .nullish(),
    delivery_contact_type: DeliveryContactTypeSchema.nullish(),
    delivery_phone: z
      .string()
      .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
      .nullish(),
    delivery_suite: z.string().max(100).nullish(),
    guest_count: z.int().gte(1).optional().default(1),
    guest_token: z.string().nullish(),
    order_type: OrderTypeSchema,
    requested_date: z.iso.date(),
    requested_time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
    setup_for_me: z.boolean().optional(),
    special_instructions: z.string().max(1000).nullish(),
    store_id: z.int().gte(1),
    tip: z.number().gte(0).lte(1000).nullish()
  })
)

export type CheckoutRequest = z.output<typeof CheckoutRequestSchema>

/**
 * Lead
 */
export const LeadSchema = z.strictObject({
  created_at: z.string(),
  email: z.string(),
  end_time: z.string(),
  event_date: z.string(),
  event_id: z.int().nullable(),
  first_name: z.string(),
  id: z.int(),
  last_name: z.string(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  party_size: z.int(),
  start_time: z.string(),
  status: LeadStatusSchema,
  store_id: z.int().nullable()
})

export type Lead = z.output<typeof LeadSchema>

/**
 * LeadStoreRequest
 */
export const LeadStoreRequestSchema = z.object({
  comments: z.string().max(5000).nullish(),
  consent: z.boolean().optional(),
  delivery_location: z.string().max(500).nullish(),
  email: z.email().max(255),
  end_time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  event_date: z.string(),
  event_end: z.string().nullish(),
  event_slug: z.string().max(255).nullish(),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  hubspotutk: z.string().optional(),
  last_name: z.string().min(1).max(255),
  order_type: OrderTypeSchema,
  organization: z.string().max(255).nullish(),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  party_size: z.int().gte(1),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/),
  recaptcha_token: z.string().optional(),
  start_time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  store_slug: z.string().max(255).nullish()
})

export type LeadStoreRequest = z.output<typeof LeadStoreRequestSchema>

/**
 * OrderModificationOrderSnapshot
 */
export const OrderModificationOrderSnapshotSchema = z.strictObject({
  delivery_address: z.string().nullable(),
  delivery_business_name: z.string().nullable(),
  delivery_contact_person: z.string().nullable(),
  delivery_contact_phone: z.string().nullable(),
  delivery_contact_type: z.string().nullable(),
  delivery_phone: z.string().nullable(),
  delivery_suite: z.string().nullable(),
  guest_count: z.union([z.string(), z.int()]).nullable(),
  order_type: OrderTypeSchema,
  payment_method_id: z.union([z.string(), z.int()]).nullable(),
  requested_date: z.string(),
  requested_time: z.string(),
  setup_for_me: z.boolean(),
  special_instructions: z.string().nullable(),
  tip: z.number()
})

export type OrderModificationOrderSnapshot = z.output<typeof OrderModificationOrderSnapshotSchema>

/**
 * OrderPricingPreviewRequest
 */
export const OrderPricingPreviewRequestSchema = z.object({
  delivery_address: z.string().max(2000).nullish(),
  items: z
    .array(
      z.object({
        customizations: z
          .array(
            z.object({
              group_id: z.int(),
              option_id: z.int()
            })
          )
          .nullish(),
        menu_id: z.int().nullish(),
        menu_item_id: z.int().gte(1),
        quantity: z.int().gte(1),
        special_instructions: z.string().max(500).nullish()
      })
    )
    .min(1),
  order_type: OrderTypeSchema,
  tip: z.number().gte(0).nullish()
})

export type OrderPricingPreviewRequest = z.output<typeof OrderPricingPreviewRequestSchema>

/**
 * OrganizerAccountSummary
 */
export const OrganizerAccountSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type OrganizerAccountSummary = z.output<typeof OrganizerAccountSummarySchema>

/**
 * OrganizerInvitationLookupOrganizerAccount
 */
export const OrganizerInvitationLookupOrganizerAccountSchema = z.strictObject({
  id: z.int().nullable(),
  name: z.string().nullable()
})

export type OrganizerInvitationLookupOrganizerAccount = z.output<
  typeof OrganizerInvitationLookupOrganizerAccountSchema
>

/**
 * OrganizerRegistrationRequest
 */
export const OrganizerRegistrationRequestSchema = z.object({
  email: z.email().min(1).max(255),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  guest_token: z.string().nullish(),
  hubspotutk: z.string().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  organization_address: z.string().max(255).nullish(),
  organization_address2: z.string().max(255).nullish(),
  organization_city: z.string().max(255).nullish(),
  organization_country: z.string().max(255).nullish(),
  organization_name: z.string().min(1).max(255),
  organization_state: z.string().max(255).nullish(),
  organization_zip_code: z.string().max(20).nullish(),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  recaptcha_token: z.string().optional(),
  remember: z.boolean().optional(),
  sms_marketing_consent: z.boolean().optional(),
  sms_transactional_consent: z.union([
    z.literal('yes'),
    z.literal('on'),
    z.literal('1'),
    z.literal(1),
    z.literal('true'),
    z.literal(true)
  ]),
  timezone: z.string().nullish()
})

export type OrganizerRegistrationRequest = z.output<typeof OrganizerRegistrationRequestSchema>

/**
 * OrganizerUserInvitationPayload
 */
export const OrganizerUserInvitationPayloadSchema = z.object({
  email: z.email(),
  has_custom_permissions: z.boolean().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  name: z.string().min(2).max(255).nullish(),
  permissions: z
    .array(
      z.enum([
        'view organizer users',
        'create organizer users',
        'edit organizer users',
        'delete organizer users',
        'view organizer orders',
        'manage organizer orders'
      ])
    )
    .nullish(),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  timezone: z.string().nullish()
})

export type OrganizerUserInvitationPayload = z.output<typeof OrganizerUserInvitationPayloadSchema>

/**
 * PaginationMetaDTO
 */
export const PaginationMetaDtoSchema = z.strictObject({
  current_page: z.int(),
  last_page: z.int(),
  per_page: z.int(),
  total: z.int()
})

export type PaginationMetaDto = z.output<typeof PaginationMetaDtoSchema>

/**
 * EventSearchPage
 */
export const EventSearchPageSchema = z.strictObject({
  items: z.array(EventSearchResultSchema),
  pagination: PaginationMetaDtoSchema,
  query: z.record(z.string(), z.unknown())
})

export type EventSearchPage = z.output<typeof EventSearchPageSchema>

/**
 * MenuAssignmentOptionPage
 */
export const MenuAssignmentOptionPageSchema = z.strictObject({
  items: z.array(MenuAssignmentOptionDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuAssignmentOptionPage = z.output<typeof MenuAssignmentOptionPageSchema>

/**
 * MenuCategoryItemOptionPage
 */
export const MenuCategoryItemOptionPageSchema = z.strictObject({
  items: z.array(MenuCategoryItemOptionDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuCategoryItemOptionPage = z.output<typeof MenuCategoryItemOptionPageSchema>

/**
 * MenuCategoryManagementPage
 */
export const MenuCategoryManagementPageSchema = z.strictObject({
  items: z.array(MenuCategoryManagementDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuCategoryManagementPage = z.output<typeof MenuCategoryManagementPageSchema>

/**
 * MenuCategoryOptionPage
 */
export const MenuCategoryOptionPageSchema = z.strictObject({
  items: z.array(MenuCategoryOptionDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuCategoryOptionPage = z.output<typeof MenuCategoryOptionPageSchema>

/**
 * MenuCustomizationGroupManagementPage
 */
export const MenuCustomizationGroupManagementPageSchema = z.strictObject({
  items: z.array(MenuCustomizationGroupManagementDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuCustomizationGroupManagementPage = z.output<
  typeof MenuCustomizationGroupManagementPageSchema
>

/**
 * MenuCustomizationGroupOptionPage
 */
export const MenuCustomizationGroupOptionPageSchema = z.strictObject({
  items: z.array(MenuCustomizationGroupOptionDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuCustomizationGroupOptionPage = z.output<
  typeof MenuCustomizationGroupOptionPageSchema
>

/**
 * PartnerAgreementClauseGroup
 */
export const PartnerAgreementClauseGroupSchema = z.strictObject({
  clauses: z.array(LegalClauseSchema),
  heading: z.string()
})

export type PartnerAgreementClauseGroup = z.output<typeof PartnerAgreementClauseGroupSchema>

/**
 * PartnerAgreementExhibitDefinition
 */
export const PartnerAgreementExhibitDefinitionSchema = z.strictObject({
  definition: z.string(),
  term: z.string()
})

export type PartnerAgreementExhibitDefinition = z.output<
  typeof PartnerAgreementExhibitDefinitionSchema
>

/**
 * PartnerAgreementExhibitItem
 */
export const PartnerAgreementExhibitItemSchema = z.strictObject({
  definitions: z.array(PartnerAgreementExhibitDefinitionSchema),
  description: z.string(),
  fee_lines: z.array(z.string()),
  title: z.string()
})

export type PartnerAgreementExhibitItem = z.output<typeof PartnerAgreementExhibitItemSchema>

/**
 * PartnerAgreementExhibit
 */
export const PartnerAgreementExhibitSchema = z.strictObject({
  column_headers: z.array(z.string()),
  intro: z.string(),
  items: z.array(PartnerAgreementExhibitItemSchema),
  title: z.string()
})

export type PartnerAgreementExhibit = z.output<typeof PartnerAgreementExhibitSchema>

/**
 * PartnerAgreementTerms
 */
export const PartnerAgreementTermsSchema = z.strictObject({
  exhibit: PartnerAgreementExhibitSchema,
  groups: z.array(PartnerAgreementClauseGroupSchema),
  preamble: z.string(),
  signature_disclaimer: z.string(),
  subtitle: z.string(),
  title: z.string(),
  version: z.string()
})

export type PartnerAgreementTerms = z.output<typeof PartnerAgreementTermsSchema>

/**
 * AcceptedPartnerAgreement
 */
export const AcceptedPartnerAgreementSchema = z.strictObject({
  accepted_at: z.string(),
  created_at: z.string(),
  current_terms_version: z.string(),
  document_status: MsaArtifactStatusSchema,
  effective_at: z.string(),
  id: z.string(),
  partner: LegalAgreementPartnerSchema,
  signatory: LegalAgreementSignatorySchema,
  status: z.literal('accepted'),
  terms: PartnerAgreementTermsSchema,
  type: z.literal('partner_agreement')
})

export type AcceptedPartnerAgreement = z.output<typeof AcceptedPartnerAgreementSchema>

/**
 * PartnerBusinessType
 */
export const PartnerBusinessTypeSchema = z.enum([
  'restaurant',
  'caterer',
  'bakery',
  'cafe_coffee_shop',
  'food_truck_mobile_vendor',
  'ghost_kitchen_virtual_kitchen',
  'grocery_specialty_food',
  'grocery',
  'restaurant_group',
  'franchisee',
  'franchisor_hq',
  'corporate_enterprise_food_provider',
  'enterprise',
  'small_business',
  'other'
])

export type PartnerBusinessType = z.output<typeof PartnerBusinessTypeSchema>

/**
 * BrandDetailPartner
 */
export const BrandDetailPartnerSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  partner_type: PartnerBusinessTypeSchema
})

export type BrandDetailPartner = z.output<typeof BrandDetailPartnerSchema>

/**
 * BrandDetail
 */
export const BrandDetailSchema = z.strictObject({
  cover: z.string().nullable(),
  created_at: z.string().nullable(),
  description: z.string().nullable(),
  dropped_images: z.array(BrandImageSlotSchema),
  id: z.int(),
  is_featured: z.boolean(),
  logo: z.string().nullable(),
  name: z.string(),
  partner: BrandDetailPartnerSchema,
  slug: z.string(),
  status: z.string(),
  stores: z.array(BrandDetailStoreSchema),
  stores_count: z.int(),
  updated_at: z.string().nullable(),
  website: z.string().nullable()
})

export type BrandDetail = z.output<typeof BrandDetailSchema>

/**
 * BrandDetailPage
 */
export const BrandDetailPageSchema = z.strictObject({
  brands: z.array(BrandDetailSchema),
  pagination: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  })
})

export type BrandDetailPage = z.output<typeof BrandDetailPageSchema>

/**
 * CreateBrandRequest
 */
export const CreateBrandRequestSchema = z.object({
  business_type: PartnerBusinessTypeSchema.optional(),
  company_name: z.string().max(255).optional(),
  cover: z.string().nullish(),
  description: z.string().max(5000).nullish(),
  hubspotutk: z.string().optional(),
  legal_entity_type: z
    .enum([
      'sole_proprietorship',
      'single_member_llc',
      'multi_member_llc',
      'partnership',
      'private_corporation',
      'public_corporation',
      'nonprofit'
    ])
    .optional(),
  logo: z.string().nullish(),
  name: z.string().min(1).max(255),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  partner_id: z.int().gte(1).optional(),
  slug: z.string().max(255).nullish(),
  status: z.enum(['pending', 'active', 'inactive']).nullish(),
  website: z.url().max(500).nullish()
})

export type CreateBrandRequest = z.output<typeof CreateBrandRequestSchema>

/**
 * PartnerInvitationLookupPartner
 */
export const PartnerInvitationLookupPartnerSchema = z.strictObject({
  id: z.int().nullable(),
  name: z.string().nullable()
})

export type PartnerInvitationLookupPartner = z.output<typeof PartnerInvitationLookupPartnerSchema>

/**
 * PartnerLegalEntityType
 *
 * A partner's legal structure; `UNDECLARED` marks a partner whose structure the application does not know.
 *
 */
export const PartnerLegalEntityTypeSchema = z.enum([
  'sole_proprietorship',
  'single_member_llc',
  'multi_member_llc',
  'partnership',
  'private_corporation',
  'public_corporation',
  'nonprofit',
  'undeclared'
])

export type PartnerLegalEntityType = z.output<typeof PartnerLegalEntityTypeSchema>

/**
 * PartnerLocationRange
 */
export const PartnerLocationRangeSchema = z.enum(['1', '2-5', '6+'])

export type PartnerLocationRange = z.output<typeof PartnerLocationRangeSchema>

/**
 * PartnerOnboardingState
 */
export const PartnerOnboardingStateSchema = z.enum(['none', 'brand_setup_required', 'active'])

export type PartnerOnboardingState = z.output<typeof PartnerOnboardingStateSchema>

/**
 * PartnerProposedPricing
 */
export const PartnerProposedPricingSchema = z.strictObject({
  customer_application_fee: z.number(),
  customer_processing_fee: z.number(),
  delivery_fee: z.number(),
  delivery_fee_deduction: z.number(),
  net_payout: z.number(),
  partner_total: z.number(),
  subtotal: z.number(),
  tax: z.number(),
  tax_deduction: z.number(),
  tip: z.number(),
  total: z.number()
})

export type PartnerProposedPricing = z.output<typeof PartnerProposedPricingSchema>

/**
 * OrderModificationRequestData
 */
export const OrderModificationRequestDataSchema = z.strictObject({
  applied_at: z.iso.datetime({ offset: true }).nullable(),
  created_at: z.iso.datetime({ offset: true }).nullable(),
  details_changed: z.boolean(),
  id: z.int(),
  items_changed: z.boolean(),
  order_id: z.int(),
  order_number: z.string().nullable(),
  previous_items: z.array(OrderModificationRequestLineItemSchema),
  previous_order: OrderModificationOrderSnapshotSchema,
  previous_total: z.string(),
  proposed_items: z.array(OrderModificationRequestLineItemSchema),
  proposed_order: OrderModificationOrderSnapshotSchema,
  proposed_pricing: z
    .union([CustomerProposedPricingSchema, PartnerProposedPricingSchema])
    .nullable(),
  proposed_total: z.string(),
  rejection_reason: z.string().nullable(),
  reviewed_at: z.iso.datetime({ offset: true }).nullable(),
  reviewed_by: z.int().nullable(),
  reviewer: OrderPartySummarySchema.nullable(),
  status: OrderModificationRequestStatusSchema,
  store: OrderPartySummarySchema.nullable(),
  store_id: z.int(),
  user: OrderRequesterSummarySchema.nullable(),
  user_id: z.int()
})

export type OrderModificationRequestData = z.output<typeof OrderModificationRequestDataSchema>

/**
 * OrderModificationRequestResource
 */
export const OrderModificationRequestResourceSchema = z.object({
  applied_at: z.string().nullable(),
  created_at: z.string().nullable(),
  details_changed: z.boolean(),
  id: z.int(),
  items_changed: z.boolean(),
  order_id: z.int(),
  order_number: z.string().optional(),
  previous_items: z.array(OrderModificationRequestLineItemResourceSchema),
  previous_order: OrderModificationOrderSnapshotSchema,
  previous_total: z.string(),
  proposed_items: z.array(OrderModificationRequestLineItemResourceSchema),
  proposed_order: OrderModificationOrderSnapshotSchema,
  proposed_pricing: z
    .union([CustomerProposedPricingSchema, PartnerProposedPricingSchema])
    .nullable(),
  proposed_total: z.string(),
  rejection_reason: z.string().nullable(),
  reviewed_at: z.string().nullable(),
  reviewed_by: z.int().nullable(),
  reviewer: OrderPartySummaryResourceSchema.nullable(),
  status: OrderModificationRequestStatusSchema,
  store: OrderPartySummaryResourceSchema.nullish(),
  store_id: z.int(),
  user: OrderRequesterSummaryResourceSchema.nullish(),
  user_id: z.int()
})

export type OrderModificationRequestResource = z.output<
  typeof OrderModificationRequestResourceSchema
>

/**
 * PartnerRegistrationRequest
 */
export const PartnerRegistrationRequestSchema = z.object({
  email: z.email().min(1).max(255),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  guest_token: z.string().nullish(),
  hubspotutk: z.string().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/),
  recaptcha_token: z.string().optional(),
  remember: z.boolean().optional(),
  sms_marketing_consent: z.boolean().optional(),
  sms_transactional_consent: z.union([
    z.literal('yes'),
    z.literal('on'),
    z.literal('1'),
    z.literal(1),
    z.literal('true'),
    z.literal(true)
  ])
})

export type PartnerRegistrationRequest = z.output<typeof PartnerRegistrationRequestSchema>

/**
 * PartnerReportChangeStat
 */
export const PartnerReportChangeStatSchema = z.strictObject({
  change_percentage: z.number().nullable(),
  count: z.int()
})

export type PartnerReportChangeStat = z.output<typeof PartnerReportChangeStatSchema>

/**
 * PartnerReportOrderTypeBreakdown
 */
export const PartnerReportOrderTypeBreakdownSchema = z.strictObject({
  delivery: z.int(),
  group_dining: z.int(),
  pickup: z.int()
})

export type PartnerReportOrderTypeBreakdown = z.output<typeof PartnerReportOrderTypeBreakdownSchema>

/**
 * PartnerReportOrdersStats
 */
export const PartnerReportOrdersStatsSchema = z.strictObject({
  cancelled: PartnerReportChangeStatSchema,
  completed: PartnerReportChangeStatSchema,
  declined: PartnerReportChangeStatSchema,
  period: z.string(),
  total: PartnerReportChangeStatSchema
})

export type PartnerReportOrdersStats = z.output<typeof PartnerReportOrdersStatsSchema>

/**
 * PartnerReportOrdersSummary
 */
export const PartnerReportOrdersSummarySchema = z.strictObject({
  average_order_value: z.number(),
  by_status: z.record(z.string(), z.int()),
  by_type: PartnerReportOrderTypeBreakdownSchema,
  cancelled: z.int(),
  completed: z.int(),
  declined: z.int(),
  pending: z.int(),
  total: z.int(),
  total_including_pending: z.int(),
  total_net_payout: z.number(),
  total_revenue: z.number(),
  upcoming: z.int()
})

export type PartnerReportOrdersSummary = z.output<typeof PartnerReportOrdersSummarySchema>

/**
 * PartnerReportPayoutsSummary
 */
export const PartnerReportPayoutsSummarySchema = z.strictObject({
  completed: z.int(),
  failed: z.int(),
  total: z.int(),
  total_amount: z.number()
})

export type PartnerReportPayoutsSummary = z.output<typeof PartnerReportPayoutsSummarySchema>

/**
 * PartnerReportTopStoreEntry
 */
export const PartnerReportTopStoreEntrySchema = z.strictObject({
  name: z.string(),
  store_id: z.int(),
  total_net_payout: z.number(),
  total_orders: z.int(),
  total_revenue: z.number()
})

export type PartnerReportTopStoreEntry = z.output<typeof PartnerReportTopStoreEntrySchema>

/**
 * PartnerReportShape
 */
export const PartnerReportShapeSchema = z.strictObject({
  orders: PartnerReportOrdersSummarySchema,
  orders_stats: PartnerReportOrdersStatsSchema,
  payouts: PartnerReportPayoutsSummarySchema,
  period: z.string(),
  top_stores: z.array(PartnerReportTopStoreEntrySchema)
})

export type PartnerReportShape = z.output<typeof PartnerReportShapeSchema>

/**
 * PartnerStatus
 */
export const PartnerStatusSchema = z.enum(['active', 'inactive', 'suspended'])

export type PartnerStatus = z.output<typeof PartnerStatusSchema>

/**
 * PayableType
 */
export const PayableTypeSchema = z.enum(['stores', 'partners', 'brands'])

export type PayableType = z.output<typeof PayableTypeSchema>

/**
 * PayableConnectedAccountRequest
 */
export const PayableConnectedAccountRequestSchema = z.object({
  payable_id: z.int().gte(1),
  payable_type: PayableTypeSchema
})

export type PayableConnectedAccountRequest = z.output<typeof PayableConnectedAccountRequestSchema>

/**
 * PayableTypeCode
 */
export const PayableTypeCodeSchema = z.enum(['STORES', 'PARTNERS', 'BRANDS'])

export type PayableTypeCode = z.output<typeof PayableTypeCodeSchema>

/**
 * PaymentDetails
 */
export const PaymentDetailsSchema = z.strictObject({
  decline_code: z.string().nullable(),
  error_code: z.string().nullable(),
  error_type: z.string().nullable(),
  http_status: z.int().nullable(),
  message: z.string().nullable(),
  param: z.string().nullable(),
  payment_intent_id: z.string().nullable(),
  payment_method: z.string().nullable(),
  payment_method_types: z.array(z.string()).nullable(),
  refund_id: z.string().nullable(),
  request_id: z.string().nullable(),
  requires_action: z.boolean()
})

export type PaymentDetails = z.output<typeof PaymentDetailsSchema>

/**
 * PaymentFailureCode
 */
export const PaymentFailureCodeSchema = z.enum([
  'CARD_DECLINED',
  'INSUFFICIENT_FUNDS',
  'EXPIRED_CARD',
  'INCORRECT_CVC',
  'PROCESSING_ERROR',
  'AUTHENTICATION_REQUIRED',
  'EXTERNAL_ACCOUNT_VERIFICATION_FAILED',
  'PROVIDER_DECLINE_OTHER'
])

export type PaymentFailureCode = z.output<typeof PaymentFailureCodeSchema>

/**
 * PaymentMethodCardView
 */
export const PaymentMethodCardViewSchema = z.strictObject({
  brand: z.string(),
  country: z.string().nullable(),
  created_at: z.string().nullable(),
  exp_month: z.int(),
  exp_year: z.int(),
  id: z.int(),
  is_default: z.boolean(),
  last4: z.string(),
  type: AcceptedPaymentMethodTypeSchema,
  updated_at: z.string().nullable()
})

export type PaymentMethodCardView = z.output<typeof PaymentMethodCardViewSchema>

/**
 * PaymentMethodCode
 */
export const PaymentMethodCodeSchema = z.enum([
  'CREDIT_CARD',
  'DEBIT_CARD',
  'PAYPAL',
  'APPLE_PAY',
  'GOOGLE_PAY',
  'CASH',
  'LINK'
])

export type PaymentMethodCode = z.output<typeof PaymentMethodCodeSchema>

/**
 * PaymentMethodLinkView
 */
export const PaymentMethodLinkViewSchema = z.strictObject({
  created_at: z.string().nullable(),
  id: z.int(),
  is_default: z.boolean(),
  type: AcceptedPaymentMethodTypeSchema,
  updated_at: z.string().nullable()
})

export type PaymentMethodLinkView = z.output<typeof PaymentMethodLinkViewSchema>

/**
 * PaymentMethodType
 */
export const PaymentMethodTypeSchema = z.enum([
  'credit_card',
  'debit_card',
  'paypal',
  'apple_pay',
  'google_pay',
  'cash',
  'link'
])

export type PaymentMethodType = z.output<typeof PaymentMethodTypeSchema>

/**
 * PaymentOrderSummary
 */
export const PaymentOrderSummarySchema = z.strictObject({
  id: z.int(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  status: z.string(),
  total: z.number()
})

export type PaymentOrderSummary = z.output<typeof PaymentOrderSummarySchema>

/**
 * PaymentStatus
 *
 * | |
 * |---|
 * | `requested` <br/>  |
 * | `pending` <br/>  |
 * | `completed` <br/>  |
 * | `failed` <br/>  |
 * | `cancelled` <br/>  |
 * | `refunded` <br/>  |
 * | `refund_reversed` <br/> A refund the provider confirmed succeeded that later failed; payment-row only, never order-level. |
 * | `not_required` <br/>  |
 * | `partially_paid` <br/>  |
 */
export const PaymentStatusSchema = z.enum([
  'requested',
  'pending',
  'completed',
  'failed',
  'cancelled',
  'refunded',
  'refund_reversed',
  'not_required',
  'partially_paid'
])

export type PaymentStatus = z.output<typeof PaymentStatusSchema>

/**
 * PaymentStoreSummary
 */
export const PaymentStoreSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type PaymentStoreSummary = z.output<typeof PaymentStoreSummarySchema>

/**
 * PaymentUserSummary
 */
export const PaymentUserSummarySchema = z.strictObject({
  email: z.string().nullable(),
  id: z.int(),
  name: z.string().nullable()
})

export type PaymentUserSummary = z.output<typeof PaymentUserSummarySchema>

/**
 * PayoutAttemptLogEntry
 */
export const PayoutAttemptLogEntrySchema = z.strictObject({
  attempt: z.int(),
  attempted_at: z.string(),
  error: z.string().nullable(),
  exception_class: z.string().nullable(),
  next_retry_at: z.string().nullable(),
  retryable: z.boolean(),
  success: z.boolean()
})

export type PayoutAttemptLogEntry = z.output<typeof PayoutAttemptLogEntrySchema>

/**
 * PayoutDetailsView
 */
export const PayoutDetailsViewSchema = z.strictObject({
  amount: z.int().nullable(),
  attempts_log: z.array(PayoutAttemptLogEntrySchema),
  currency: z.string().nullable(),
  destination: z.string().nullable(),
  transfer_id: z.string().nullable()
})

export type PayoutDetailsView = z.output<typeof PayoutDetailsViewSchema>

/**
 * PayoutStatus
 */
export const PayoutStatusSchema = z.enum([
  'pending',
  'processing',
  'completed',
  'failed',
  'cancelled'
])

export type PayoutStatus = z.output<typeof PayoutStatusSchema>

/**
 * PayoutStatusCode
 */
export const PayoutStatusCodeSchema = z.enum([
  'PENDING',
  'PROCESSING',
  'COMPLETED',
  'FAILED',
  'CANCELLED'
])

export type PayoutStatusCode = z.output<typeof PayoutStatusCodeSchema>

/**
 * PendingBeoAgreement
 */
export const PendingBeoAgreementSchema = z.strictObject({
  created_at: z.string(),
  id: z.string(),
  order: LegalAgreementOrderSchema,
  status: z.literal('pending'),
  terms: BeoAgreementTermsSchema,
  type: z.literal('beo_agreement')
})

export type PendingBeoAgreement = z.output<typeof PendingBeoAgreementSchema>

/**
 * PendingPartnerAgreement
 */
export const PendingPartnerAgreementSchema = z.strictObject({
  created_at: z.string(),
  id: z.string(),
  partner: LegalAgreementPartnerSchema,
  status: z.literal('pending'),
  terms: PartnerAgreementTermsSchema,
  type: z.literal('partner_agreement')
})

export type PendingPartnerAgreement = z.output<typeof PendingPartnerAgreementSchema>

/**
 * Permission
 */
export const PermissionSchema = z.enum([
  'view users',
  'create users',
  'edit users',
  'delete users',
  'view organizer users',
  'create organizer users',
  'edit organizer users',
  'delete organizer users',
  'view organizer orders',
  'manage organizer orders',
  'view partners',
  'create partners',
  'edit partners',
  'delete partners',
  'view brands',
  'create brands',
  'edit brands',
  'delete brands',
  'view stores',
  'create stores',
  'edit stores',
  'delete stores',
  'view menus',
  'create menus',
  'edit menus',
  'delete menus',
  'assign menus to store',
  'view orders',
  'create orders',
  'edit orders',
  'delete orders',
  'update order status',
  'view payments',
  'create payments',
  'edit payments',
  'delete payments',
  'view payout account',
  'create payout accounts',
  'edit payout accounts',
  'view payouts',
  'create payouts',
  'edit payouts',
  'delete payouts',
  'view reports',
  'export data'
])

export type Permission = z.output<typeof PermissionSchema>

/**
 * DashboardPermissionCatalog
 */
export const DashboardPermissionCatalogSchema = z.strictObject({
  all: z.array(PermissionSchema),
  grouped: z.record(z.string(), z.array(PermissionSchema))
})

export type DashboardPermissionCatalog = z.output<typeof DashboardPermissionCatalogSchema>

/**
 * DashboardPermissionEntry
 */
export const DashboardPermissionEntrySchema = z.strictObject({
  description: z.string(),
  is_parent: z.boolean(),
  label: z.string(),
  name: PermissionSchema
})

export type DashboardPermissionEntry = z.output<typeof DashboardPermissionEntrySchema>

/**
 * DashboardPermissionEntryResource
 */
export const DashboardPermissionEntryResourceSchema = z.object({
  description: z.string(),
  is_parent: z.boolean(),
  label: z.string(),
  name: PermissionSchema
})

export type DashboardPermissionEntryResource = z.output<
  typeof DashboardPermissionEntryResourceSchema
>

/**
 * PartnerUserInvitationPayload
 */
export const PartnerUserInvitationPayloadSchema = z.object({
  email: z.email(),
  has_custom_permissions: z.boolean().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  manage_all_stores: z.boolean().optional(),
  managed_stores: z
    .array(
      z.object({
        id: z.int(),
        name: z.string().min(1).max(255)
      })
    )
    .optional(),
  name: z.string().min(2).max(255).nullish(),
  partner_id: z.int().nullish(),
  permissions: z.array(PermissionSchema).nullish(),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  roles: z.tuple([z.enum(['partner_manager', 'store_manager'])]),
  timezone: z.string().nullish()
})

export type PartnerUserInvitationPayload = z.output<typeof PartnerUserInvitationPayloadSchema>

/**
 * PhoneVerificationCooldown
 */
export const PhoneVerificationCooldownSchema = z.strictObject({
  retry_after_seconds: z.int()
})

export type PhoneVerificationCooldown = z.output<typeof PhoneVerificationCooldownSchema>

/**
 * PhoneVerificationStatus
 */
export const PhoneVerificationStatusSchema = z.strictObject({
  enabled: z.boolean()
})

export type PhoneVerificationStatus = z.output<typeof PhoneVerificationStatusSchema>

/**
 * PhoneVerified
 */
export const PhoneVerifiedSchema = z.strictObject({
  phone_verified_at: z.string()
})

export type PhoneVerified = z.output<typeof PhoneVerifiedSchema>

/**
 * PreferredContactMethod
 */
export const PreferredContactMethodSchema = z.enum(['email', 'phone'])

export type PreferredContactMethod = z.output<typeof PreferredContactMethodSchema>

/**
 * PricingModelCode
 */
export const PricingModelCodeSchema = z.enum(['EACH', 'WEIGHT', 'PERCENTAGE'])

export type PricingModelCode = z.output<typeof PricingModelCodeSchema>

/**
 * CustomizationOptionDto
 */
export const CustomizationOptionDtoSchema = z.strictObject({
  allergens: z.array(z.string()).nullable(),
  allergens_text: z.string(),
  calories: z.int().nullable(),
  description: z.string().nullable(),
  effective_price: z.number(),
  external_id: z.string().nullable(),
  id: z.int(),
  image: z.string().nullable(),
  is_auto_generated: z.boolean(),
  is_available: z.boolean(),
  kilojoules: z.int().nullable(),
  name: z.string(),
  pickup_price_adjustment: z.string().nullable(),
  price_adjustment: z.number(),
  pricing_model: CustomizationPricingModelSchema,
  pricing_model_code: PricingModelCodeSchema,
  serves_count: z.int().nullable(),
  sort_order: z.int(),
  tax_rate: z.string(),
  weight_unit: z.string().nullable()
})

export type CustomizationOptionDto = z.output<typeof CustomizationOptionDtoSchema>

/**
 * CustomizationGroupDto
 */
export const CustomizationGroupDtoSchema = z.strictObject({
  allow_multiple_selections: z.boolean(),
  allow_repeated_selection: z.boolean(),
  description: z.string().nullable(),
  id: z.int(),
  is_required: z.boolean(),
  max_per_option: z.union([z.int(), z.enum(['Infinity'])]),
  max_selections: z.int(),
  max_total_selections: z.union([z.int(), z.enum(['Infinity'])]),
  min_selections: z.int(),
  name: z.string(),
  options: z.array(CustomizationOptionDtoSchema),
  options_count: z.int(),
  sort_order: z.int()
})

export type CustomizationGroupDto = z.output<typeof CustomizationGroupDtoSchema>

/**
 * ProcessOrderPaymentRequest
 */
export const ProcessOrderPaymentRequestSchema = z.object({
  payment_method_id: z.int().gte(1)
})

export type ProcessOrderPaymentRequest = z.output<typeof ProcessOrderPaymentRequestSchema>

/**
 * ProfileUpdateRequest
 */
export const ProfileUpdateRequestSchema = z.object({
  avatar: z.string().optional(),
  email: z.email().optional(),
  has_custom_permissions: z.string().optional(),
  last_name: z.string().min(1).max(255).optional(),
  managed_stores: z.string().optional(),
  name: z.string().max(255).optional(),
  organizer_account_id: z.string().optional(),
  partner_id: z.string().optional(),
  permissions: z.string().optional(),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  roles: z.string().optional(),
  status: z.string().optional(),
  timezone: z.string().max(255).optional()
})

export type ProfileUpdateRequest = z.output<typeof ProfileUpdateRequestSchema>

/**
 * PublicBrandPage
 */
export const PublicBrandPageSchema = z.strictObject({
  brands: z.array(BrandPublicRecordSchema),
  pagination: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  })
})

export type PublicBrandPage = z.output<typeof PublicBrandPageSchema>

/**
 * ReplaceMenuCustomizationGroupLinkedItemsRequest
 */
export const ReplaceMenuCustomizationGroupLinkedItemsRequestSchema = z.object({
  linked_items: z.array(
    z.object({
      id: z.int(),
      name: z.string().min(1)
    })
  )
})

export type ReplaceMenuCustomizationGroupLinkedItemsRequest = z.output<
  typeof ReplaceMenuCustomizationGroupLinkedItemsRequestSchema
>

/**
 * ReportPeriod
 */
export const ReportPeriodSchema = z.enum(['7days', '30days', 'all', 'all-time'])

export type ReportPeriod = z.output<typeof ReportPeriodSchema>

/**
 * RequestPartnerAccessRequest
 */
export const RequestPartnerAccessRequestSchema = z.object({
  partner_id: z.int(),
  reason_notes: z.string().min(1).max(2000),
  reason_reference: z.url().nullish()
})

export type RequestPartnerAccessRequest = z.output<typeof RequestPartnerAccessRequestSchema>

/**
 * ResetPasswordRequest
 */
export const ResetPasswordRequestSchema = z.object({
  email: z.email().min(1),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  token: z.string().min(1)
})

export type ResetPasswordRequest = z.output<typeof ResetPasswordRequestSchema>

/**
 * ResultCode
 */
export const ResultCodeSchema = z.enum([
  'PASSWORD_RESET_LINK_SENT',
  'PASSWORD_RESET_COMPLETED',
  'PHONE_VERIFIED',
  'PHONE_VERIFICATION_SENT',
  'PHONE_VERIFICATION_NOT_REQUIRED',
  'REGISTRATION_COMPLETED',
  'REGISTRATION_STEP_VALIDATED',
  'EMAIL_VERIFIED',
  'EMAIL_VERIFICATION_SENT',
  'FAVORITE_STORE_TOGGLED',
  'FAVORITE_STORES_SYNCED',
  'SUPPORT_REQUEST_SUBMITTED',
  'REVIEW_SUBMITTED',
  'CONTACT_MESSAGE_SUBMITTED',
  'LEAD_SUBMITTED',
  'PARTNER_UPDATED',
  'PARTNER_DEACTIVATED',
  'ORDER_MODIFICATION_APPROVED',
  'ORDER_MODIFICATION_REJECTED',
  'PROFILE_UPDATED',
  'AVATAR_UPLOADED',
  'AVATAR_DELETED',
  'INVITATION_SENT',
  'INVITATION_ACCEPTED',
  'INVITATION_RESENT',
  'INVITATION_CANCELLED',
  'INVITATION_DELETED',
  'REVIEW_UPDATED',
  'REVIEW_MARKED_HELPFUL',
  'REVIEW_HELPFUL_MARK_REMOVED',
  'RESOURCE_DELETED',
  'WEBHOOK_ACKNOWLEDGED',
  'DASHBOARD_ENTITY_ACTION_COMPLETED',
  'CART_ITEM_MERGED',
  'CART_ITEM_UPDATED',
  'CHECKOUT_COMPLETED',
  'NOTIFICATION_INBOX_MARKED_READ',
  'NOTIFICATION_INBOX_CLEARED',
  'ORDER_CANCELLED',
  'ORDER_MODIFICATION_REQUESTED',
  'ORDER_MODIFICATION_APPLIED',
  'ORDER_PAYMENT_SUBMITTED',
  'ORDER_STATUS_TRANSITION_SUPPRESSED',
  'LEGAL_AGREEMENT_EMAILED',
  'LOGGED_OUT',
  'OTHER_SESSIONS_LOGGED_OUT',
  'RESOURCE_CREATED',
  'RESOURCE_UPDATED',
  'RESOURCE_RETRIEVED',
  'LOGGED_IN',
  'TWO_FACTOR_CHALLENGE_ISSUED',
  'TWO_FACTOR_STEP_UP_CONFIRMED',
  'PASSWORD_UPDATED',
  'PASSWORD_CONFIRMED',
  'TWO_FACTOR_ENABLED',
  'TWO_FACTOR_DISABLED',
  'TWO_FACTOR_CONFIRMED',
  'TWO_FACTOR_RECOVERY_CODES_REGENERATED',
  'TWO_FACTOR_RECOVERY_CODES_RETRIEVED',
  'TWO_FACTOR_QR_CODE_RETRIEVED',
  'TWO_FACTOR_SECRET_KEY_RETRIEVED'
])

export type ResultCode = z.output<typeof ResultCodeSchema>

/**
 * ReviewOrderModificationRequest
 */
export const ReviewOrderModificationRequestSchema = z.object({
  action: OrderModificationActionSchema,
  modification_request_id: z.int().gte(1),
  order_number: z.string().min(1),
  rejection_reason: z.string().max(2000).nullish()
})

export type ReviewOrderModificationRequest = z.output<typeof ReviewOrderModificationRequestSchema>

/**
 * SameBrandStore
 */
export const SameBrandStoreSchema = z.strictObject({
  address: z.string().nullable(),
  city: z.string().nullable(),
  distance_miles: z.string(),
  id: z.int(),
  latitude: z.number(),
  longitude: z.number(),
  slug: z.string(),
  state: z.string().nullable(),
  zip: z.string().nullable()
})

export type SameBrandStore = z.output<typeof SameBrandStoreSchema>

/**
 * SameBrandStores
 */
export const SameBrandStoresSchema = z.strictObject({
  brand: BrandSummarySchema,
  stores: z.array(SameBrandStoreSchema),
  total_stores: z.int()
})

export type SameBrandStores = z.output<typeof SameBrandStoresSchema>

/**
 * SavePaymentMethodRequest
 */
export const SavePaymentMethodRequestSchema = z.object({
  setup_intent_id: z
    .string()
    .min(1)
    .regex(/^seti_[A-Za-z0-9_]+$/)
})

export type SavePaymentMethodRequest = z.output<typeof SavePaymentMethodRequestSchema>

/**
 * SavedPaymentMethodType
 */
export const SavedPaymentMethodTypeSchema = z.enum([
  'card',
  'link',
  'cash',
  'us_bank_account',
  'pending'
])

export type SavedPaymentMethodType = z.output<typeof SavedPaymentMethodTypeSchema>

/**
 * AttachedLinkPaymentMethodSummary
 */
export const AttachedLinkPaymentMethodSummarySchema = z.strictObject({
  created_at: z.string().nullable(),
  id: z.int(),
  is_default: z.boolean(),
  payment_method_id: z.string(),
  status: OrderPaymentMethodStatusSchema,
  type: SavedPaymentMethodTypeSchema,
  updated_at: z.string().nullable()
})

export type AttachedLinkPaymentMethodSummary = z.output<
  typeof AttachedLinkPaymentMethodSummarySchema
>

/**
 * AttachedPaymentMethodSummary
 */
export const AttachedPaymentMethodSummarySchema = z.strictObject({
  brand: z.string(),
  country: z.string().nullable(),
  created_at: z.string().nullable(),
  exp_month: z.int(),
  exp_year: z.int(),
  id: z.int(),
  is_default: z.boolean(),
  last4: z.string(),
  payment_method_id: z.string(),
  status: OrderPaymentMethodStatusSchema,
  type: SavedPaymentMethodTypeSchema,
  updated_at: z.string().nullable()
})

export type AttachedPaymentMethodSummary = z.output<typeof AttachedPaymentMethodSummarySchema>

/**
 * PaymentMethodDetail
 */
export const PaymentMethodDetailSchema = z.strictObject({
  brand: z.string().nullable(),
  country: z.string().nullable(),
  created_at: z.string().nullable(),
  exp_month: z.int().nullable(),
  exp_year: z.int().nullable(),
  id: z.int(),
  is_default: z.boolean(),
  last4: z.string().nullable(),
  payment_method_id: z.string().nullable(),
  type: SavedPaymentMethodTypeSchema,
  updated_at: z.string().nullable()
})

export type PaymentMethodDetail = z.output<typeof PaymentMethodDetailSchema>

/**
 * PaymentData
 */
export const PaymentDataSchema = z.strictObject({
  amount: z.number(),
  created_at: z.string().nullable(),
  currency: CurrencySchema,
  failure_reason: z.string().nullable(),
  id: z.string(),
  order: PaymentOrderSummarySchema.nullable(),
  payment_details: PaymentDetailsSchema.nullable(),
  payment_method: z.string(),
  payment_method_code: PaymentMethodCodeSchema,
  payment_method_object: PaymentMethodDetailSchema.nullable(),
  processed_at: z.string().nullable(),
  remaining_charge_at: z.string().nullable(),
  status: PaymentStatusSchema,
  store: PaymentStoreSummarySchema.nullable(),
  transaction_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  user: PaymentUserSummarySchema.nullable()
})

export type PaymentData = z.output<typeof PaymentDataSchema>

/**
 * PaymentResource
 */
export const PaymentResourceSchema = z.object({
  amount: z.number(),
  created_at: z.string().nullable(),
  currency: CurrencySchema,
  failure_reason: z.string().nullable(),
  id: z.string(),
  order: PaymentOrderSummarySchema.optional(),
  payment_details: PaymentDetailsSchema.nullable(),
  payment_method: z.string(),
  payment_method_code: PaymentMethodCodeSchema,
  payment_method_object: PaymentMethodDetailSchema.nullish(),
  processed_at: z.string().nullable(),
  remaining_charge_at: z.string().nullable(),
  status: PaymentStatusSchema,
  store: PaymentStoreSummarySchema.optional(),
  transaction_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  user: PaymentUserSummarySchema.optional()
})

export type PaymentResource = z.output<typeof PaymentResourceSchema>

/**
 * PaymentSummary
 */
export const PaymentSummarySchema = z.strictObject({
  amount: z.number(),
  created_at: z.string().nullable(),
  currency: CurrencySchema,
  failure_reason: z.string().nullable(),
  order: PaymentOrderSummarySchema.nullable(),
  payment_details: PaymentDetailsSchema.nullable(),
  payment_method: PaymentMethodTypeSchema,
  payment_method_object: PaymentMethodDetailSchema.nullable(),
  payment_method_relation_loaded: z.boolean(),
  processed_at: z.string().nullable(),
  public_id: z.string(),
  remaining_charge_at: z.string().nullable(),
  status: PaymentStatusSchema,
  store: PaymentStoreSummarySchema.nullable(),
  store_timezone: z.string().nullable(),
  transaction_id: z.string().nullable(),
  updated_at: z.string().nullable(),
  user: PaymentUserSummarySchema.nullable()
})

export type PaymentSummary = z.output<typeof PaymentSummarySchema>

/**
 * ScoreFactor
 */
export const ScoreFactorSchema = z.strictObject({
  accepted: z.int().nullable(),
  auto_declined: z.int().nullable(),
  declined: z.int().nullable(),
  included: z.boolean(),
  score: z.number().nullable(),
  value: z.number().nullable(),
  weight: z.int()
})

export type ScoreFactor = z.output<typeof ScoreFactorSchema>

/**
 * ScoreBreakdown
 */
export const ScoreBreakdownSchema = z.strictObject({
  acceptance: ScoreFactorSchema,
  completion: ScoreFactorSchema,
  rating: ScoreFactorSchema,
  repeat: ScoreFactorSchema,
  responsiveness: ScoreFactorSchema,
  volume: ScoreFactorSchema
})

export type ScoreBreakdown = z.output<typeof ScoreBreakdownSchema>

/**
 * SearchRadiusQuery
 */
export const SearchRadiusQuerySchema = z.strictObject({
  lat: z.number(),
  lng: z.number(),
  q: z.string(),
  radius_miles: z.number(),
  search_method: z.string()
})

export type SearchRadiusQuery = z.output<typeof SearchRadiusQuerySchema>

/**
 * SearchScope
 */
export const SearchScopeSchema = z.enum(['categories', 'items'])

export type SearchScope = z.output<typeof SearchScopeSchema>

/**
 * SelectionType
 */
export const SelectionTypeSchema = z.enum(['single', 'multiple'])

export type SelectionType = z.output<typeof SelectionTypeSchema>

/**
 * SessionTokenResult
 */
export const SessionTokenResultSchema = z.strictObject({
  token: z.string()
})

export type SessionTokenResult = z.output<typeof SessionTokenResultSchema>

/**
 * SetupCheckpointStatus
 */
export const SetupCheckpointStatusSchema = z.enum(['not_started', 'in_progress', 'complete'])

export type SetupCheckpointStatus = z.output<typeof SetupCheckpointStatusSchema>

/**
 * SetupWarningCode
 */
export const SetupWarningCodeSchema = z.enum(['MENU_ASSIGNED_BUT_UNPUBLISHED'])

export type SetupWarningCode = z.output<typeof SetupWarningCodeSchema>

/**
 * SortDirection
 */
export const SortDirectionSchema = z.enum(['asc', 'desc'])

export type SortDirection = z.output<typeof SortDirectionSchema>

/**
 * SportTypeSummary
 */
export const SportTypeSummarySchema = z.strictObject({
  code: z.string(),
  description: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type SportTypeSummary = z.output<typeof SportTypeSummarySchema>

/**
 * StoreAvailabilityDeliveryRadiusResult
 */
export const StoreAvailabilityDeliveryRadiusResultSchema = z.strictObject({
  address: z.string(),
  available: z.boolean(),
  delivery_radius: z.number(),
  distance: z.number(),
  order_type: z.string(),
  reason: z.string(),
  store_id: z.int(),
  store_name: z.string()
})

export type StoreAvailabilityDeliveryRadiusResult = z.output<
  typeof StoreAvailabilityDeliveryRadiusResultSchema
>

/**
 * StoreAvailabilityLeadTimeRequirements
 */
export const StoreAvailabilityLeadTimeRequirementsSchema = z.strictObject({
  day_before_cutoff_time: z.string().nullable(),
  lead_time_hours: z.number(),
  lead_time_type: LeadTimeTypeSchema,
  multiple_days_notice: z.int().nullable(),
  required_minutes: z.int()
})

export type StoreAvailabilityLeadTimeRequirements = z.output<
  typeof StoreAvailabilityLeadTimeRequirementsSchema
>

/**
 * StoreAvailabilityLeadTimeResult
 */
export const StoreAvailabilityLeadTimeResultSchema = z.strictObject({
  available: z.boolean(),
  lead_time_requirements: StoreAvailabilityLeadTimeRequirementsSchema,
  order_type: z.string(),
  reason: z.string(),
  requested_date: z.string(),
  requested_time: z.string().nullable(),
  store_id: z.int(),
  store_name: z.string()
})

export type StoreAvailabilityLeadTimeResult = z.output<typeof StoreAvailabilityLeadTimeResultSchema>

/**
 * StoreAvailabilityMenuCustomHour
 */
export const StoreAvailabilityMenuCustomHourSchema = z.strictObject({
  day_of_week: z.string(),
  end_time: z.string().nullable(),
  is_enabled: z.boolean(),
  start_time: z.string().nullable()
})

export type StoreAvailabilityMenuCustomHour = z.output<typeof StoreAvailabilityMenuCustomHourSchema>

/**
 * StoreAvailabilityMenuCheck
 */
export const StoreAvailabilityMenuCheckSchema = z.strictObject({
  availability_mode: z.string(),
  available: z.boolean(),
  custom_hours: z.array(StoreAvailabilityMenuCustomHourSchema),
  menu_id: z.int(),
  menu_name: z.string(),
  message: z.string().nullable(),
  order_types: z.array(z.string()),
  reason: z.string().nullable()
})

export type StoreAvailabilityMenuCheck = z.output<typeof StoreAvailabilityMenuCheckSchema>

/**
 * StoreAvailabilityAvailableResult
 */
export const StoreAvailabilityAvailableResultSchema = z.strictObject({
  available: z.boolean(),
  delivery_fee: z.number(),
  estimated_preparation_time: z.int(),
  guest_count: z.int(),
  menus: z.array(StoreAvailabilityMenuCheckSchema),
  order_type: z.string(),
  pickup_instructions: z.string().nullable(),
  requested_date: z.string().nullable(),
  requested_time: z.string().nullable(),
  store_id: z.int(),
  store_name: z.string()
})

export type StoreAvailabilityAvailableResult = z.output<
  typeof StoreAvailabilityAvailableResultSchema
>

/**
 * StoreAvailabilityMenuCheckResult
 */
export const StoreAvailabilityMenuCheckResultSchema = z.strictObject({
  available: z.boolean(),
  menus: z.array(StoreAvailabilityMenuCheckSchema),
  order_type: z.string(),
  requested_date: z.string().nullable(),
  requested_time: z.string().nullable(),
  store_id: z.int(),
  store_name: z.string()
})

export type StoreAvailabilityMenuCheckResult = z.output<
  typeof StoreAvailabilityMenuCheckResultSchema
>

/**
 * StoreAvailabilityOperatingHours
 */
export const StoreAvailabilityOperatingHoursSchema = z.strictObject({
  close_time: z.string().nullable(),
  day: z.string(),
  is_open: z.boolean(),
  open_time: z.string().nullable()
})

export type StoreAvailabilityOperatingHours = z.output<typeof StoreAvailabilityOperatingHoursSchema>

/**
 * StoreAvailabilityOperatingHoursResult
 */
export const StoreAvailabilityOperatingHoursResultSchema = z.strictObject({
  available: z.boolean(),
  operating_hours: StoreAvailabilityOperatingHoursSchema,
  order_type: z.string(),
  reason: z.string(),
  requested_date: z.string(),
  requested_time: z.string().nullable(),
  store_id: z.int(),
  store_name: z.string()
})

export type StoreAvailabilityOperatingHoursResult = z.output<
  typeof StoreAvailabilityOperatingHoursResultSchema
>

/**
 * StoreAvailabilityPastTimeResult
 */
export const StoreAvailabilityPastTimeResultSchema = z.strictObject({
  available: z.boolean(),
  current_time: z.string(),
  order_type: z.string(),
  reason: z.string(),
  requested_time: z.string(),
  store_id: z.int(),
  store_name: z.string()
})

export type StoreAvailabilityPastTimeResult = z.output<typeof StoreAvailabilityPastTimeResultSchema>

/**
 * StoreAvailabilityUnavailable
 */
export const StoreAvailabilityUnavailableSchema = z.strictObject({
  available: z.boolean(),
  order_type: z.string(),
  reason: z.string(),
  store_id: z.int(),
  store_name: z.string()
})

export type StoreAvailabilityUnavailable = z.output<typeof StoreAvailabilityUnavailableSchema>

/**
 * StoreBrandSummary
 */
export const StoreBrandSummarySchema = z.strictObject({
  cover: z.string().nullable(),
  id: z.int(),
  logo: z.string().nullable(),
  name: z.string(),
  slug: z.string(),
  website: z.string().nullable()
})

export type StoreBrandSummary = z.output<typeof StoreBrandSummarySchema>

/**
 * StoreCartRequest
 */
export const StoreCartRequestSchema = z.object({
  customizations: z
    .array(
      z.object({
        group_id: z.int().optional(),
        option_id: z.int().optional()
      })
    )
    .nullish(),
  menu_id: z.int().nullish(),
  menu_item_id: z.int(),
  order_type: OrderTypeSchema.nullish(),
  quantity: z.int().gte(1),
  requested_date: z.iso.date().nullish(),
  requested_time: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
    .nullish(),
  serves_count: z
    .string()
    .regex(/^\d+(?:-\d+)?$/)
    .nullish(),
  special_instructions: z.string().max(500).nullish(),
  store_slug: z.string().min(1)
})

export type StoreCartRequest = z.output<typeof StoreCartRequestSchema>

/**
 * StoreCategorySummary
 */
export const StoreCategorySummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type StoreCategorySummary = z.output<typeof StoreCategorySummarySchema>

/**
 * StoreClosureCodeParams
 */
export const StoreClosureCodeParamsSchema = z.strictObject({
  closed_until: z.string(),
  operator_note: z.string().nullable()
})

export type StoreClosureCodeParams = z.output<typeof StoreClosureCodeParamsSchema>

/**
 * StoreClosureCode
 */
export const StoreClosureCodeSchema = z.strictObject({
  code: ClosureCodeSchema,
  params: StoreClosureCodeParamsSchema
})

export type StoreClosureCode = z.output<typeof StoreClosureCodeSchema>

/**
 * StoreConnectedAccountRequest
 */
export const StoreConnectedAccountRequestSchema = z.object({
  business_profile_brand_id: z.int().gte(1).optional(),
  payable_id: z.int().gte(1),
  payable_type: PayableTypeSchema
})

export type StoreConnectedAccountRequest = z.output<typeof StoreConnectedAccountRequestSchema>

/**
 * StoreDietaryOptionSummary
 */
export const StoreDietaryOptionSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string(),
  type: z.string()
})

export type StoreDietaryOptionSummary = z.output<typeof StoreDietaryOptionSummarySchema>

/**
 * StoreFieldUpdateRequest
 */
export const StoreFieldUpdateRequestSchema = z.strictObject({
  field: z.string(),
  requested_correction: z.string()
})

export type StoreFieldUpdateRequest = z.output<typeof StoreFieldUpdateRequestSchema>

/**
 * StoreImageType
 */
export const StoreImageTypeSchema = z.enum(['cover', 'logo'])

export type StoreImageType = z.output<typeof StoreImageTypeSchema>

/**
 * StoreImageRequest
 */
export const StoreImageRequestSchema = z.object({
  image: z.string().min(1),
  type: StoreImageTypeSchema
})

export type StoreImageRequest = z.output<typeof StoreImageRequestSchema>

/**
 * StoreMenuCategoryRequest
 */
export const StoreMenuCategoryRequestSchema = z.object({
  description: z.string().max(5000).nullish(),
  menu_ids: z.array(z.int()).min(1).optional(),
  name: z.string().min(1).max(255),
  status: MenuCategoryStatusSchema.nullish()
})

export type StoreMenuCategoryRequest = z.output<typeof StoreMenuCategoryRequestSchema>

/**
 * StoreMenuCustomizationGroupRequest
 */
export const StoreMenuCustomizationGroupRequestSchema = z.object({
  allow_repeated_selection: z.boolean().optional(),
  description: z.string().max(5000).nullish(),
  linked_items: z
    .array(
      z.object({
        id: z.int(),
        name: z.string().min(1)
      })
    )
    .optional(),
  max_per_option: z.string().optional(),
  max_selections: z.int().gte(1),
  max_total_selections: z.string().optional(),
  min_selections: z.int().gte(0),
  name: z.string().min(1).max(255),
  note: z.string().max(5000).nullish(),
  options: z
    .array(
      z.object({
        description: z.string().max(5000).nullish(),
        is_available: z.boolean().optional(),
        name: z.string().min(1).max(255),
        price_adjustment: z.number().gte(0).nullish(),
        sort_order: z.int().gte(0).optional()
      })
    )
    .min(1),
  selection_type: SelectionTypeSchema,
  status: CustomizationGroupStatusSchema.optional()
})

export type StoreMenuCustomizationGroupRequest = z.output<
  typeof StoreMenuCustomizationGroupRequestSchema
>

/**
 * StoreOperatingHourEntry
 */
export const StoreOperatingHourEntrySchema = z.strictObject({
  close_time: z.string().nullable(),
  day_of_week: DayOfWeekSchema,
  is_open: z.boolean(),
  open_time: z.string().nullable()
})

export type StoreOperatingHourEntry = z.output<typeof StoreOperatingHourEntrySchema>

/**
 * StoreOperationalHealth
 */
export const StoreOperationalHealthSchema = z.strictObject({
  average_rating: z.number().nullable(),
  breakdown: ScoreBreakdownSchema.nullable(),
  is_reliability_superstar: z.boolean(),
  review_count: z.int(),
  score: z.number().nullable(),
  score_updated_at: z.string().nullable()
})

export type StoreOperationalHealth = z.output<typeof StoreOperationalHealthSchema>

/**
 * StoreOrderModificationRequest
 */
export const StoreOrderModificationRequestSchema = z.object({
  details: z
    .object({
      delivery_address: z.string().max(500).optional(),
      delivery_business_name: z.string().max(255).nullish(),
      delivery_contact_person: z.string().max(255).nullish(),
      delivery_contact_phone: z
        .string()
        .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
        .nullish(),
      delivery_contact_type: DeliveryContactTypeSchema.nullish(),
      delivery_phone: z
        .string()
        .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
        .nullish(),
      delivery_suite: z.string().max(100).nullish(),
      guest_count: z.int().gte(1).optional(),
      order_type: OrderTypeSchema.optional(),
      payment_method_id: z.int().gte(1).optional(),
      requested_date: z.iso.date().optional(),
      requested_time: z
        .string()
        .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
        .optional(),
      setup_for_me: z.boolean().optional(),
      special_instructions: z.string().max(1000).nullish(),
      tip: z.number().gte(0).lte(1000).nullish()
    })
    .optional(),
  items: z
    .array(
      z.object({
        customizations: z
          .array(
            z.object({
              group_id: z.int(),
              option_id: z.int()
            })
          )
          .nullish(),
        menu_id: z.int().nullish(),
        menu_item_id: z.int().gte(1),
        quantity: z.int().gte(1),
        special_instructions: z.string().max(500).nullish()
      })
    )
    .min(1)
    .nullish()
})

export type StoreOrderModificationRequest = z.output<typeof StoreOrderModificationRequestSchema>

/**
 * StorePartnerSummary
 */
export const StorePartnerSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type StorePartnerSummary = z.output<typeof StorePartnerSummarySchema>

/**
 * StoreReference
 */
export const StoreReferenceSchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type StoreReference = z.output<typeof StoreReferenceSchema>

/**
 * StoreReviewCreateRequest
 */
export const StoreReviewCreateRequestSchema = z.object({
  photos: z.array(z.url()).nullish(),
  rating: z.int().gte(1).lte(5),
  review: z.string().max(1000).nullish(),
  title: z.string().max(100).nullish()
})

export type StoreReviewCreateRequest = z.output<typeof StoreReviewCreateRequestSchema>

/**
 * StoreReviewCustomerRef
 */
export const StoreReviewCustomerRefSchema = z.strictObject({
  id: z.int(),
  name: z.string()
})

export type StoreReviewCustomerRef = z.output<typeof StoreReviewCustomerRefSchema>

/**
 * StoreReviewFeedback
 */
export const StoreReviewFeedbackSchema = z.strictObject({
  comment: z.string().nullable(),
  field_update_requests: z.array(StoreFieldUpdateRequestSchema),
  reason_codes: z.array(z.string()),
  requested_at: z.string().nullable()
})

export type StoreReviewFeedback = z.output<typeof StoreReviewFeedbackSchema>

/**
 * StoreReviewFormOrder
 */
export const StoreReviewFormOrderSchema = z.strictObject({
  id: z.int()
})

export type StoreReviewFormOrder = z.output<typeof StoreReviewFormOrderSchema>

/**
 * StoreReviewRatingDistribution
 */
export const StoreReviewRatingDistributionSchema = z.strictObject({
  five_star: z.int(),
  four_star: z.int(),
  one_star: z.int(),
  three_star: z.int(),
  two_star: z.int()
})

export type StoreReviewRatingDistribution = z.output<typeof StoreReviewRatingDistributionSchema>

/**
 * StoreReviewReviewerRef
 */
export const StoreReviewReviewerRefSchema = z.strictObject({
  id: z.int(),
  last_name: z.string().nullable(),
  name: z.string().nullable()
})

export type StoreReviewReviewerRef = z.output<typeof StoreReviewReviewerRefSchema>

/**
 * StorePublicReviewEntry
 */
export const StorePublicReviewEntrySchema = z.strictObject({
  created_at: z.string().nullable(),
  helpful_count: z.int(),
  id: z.int(),
  is_helpful: z.boolean(),
  is_verified: z.boolean(),
  photos: z.array(z.string().nullable()),
  rating: z.int(),
  review: z.string().nullable(),
  reviewed_at: z.string().nullable(),
  title: z.string().nullable(),
  user: StoreReviewReviewerRefSchema
})

export type StorePublicReviewEntry = z.output<typeof StorePublicReviewEntrySchema>

/**
 * StoreReviewSort
 */
export const StoreReviewSortSchema = z.enum(['recent', 'helpful', 'highest', 'lowest'])

export type StoreReviewSort = z.output<typeof StoreReviewSortSchema>

/**
 * StoreReviewStatsDTO
 */
export const StoreReviewStatsDtoSchema = z.strictObject({
  average_rating: z.number(),
  rating_distribution: StoreReviewRatingDistributionSchema,
  total_reviews: z.int()
})

export type StoreReviewStatsDto = z.output<typeof StoreReviewStatsDtoSchema>

/**
 * GoogleReviewListingPage
 */
export const GoogleReviewListingPageSchema = z.strictObject({
  pagination: PaginationMetaDtoSchema,
  reviews: z.array(GoogleReviewEntrySchema),
  store_stats: StoreReviewStatsDtoSchema
})

export type GoogleReviewListingPage = z.output<typeof GoogleReviewListingPageSchema>

/**
 * StoreReviewStatus
 */
export const StoreReviewStatusSchema = z.enum(['pending', 'approved', 'rejected'])

export type StoreReviewStatus = z.output<typeof StoreReviewStatusSchema>

/**
 * StoreReviewStoreRef
 */
export const StoreReviewStoreRefSchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type StoreReviewStoreRef = z.output<typeof StoreReviewStoreRefSchema>

/**
 * DashboardStoreReview
 */
export const DashboardStoreReviewSchema = z.strictObject({
  created_at: z.string(),
  customer: StoreReviewCustomerRefSchema,
  helpful_count: z.int(),
  id: z.int(),
  order: DashboardStoreReviewOrderSchema.nullable(),
  order_number: z.string().nullable(),
  rating: z.int(),
  review: z.string(),
  reviewed_at: z.string().nullable(),
  status: StoreReviewStatusSchema,
  store: StoreReviewStoreRefSchema,
  title: z.string()
})

export type DashboardStoreReview = z.output<typeof DashboardStoreReviewSchema>

/**
 * DashboardStoreReviewModeration
 */
export const DashboardStoreReviewModerationSchema = z.strictObject({
  review: DashboardStoreReviewSchema
})

export type DashboardStoreReviewModeration = z.output<typeof DashboardStoreReviewModerationSchema>

/**
 * StoreReviewForm
 */
export const StoreReviewFormSchema = z.strictObject({
  expires_at: z.string(),
  order: StoreReviewFormOrderSchema.nullable(),
  store: StoreReviewStoreRefSchema
})

export type StoreReviewForm = z.output<typeof StoreReviewFormSchema>

/**
 * StoreReviewSummary
 */
export const StoreReviewSummarySchema = z.strictObject({
  approved: z.int(),
  average_rating: z.number(),
  pending: z.int(),
  rating_distribution: StoreReviewRatingDistributionSchema,
  rejected: z.int(),
  review_trend: z.int(),
  total: z.int()
})

export type StoreReviewSummary = z.output<typeof StoreReviewSummarySchema>

/**
 * DashboardStoreReviewList
 */
export const DashboardStoreReviewListSchema = z.strictObject({
  items: z.array(DashboardStoreReviewSchema),
  pagination: PaginationMetaDtoSchema,
  summary: StoreReviewSummarySchema
})

export type DashboardStoreReviewList = z.output<typeof DashboardStoreReviewListSchema>

/**
 * DashboardStoreScopedReviewList
 */
export const DashboardStoreScopedReviewListSchema = z.strictObject({
  google_reviews_status: DashboardStoreReviewGoogleStatusSchema,
  items: z.array(DashboardStoreReviewSchema),
  pagination: PaginationMetaDtoSchema,
  summary: StoreReviewSummarySchema
})

export type DashboardStoreScopedReviewList = z.output<typeof DashboardStoreScopedReviewListSchema>

/**
 * StoreReviewUpdateRequest
 */
export const StoreReviewUpdateRequestSchema = z.object({
  photos: z.array(z.url()).nullish(),
  rating: z.int().gte(1).lte(5).optional(),
  review: z.string().max(1000).nullish(),
  title: z.string().max(100).nullish()
})

export type StoreReviewUpdateRequest = z.output<typeof StoreReviewUpdateRequestSchema>

/**
 * StoreReviewUserRef
 */
export const StoreReviewUserRefSchema = z.strictObject({
  id: z.int(),
  last_name: z.string().nullable(),
  name: z.string()
})

export type StoreReviewUserRef = z.output<typeof StoreReviewUserRefSchema>

/**
 * StoreReview
 */
export const StoreReviewSchema = z.strictObject({
  created_at: z.string(),
  helpful_count: z.int(),
  id: z.int(),
  is_helpful: z.boolean(),
  is_verified: z.boolean(),
  photos: z.array(z.string()),
  rating: z.int(),
  review: z.string(),
  reviewed_at: z.string().nullable(),
  status: StoreReviewStatusSchema,
  title: z.string(),
  user: StoreReviewUserRefSchema
})

export type StoreReview = z.output<typeof StoreReviewSchema>

/**
 * StoreReviewListingPage
 */
export const StoreReviewListingPageSchema = z.strictObject({
  pagination: PaginationMetaDtoSchema,
  reviews: z.array(StoreReviewSchema),
  store_stats: StoreReviewStatsDtoSchema
})

export type StoreReviewListingPage = z.output<typeof StoreReviewListingPageSchema>

/**
 * StoreSearchEntry
 */
export const StoreSearchEntrySchema = z.strictObject({
  address: z.string().nullable(),
  average_rating: z.number().nullable(),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  created_at: z.string().nullable(),
  delivery_fee: z.number(),
  delivery_radius: z.number().nullable(),
  dine_in_available: z.boolean(),
  distance_miles: z.number().nullable(),
  featured_sort_order: z.union([z.int(), z.string()]),
  id: z.int(),
  individual_packaging_available: z.boolean(),
  is_favorite: z.boolean(),
  is_featured: z.boolean(),
  is_reliability_superstar: z.boolean(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  name: z.string(),
  review_count: z.int(),
  slug: z.string(),
  state: z.string().nullable(),
  zip: z.string().nullable()
})

export type StoreSearchEntry = z.output<typeof StoreSearchEntrySchema>

/**
 * StoreSearchResultsPage
 */
export const StoreSearchResultsPageSchema = z.strictObject({
  geocoded: z
    .object({
      address: z.string(),
      city: z.string().nullable(),
      state: z.string().nullable(),
      zip: z.string().nullable()
    })
    .nullable(),
  pagination: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  }),
  query: z.union([
    z.object({
      bbox: z.string(),
      place_type: z.string().nullable(),
      q: z.string(),
      search_method: z.literal('bounding_box')
    }),
    SearchRadiusQuerySchema,
    z.object({
      q: z.string()
    })
  ]),
  stores: z.array(StoreSearchEntrySchema)
})

export type StoreSearchResultsPage = z.output<typeof StoreSearchResultsPageSchema>

/**
 * StoreSetupTaskCode
 */
export const StoreSetupTaskCodeSchema = z.enum([
  'STORE_NAME',
  'CONTACT_PHONE',
  'CONTACT_EMAIL',
  'ADDRESS',
  'LOGO',
  'COVER_IMAGE',
  'CUISINE_TYPES',
  'SEATING_CAPACITY',
  'SERVICES',
  'OPERATING_HOURS',
  'ACCEPT_MSA',
  'PAYOUT_ONBOARDING',
  'PUBLISHED_MENU'
])

export type StoreSetupTaskCode = z.output<typeof StoreSetupTaskCodeSchema>

/**
 * DashboardTaskMetaResource
 */
export const DashboardTaskMetaResourceSchema = z.object({
  affected_brands: z.array(DashboardAffectedBrandSchema).optional(),
  brand_id: z.int().optional(),
  brand_name: z.string().optional(),
  can_submit: z.boolean().optional(),
  locked: z.boolean(),
  locked_by: DashboardTaskCodeSchema.optional(),
  next_route: z.string().optional(),
  next_step: StoreSetupTaskCodeSchema.optional(),
  pending_tasks: z.array(StoreSetupTaskCodeSchema).optional(),
  store_id: z.int().optional(),
  store_name: z.string().optional(),
  stores_missing_menu: z.array(DashboardStoreMissingMenuSchema).optional()
})

export type DashboardTaskMetaResource = z.output<typeof DashboardTaskMetaResourceSchema>

/**
 * DashboardTaskResource
 */
export const DashboardTaskResourceSchema = z.object({
  category: z.string(),
  completed: z.boolean(),
  count: z.int().optional(),
  key: z.string(),
  meta: DashboardTaskMetaResourceSchema,
  route: z.string(),
  status: z.string(),
  task_code: DashboardTaskCodeResourceSchema,
  total: z.int().optional()
})

export type DashboardTaskResource = z.output<typeof DashboardTaskResourceSchema>

/**
 * DashboardTaskGroupsResource
 */
export const DashboardTaskGroupsResourceSchema = z.object({
  completed: z.array(DashboardTaskResourceSchema),
  important: z.array(DashboardTaskResourceSchema),
  required: z.array(DashboardTaskResourceSchema),
  suggested: z.array(DashboardTaskResourceSchema)
})

export type DashboardTaskGroupsResource = z.output<typeof DashboardTaskGroupsResourceSchema>

/**
 * DashboardQuickActionsResult
 */
export const DashboardQuickActionsResultSchema = z.strictObject({
  completion: DashboardTaskCompletionResourceSchema,
  recommended_tasks: DashboardTaskGroupsResourceSchema
})

export type DashboardQuickActionsResult = z.output<typeof DashboardQuickActionsResultSchema>

/**
 * SetupTask
 */
export const SetupTaskSchema = z.strictObject({
  done: z.boolean(),
  key: z.string(),
  task_code: StoreSetupTaskCodeSchema
})

export type SetupTask = z.output<typeof SetupTaskSchema>

/**
 * SetupCheckpoint
 */
export const SetupCheckpointSchema = z.strictObject({
  completed: z.int(),
  key: z.string(),
  status: SetupCheckpointStatusSchema,
  tasks: z.array(SetupTaskSchema),
  total: z.int(),
  warning_code: SetupWarningCodeSchema.nullable()
})

export type SetupCheckpoint = z.output<typeof SetupCheckpointSchema>

/**
 * StoreSetupProgress
 */
export const StoreSetupProgressSchema = z.strictObject({
  can_submit: z.boolean(),
  checkpoints: z.array(SetupCheckpointSchema)
})

export type StoreSetupProgress = z.output<typeof StoreSetupProgressSchema>

/**
 * StoreSlugSummary
 */
export const StoreSlugSummarySchema = z.strictObject({
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type StoreSlugSummary = z.output<typeof StoreSlugSummarySchema>

/**
 * LeadSubmission
 */
export const LeadSubmissionSchema = z.strictObject({
  event: EventSlugSummarySchema.nullable(),
  lead: LeadSchema,
  store: StoreSlugSummarySchema.nullable()
})

export type LeadSubmission = z.output<typeof LeadSubmissionSchema>

/**
 * StoreStatus
 */
export const StoreStatusSchema = z.enum([
  'draft',
  'in_review',
  'updates_required',
  'active',
  'temporarily_closed',
  'disabled'
])

export type StoreStatus = z.output<typeof StoreStatusSchema>

/**
 * StoreTemporaryClosure
 */
export const StoreTemporaryClosureSchema = z.strictObject({
  duration_minutes: z.int(),
  ends_at: z.string(),
  id: z.int(),
  reason: z.string().nullable(),
  starts_at: z.string(),
  store_id: z.int()
})

export type StoreTemporaryClosure = z.output<typeof StoreTemporaryClosureSchema>

/**
 * StoreSummary
 */
export const StoreSummarySchema = z.strictObject({
  active_temporary_closure: StoreTemporaryClosureSchema.nullable(),
  address: z.string().nullable(),
  average_rating: z.number().nullable(),
  city: z.string().nullable(),
  closure_code: StoreClosureCodeSchema.nullable(),
  cover: z.string().nullable(),
  delivery_radius: z.number().nullable(),
  id: z.int(),
  is_temporarily_closed: z.boolean(),
  logo: z.string().nullable(),
  merchant_connected: z.boolean(),
  name: z.string(),
  order_types: z.array(z.string()),
  slug: z.string(),
  state: z.string().nullable(),
  status: StoreStatusSchema,
  timezone: z.string().nullable(),
  zip: z.string().nullable()
})

export type StoreSummary = z.output<typeof StoreSummarySchema>

/**
 * MenuListItemDto
 */
export const MenuListItemDtoSchema = z.strictObject({
  categories: z.array(MenuOptionSummaryDtoSchema),
  categories_count: z.int(),
  categories_preview: z.array(MenuOptionSummaryDtoSchema),
  id: z.int(),
  is_active: z.boolean(),
  items_count: z.int(),
  name: z.string(),
  partner_id: z.int().nullable(),
  status: z.string(),
  store_ids: z.array(z.int()),
  stores: z.array(StoreSummarySchema),
  type_ids: z.array(z.int()),
  types: z.array(MenuTypeSummaryDtoSchema),
  updated_at: z.string().nullable()
})

export type MenuListItemDto = z.output<typeof MenuListItemDtoSchema>

/**
 * MenuListPage
 */
export const MenuListPageSchema = z.strictObject({
  items: z.array(MenuListItemDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuListPage = z.output<typeof MenuListPageSchema>

/**
 * PartnerOrderSummaryData
 */
export const PartnerOrderSummaryDataSchema = z.strictObject({
  acceptance_deadline: z.string().nullable(),
  created_at: z.string().nullable(),
  delivery_address: z.string().nullable(),
  delivery_fee: z.number(),
  delivery_fee_deduction: z.number(),
  guest_count: z.int(),
  id: z.int(),
  net_payout: z.number(),
  order_items_count: z.int().nullable(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  partner_total: z.number(),
  payment_status: PaymentStatusSchema,
  requested_date: z.string(),
  requested_time: z.string(),
  status: OrderStatusSchema,
  store: StoreSummarySchema.nullable(),
  subtotal: z.number(),
  tax: z.number(),
  tax_deduction: z.number(),
  tip: z.number(),
  total: z.number(),
  user: OrderRequesterSummarySchema.nullable()
})

export type PartnerOrderSummaryData = z.output<typeof PartnerOrderSummaryDataSchema>

/**
 * PartnerOrderSummaryDataPage
 */
export const PartnerOrderSummaryDataPageSchema = z.strictObject({
  items: z.array(PartnerOrderSummaryDataSchema),
  pagination: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  })
})

export type PartnerOrderSummaryDataPage = z.output<typeof PartnerOrderSummaryDataPageSchema>

/**
 * StoreSummaryPage
 */
export const StoreSummaryPageSchema = z.strictObject({
  items: z.array(StoreSummarySchema),
  pagination: PaginationMetaDtoSchema
})

export type StoreSummaryPage = z.output<typeof StoreSummaryPageSchema>

/**
 * StoreSummaryResource
 */
export const StoreSummaryResourceSchema = z.object({
  active_temporary_closure: StoreTemporaryClosureSchema.nullable(),
  address: z.string().nullable(),
  average_rating: z.number().nullable(),
  city: z.string().nullable(),
  closure_code: StoreClosureCodeSchema.nullable(),
  cover: z.string().nullable(),
  delivery_radius: z.number().nullable(),
  id: z.int(),
  is_temporarily_closed: z.boolean(),
  logo: z.string().nullable(),
  merchant_connected: z.boolean(),
  name: z.string(),
  order_types: z.array(z.string()),
  slug: z.string(),
  state: z.string().nullable(),
  status: StoreStatusSchema,
  timezone: z.string().nullable(),
  zip: z.string().nullable()
})

export type StoreSummaryResource = z.output<typeof StoreSummaryResourceSchema>

/**
 * OrderSummaryResource
 */
export const OrderSummaryResourceSchema = z.object({
  created_at: z.string().nullable(),
  delivery_address: z.string().nullable(),
  guest_count: z.int(),
  id: z.int(),
  net_payout: z.number(),
  order_items_count: z.int().nullish(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  payment_status: PaymentStatusSchema,
  requested_date: z.string(),
  requested_time: z.string(),
  status: OrderStatusSchema,
  store: StoreSummaryResourceSchema.nullable(),
  total: z.number(),
  user: OrderRequesterSummaryResourceSchema.optional()
})

export type OrderSummaryResource = z.output<typeof OrderSummaryResourceSchema>

/**
 * PartnerOrderSummaryResource
 */
export const PartnerOrderSummaryResourceSchema = z.object({
  acceptance_deadline: z.string().nullable(),
  created_at: z.string().nullable(),
  delivery_address: z.string().nullable(),
  delivery_fee: z.number(),
  delivery_fee_deduction: z.number(),
  guest_count: z.int(),
  id: z.int(),
  net_payout: z.number(),
  order_items_count: z.int().nullish(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  partner_total: z.number(),
  payment_status: PaymentStatusSchema,
  requested_date: z.string(),
  requested_time: z.string(),
  status: OrderStatusSchema,
  store: StoreSummaryResourceSchema.nullable(),
  subtotal: z.number(),
  tax: z.number(),
  tax_deduction: z.number(),
  tip: z.number(),
  total: z.number(),
  user: OrderRequesterSummaryResourceSchema.optional()
})

export type PartnerOrderSummaryResource = z.output<typeof PartnerOrderSummaryResourceSchema>

/**
 * PayoutResource
 */
export const PayoutResourceSchema = z.object({
  amount: z.number(),
  application_fee_total: z.string(),
  created_at: z.string().nullable(),
  currency: z.string(),
  delivery_fee_total: z.string(),
  destination_account: z.string().nullable(),
  destination_entity_type: z.string().nullable(),
  destination_name: z.string().nullable(),
  gross_amount: z.number(),
  id: z.string(),
  included_orders_count: z.int(),
  initiated_by: z.int().nullable(),
  orders: z.array(OrderSummaryResourceSchema).optional(),
  payout_details: PayoutDetailsViewSchema.nullable(),
  period_end: z.string().nullable(),
  period_start: z.string().nullable(),
  platform_commission_total: z.string(),
  processed_at: z.string().nullable(),
  processing_fee_total: z.string(),
  scheduled_at: z.string().nullable(),
  status: PayoutStatusSchema,
  status_code: PayoutStatusCodeSchema,
  store: StoreSummaryResourceSchema.nullable(),
  subtotal: z.number(),
  tax_collected: z.string(),
  tax_remitted: z.string(),
  tax_withheld: z.number(),
  tip_total: z.string(),
  transaction_id: z.string().nullable(),
  updated_at: z.string().nullable()
})

export type PayoutResource = z.output<typeof PayoutResourceSchema>

/**
 * DashboardPayoutGroupResource
 */
export const DashboardPayoutGroupResourceSchema = z.object({
  label: z.string(),
  payouts: z.array(PayoutResourceSchema)
})

export type DashboardPayoutGroupResource = z.output<typeof DashboardPayoutGroupResourceSchema>

/**
 * DashboardSummary
 */
export const DashboardSummarySchema = z.strictObject({
  active_orders: z.array(PartnerOrderSummaryResourceSchema),
  order_requests: z.array(PartnerOrderSummaryResourceSchema),
  recent_activity: z.array(DashboardPayoutGroupResourceSchema)
})

export type DashboardSummary = z.output<typeof DashboardSummarySchema>

/**
 * StoreTemporaryClosureList
 */
export const StoreTemporaryClosureListSchema = z.strictObject({
  items: z.array(StoreTemporaryClosureSchema)
})

export type StoreTemporaryClosureList = z.output<typeof StoreTemporaryClosureListSchema>

/**
 * StripeWebhookAcknowledgement
 */
export const StripeWebhookAcknowledgementSchema = z.strictObject({
  deduped: z.boolean()
})

export type StripeWebhookAcknowledgement = z.output<typeof StripeWebhookAcknowledgementSchema>

/**
 * SubmitMenuSupportRequest
 */
export const SubmitMenuSupportRequestSchema = z.object({
  current_url: z.string().max(500).nullish(),
  email: z.email().max(180),
  menu_id: z.int().nullish(),
  message: z.string().min(1).max(5000),
  name: z.string().min(1).max(120),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  preferred_contact_method: PreferredContactMethodSchema,
  subject: z.string().min(1).max(180),
  topic: z.string().min(1).max(120)
})

export type SubmitMenuSupportRequest = z.output<typeof SubmitMenuSupportRequestSchema>

/**
 * SubmitStoreReviewRequest
 */
export const SubmitStoreReviewRequestSchema = z.object({
  rating: z.int().gte(1).lte(5),
  review: z.string().max(2000).nullish(),
  title: z.string().max(120).nullish()
})

export type SubmitStoreReviewRequest = z.output<typeof SubmitStoreReviewRequestSchema>

/**
 * SupersededPartnerAgreement
 */
export const SupersededPartnerAgreementSchema = z.strictObject({
  accepted_at: z.string(),
  created_at: z.string(),
  effective_at: z.string(),
  id: z.string(),
  partner: LegalAgreementPartnerSchema,
  signatory: LegalAgreementSignatorySchema,
  status: z.literal('superseded'),
  superseded_at: z.string(),
  terms: PartnerAgreementTermsSchema,
  type: z.literal('partner_agreement')
})

export type SupersededPartnerAgreement = z.output<typeof SupersededPartnerAgreementSchema>

/**
 * SyncGuestFavoritesRequest
 */
export const SyncGuestFavoritesRequestSchema = z.object({
  store_ids: z.array(z.int()).nullish()
})

export type SyncGuestFavoritesRequest = z.output<typeof SyncGuestFavoritesRequestSchema>

/**
 * SyncMenuItemPlacementsRequest
 */
export const SyncMenuItemPlacementsRequestSchema = z.object({
  placements: z.array(
    z.object({
      menu_category_id: z.int(),
      sort_order: z.int().gte(0).optional()
    })
  )
})

export type SyncMenuItemPlacementsRequest = z.output<typeof SyncMenuItemPlacementsRequestSchema>

/**
 * TagDto
 */
export const TagDtoSchema = z.strictObject({
  cover: z.string().nullable(),
  description: z.string().nullable(),
  featured_title: z.string().nullable(),
  group: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  slug: z.string()
})

export type TagDto = z.output<typeof TagDtoSchema>

/**
 * PublicStoreDto
 */
export const PublicStoreDtoSchema = z.strictObject({
  active_temporary_closure: StoreTemporaryClosureSchema.nullable(),
  address: z.string().nullable(),
  average_rating: z.number().nullable(),
  brand: StoreBrandSummarySchema.nullable(),
  categories: z.array(StoreCategorySummarySchema).nullable(),
  city: z.string().nullable(),
  closure_code: StoreClosureCodeSchema.nullable(),
  cover: z.string().nullable(),
  created_at: z.string().nullable(),
  day_before_cutoff_time: z.string().nullable(),
  delivery_available: z.boolean(),
  delivery_fee: z.number(),
  delivery_radius: z.number().nullable(),
  description: z.string().nullable(),
  dine_in_available: z.boolean(),
  email: z.string().nullable(),
  id: z.int(),
  is_favorite: z.boolean(),
  is_reliability_superstar: z.boolean(),
  is_temporarily_closed: z.boolean(),
  latitude: z.number().nullable(),
  lead_time_hours: z.number().nullable(),
  lead_time_type: z.string().nullable(),
  logo: z.string().nullable(),
  longitude: z.number().nullable(),
  minimum_order: z.number(),
  multiple_days_notice: z.int().nullable(),
  name: z.string(),
  operating_hours: z.array(StoreOperatingHourEntrySchema).nullable(),
  order_types: z.array(z.string()),
  phone: z.string().nullable(),
  pickup_available: z.boolean(),
  review_count: z.int().nullable(),
  reviews: z.array(StorePublicReviewEntrySchema).nullable(),
  slug: z.string(),
  state: z.string().nullable(),
  status: z.string(),
  tags: z.array(TagDtoSchema).nullable(),
  temporary_closures: z.array(StoreTemporaryClosureSchema).nullable(),
  timezone: z.string().nullable(),
  updated_at: z.string().nullable(),
  website: z.string().nullable(),
  zip: z.string().nullable()
})

export type PublicStoreDto = z.output<typeof PublicStoreDtoSchema>

/**
 * StoreDto
 */
export const StoreDtoSchema = z.strictObject({
  active_temporary_closure: StoreTemporaryClosureSchema.nullable(),
  address: z.string().nullable(),
  average_rating: z.number().nullable(),
  brand: StoreBrandSummarySchema.nullable(),
  categories: z.array(StoreCategorySummarySchema).nullable(),
  city: z.string().nullable(),
  cover: z.string().nullable(),
  created_at: z.string().nullable(),
  day_before_cutoff_time: z.string().nullable(),
  delivery_available: z.boolean(),
  delivery_fee: z.number(),
  delivery_radius: z.number().nullable(),
  description: z.string().nullable(),
  dietary_options: z.array(StoreDietaryOptionSummarySchema).nullable(),
  dine_in_available: z.boolean(),
  email: z.string().nullable(),
  enable_google_reviews: z.boolean(),
  google_places_address: z.string().nullable(),
  id: z.int(),
  is_favorite: z.boolean(),
  is_reliability_superstar: z.boolean(),
  is_temporarily_closed: z.boolean(),
  latitude: z.number().nullable(),
  lead_time_hours: z.number().nullable(),
  lead_time_type: z.string().nullable(),
  logo: z.string().nullable(),
  longitude: z.number().nullable(),
  minimum_order: z.number(),
  multiple_days_notice: z.int().nullable(),
  name: z.string(),
  onboarding_review_status: z.string().nullable(),
  operating_hours: z.array(StoreOperatingHourEntrySchema).nullable(),
  partner: StorePartnerSummarySchema.nullable(),
  phone: z.string().nullable(),
  pickup_available: z.boolean(),
  review_count: z.int().nullable(),
  review_feedback: StoreReviewFeedbackSchema.nullable(),
  review_requested_at: z.string().nullable(),
  reviewed_at: z.string().nullable(),
  seating_capacity: z.int().nullable(),
  setup_progress: StoreSetupProgressSchema.nullable(),
  slug: z.string(),
  state: z.string().nullable(),
  status: StoreStatusSchema,
  tags: z.array(TagDtoSchema).nullable(),
  temporary_closures: z.array(StoreTemporaryClosureSchema).nullable(),
  timezone: z.string().nullable(),
  updated_at: z.string().nullable(),
  website: z.string().nullable(),
  zip: z.string().nullable()
})

export type StoreDto = z.output<typeof StoreDtoSchema>

/**
 * TaxCategoryCode
 */
export const TaxCategoryCodeSchema = z.enum([
  'FOOD_AND_NON_ALCOHOLIC_BEVERAGES',
  'ALCOHOLIC_BEER_OR_MALT_BEVERAGE',
  'ALCOHOLIC_SPIRITS',
  'ALCOHOLIC_WINE'
])

export type TaxCategoryCode = z.output<typeof TaxCategoryCodeSchema>

/**
 * MenuItemDto
 */
export const MenuItemDtoSchema = z.strictObject({
  allergens: z.array(MenuItemAllergenRecordSchema),
  calories_per_serving: z.int().nullable(),
  category: MenuItemCategoryRefSchema,
  created_at: z.string().nullable(),
  customizations: z.array(CustomizationGroupDtoSchema),
  customizations_count: z.int(),
  description: z.string().nullable(),
  dietary_info: z.array(MenuItemDietaryInfoRecordSchema),
  dietary_options: z.array(MenuItemDietaryOptionSummarySchema),
  id: z.int(),
  image: z.string().nullable(),
  individual_packaging_available: z.boolean(),
  is_featured: z.boolean(),
  is_new: z.int(),
  is_package: z.boolean(),
  is_popular: z.int(),
  is_special: z.int(),
  minimum_guest_count: z.int(),
  minimum_order: z.int(),
  name: z.string(),
  order_count: z.int(),
  popularity_score: z.number().nullable(),
  preparation_time: z.int().nullable(),
  price: z.number(),
  price_type: MenuItemPriceTypeSchema,
  serves_count: z.string().nullable(),
  sort_order: z.int(),
  status: z.string(),
  tax_category: TaxCategoryCodeSchema,
  updated_at: z.string().nullable(),
  weight_unit: z.string().nullable(),
  weight_value: z.number().nullable()
})

export type MenuItemDto = z.output<typeof MenuItemDtoSchema>

/**
 * MenuCategoryDto
 */
export const MenuCategoryDtoSchema = z.strictObject({
  description: z.string().nullable(),
  id: z.int(),
  is_featured_category: z.boolean(),
  menu_items: z.array(MenuItemDtoSchema),
  menu_items_count: z.int(),
  name: z.string(),
  sort_order: z.int(),
  status: z.string()
})

export type MenuCategoryDto = z.output<typeof MenuCategoryDtoSchema>

/**
 * MenuDto
 */
export const MenuDtoSchema = z.strictObject({
  availability: z.string().nullable(),
  availability_mode: z.string(),
  available_from: z.string().nullable(),
  available_until: z.string().nullable(),
  categories: z.array(MenuCategoryDtoSchema),
  categories_count: z.int(),
  created_at: z.string().nullable(),
  custom_hours: z.array(CustomHoursDtoSchema),
  description: z.string().nullable(),
  id: z.int(),
  name: z.string(),
  order_types: z.array(z.string()),
  partner_id: z.int().nullable(),
  schedule: z.array(CustomHoursDtoSchema),
  sort_order: z.int(),
  status: z.string(),
  store_ids: z.array(z.int()),
  stores: z.array(StoreSummarySchema),
  sync_with_store_hours: z.boolean(),
  tag_ids: z.array(z.int()),
  tags: z.array(MenuTagSummaryDtoSchema),
  type: z.string().nullable(),
  type_ids: z.array(z.int()),
  types: z.array(MenuTypeSummaryDtoSchema),
  updated_at: z.string().nullable()
})

export type MenuDto = z.output<typeof MenuDtoSchema>

/**
 * MenuItemManagementDto
 */
export const MenuItemManagementDtoSchema = z.strictObject({
  created_at: z.string().nullable(),
  customization_group_ids: z.array(z.int()).nullable(),
  customization_groups: z.array(MenuItemCustomizationGroupAssignmentDtoSchema).nullable(),
  default_price: z.number(),
  description: z.string().nullable(),
  dietary_attribute_ids: z.array(z.int()).nullable(),
  dietary_attributes: z.array(DietaryOptionSummaryDtoSchema).nullable(),
  duplicate_name_count: z.int(),
  id: z.int(),
  individual_packaging_available: z.boolean(),
  is_available: z.boolean(),
  is_featured: z.boolean(),
  is_package: z.boolean(),
  menu_category: MenuItemManagementCategoryRefDtoSchema.nullable(),
  menu_category_id: z.int().nullable(),
  menu_context: MenuItemMenuContextDtoSchema.nullable(),
  minimum_guest_count: z.int(),
  name: z.string(),
  out_of_stock: z.boolean(),
  photo: z.string().nullable(),
  photo_path: z.string().nullable(),
  placements: z.array(MenuItemPlacementDtoSchema),
  price: z.number(),
  price_type: MenuItemPriceTypeSchema,
  serves_count: z.string().nullable(),
  sort_order: z.int().nullable(),
  status: z.string(),
  store: MenuOptionSummaryDtoSchema.nullable(),
  tax_category: TaxCategoryCodeSchema,
  updated_at: z.string().nullable(),
  weight_unit: z.string().nullable(),
  weight_value: z.number().nullable()
})

export type MenuItemManagementDto = z.output<typeof MenuItemManagementDtoSchema>

/**
 * MenuItemManagementPage
 */
export const MenuItemManagementPageSchema = z.strictObject({
  items: z.array(MenuItemManagementDtoSchema),
  pagination: PaginationMetaDtoSchema
})

export type MenuItemManagementPage = z.output<typeof MenuItemManagementPageSchema>

/**
 * OrderItemData
 */
export const OrderItemDataSchema = z.strictObject({
  created_at: z.iso.datetime({ offset: true }).nullable(),
  customizations: z.array(CustomizationDtoSchema),
  id: z.int(),
  item_name: z.string(),
  menu_ids: z.array(z.int()),
  menu_item: OrderItemMenuItemSummarySchema,
  quantity: z.int(),
  special_instructions: z.string().nullable(),
  tax_category: TaxCategoryCodeSchema,
  total_price: z.number(),
  unit_price: z.number(),
  updated_at: z.iso.datetime({ offset: true }).nullable()
})

export type OrderItemData = z.output<typeof OrderItemDataSchema>

/**
 * CustomerOrderData
 */
export const CustomerOrderDataSchema = z.strictObject({
  actual_delivery_time: z.string().nullable(),
  amount_paid: z.number(),
  amount_remaining: z.number(),
  application_fee: z.number(),
  beo_agreement_url: z.string().nullable(),
  booked_by: z.string().nullable(),
  can_be_cancelled: z.boolean(),
  can_be_modified: z.boolean(),
  created_at: z.string().nullable(),
  delivery_address: z.string().nullable(),
  delivery_business_name: z.string().nullable(),
  delivery_contact_person: z.string().nullable(),
  delivery_contact_phone: z.string().nullable(),
  delivery_contact_type: z.string().nullable(),
  delivery_fee: z.number(),
  delivery_phone: z.string().nullable(),
  delivery_suite: z.string().nullable(),
  estimated_delivery_time: z.string().nullable(),
  guest_count: z.int(),
  id: z.int(),
  is_organizer_order: z.boolean(),
  latest_payment: PaymentSummarySchema.nullable(),
  latest_payment_loaded: z.boolean(),
  modification_requests: z.array(OrderModificationRequestDataSchema).nullable(),
  order_items: z.array(OrderItemDataSchema).nullable(),
  order_items_count: z.int().nullable(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  organization: z.string().nullable(),
  payment_method: z.union([
    AttachedPaymentMethodSummarySchema,
    AttachedLinkPaymentMethodSummarySchema,
    NotAttachedPaymentMethodSummarySchema
  ]),
  payment_retry_url: z.string().nullable(),
  payment_status: PaymentStatusSchema,
  payment_url: z.string().nullable(),
  payments: z.array(PaymentSummarySchema),
  requested_date: z.string(),
  requested_time: z.string(),
  setup_for_me: z.boolean(),
  special_instructions: z.string().nullable(),
  status: OrderStatusSchema,
  store: StoreSummarySchema.nullable(),
  subtotal: z.number(),
  tax: z.number(),
  timeline: z.array(OrderLedgerEntryDtoSchema).nullable(),
  tip: z.number(),
  total: z.number(),
  updated_at: z.string().nullable()
})

export type CustomerOrderData = z.output<typeof CustomerOrderDataSchema>

/**
 * CustomerOrderDataPage
 */
export const CustomerOrderDataPageSchema = z.strictObject({
  items: z.array(CustomerOrderDataSchema),
  pagination: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  })
})

export type CustomerOrderDataPage = z.output<typeof CustomerOrderDataPageSchema>

/**
 * OrderItemResource
 */
export const OrderItemResourceSchema = z.object({
  created_at: z.string().nullable(),
  customizations: z.array(CustomizationResourceSchema),
  id: z.int(),
  item_name: z.string(),
  menu_ids: z.array(z.int()),
  menu_item: OrderItemMenuItemSummaryResourceSchema,
  quantity: z.int(),
  special_instructions: z.string().nullable(),
  tax_category: TaxCategoryCodeSchema,
  total_price: z.number(),
  unit_price: z.number(),
  updated_at: z.string().nullable()
})

export type OrderItemResource = z.output<typeof OrderItemResourceSchema>

/**
 * CustomerOrderResource
 */
export const CustomerOrderResourceSchema = z.object({
  actual_delivery_time: z.string().nullable(),
  amount_paid: z.number(),
  amount_remaining: z.number(),
  application_fee: z.number(),
  beo_agreement_url: z.string().nullable(),
  booked_by: z.string().nullable(),
  can_be_cancelled: z.boolean(),
  can_be_modified: z.boolean(),
  created_at: z.string().nullable(),
  delivery_address: z.string().nullable(),
  delivery_business_name: z.string().nullable(),
  delivery_contact_person: z.string().nullable(),
  delivery_contact_phone: z.string().nullable(),
  delivery_contact_type: z.string().nullable(),
  delivery_fee: z.number(),
  delivery_phone: z.string().nullable(),
  delivery_suite: z.string().nullable(),
  estimated_delivery_time: z.string().nullable(),
  guest_count: z.int(),
  id: z.int(),
  is_organizer_order: z.boolean(),
  latest_payment: PaymentResourceSchema.nullish(),
  modification_requests: z.array(OrderModificationRequestResourceSchema).optional(),
  order_items: z.array(OrderItemResourceSchema).optional(),
  order_items_count: z.int().optional(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  organization: z.string().nullable(),
  payment_method: z.union([
    AttachedPaymentMethodSummarySchema,
    AttachedLinkPaymentMethodSummarySchema,
    NotAttachedPaymentMethodSummarySchema
  ]),
  payment_retry_url: z.string().nullable(),
  payment_status: PaymentStatusSchema,
  payment_url: z.string().nullable(),
  payments: z.array(PaymentResourceSchema),
  requested_date: z.string(),
  requested_time: z.string(),
  setup_for_me: z.boolean(),
  special_instructions: z.string().nullable(),
  status: OrderStatusSchema,
  store: StoreSummarySchema.nullable(),
  subtotal: z.number(),
  tax: z.number(),
  timeline: z.array(OrderLedgerResourceSchema).optional(),
  tip: z.number(),
  total: z.number(),
  updated_at: z.string().nullable()
})

export type CustomerOrderResource = z.output<typeof CustomerOrderResourceSchema>

/**
 * CustomerOrderPage
 */
export const CustomerOrderPageSchema = z.strictObject({
  orders: z.array(CustomerOrderResourceSchema),
  pagination: PaginationMetaDtoSchema
})

export type CustomerOrderPage = z.output<typeof CustomerOrderPageSchema>

/**
 * OrderModificationSubmission
 */
export const OrderModificationSubmissionSchema = z.strictObject({
  modification_request: OrderModificationRequestResourceSchema,
  order: CustomerOrderDataSchema
})

export type OrderModificationSubmission = z.output<typeof OrderModificationSubmissionSchema>

/**
 * PartnerOrderData
 */
export const PartnerOrderDataSchema = z.strictObject({
  acceptance_deadline: z.string().nullable(),
  actual_delivery_time: z.string().nullable(),
  beo_agreement_url: z.string().nullable(),
  beo_invoice_url: z.string().nullable(),
  can_be_accepted: z.boolean(),
  can_be_completed: z.boolean(),
  can_be_declined: z.boolean(),
  can_be_preparing: z.boolean(),
  can_be_ready: z.boolean(),
  created_at: z.string().nullable(),
  customer_application_fee: z.number(),
  customer_processing_fee: z.number(),
  delivery_address: z.string().nullable(),
  delivery_business_name: z.string().nullable(),
  delivery_contact_person: z.string().nullable(),
  delivery_contact_phone: z.string().nullable(),
  delivery_contact_type: z.string().nullable(),
  delivery_fee: z.number(),
  delivery_fee_deduction: z.number(),
  delivery_phone: z.string().nullable(),
  delivery_suite: z.string().nullable(),
  estimated_delivery_time: z.string().nullable(),
  guest_count: z.int(),
  id: z.int(),
  modification_requests: z.array(OrderModificationRequestDataSchema).nullable(),
  net_payout: z.number(),
  order_items: z.array(OrderItemDataSchema).nullable(),
  order_items_count: z.int().nullable(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  partner_total: z.number(),
  payment_status: PaymentStatusSchema,
  requested_date: z.string(),
  requested_time: z.string(),
  setup_for_me: z.boolean(),
  special_instructions: z.string().nullable(),
  status: OrderStatusSchema,
  store: StoreSummarySchema.nullable(),
  subtotal: z.number(),
  tax: z.number(),
  tax_deduction: z.number(),
  timeline: z.array(OrderLedgerEntryDtoSchema).nullable(),
  tip: z.number(),
  total: z.number(),
  updated_at: z.string().nullable(),
  user: OrderRequesterSummarySchema.nullable()
})

export type PartnerOrderData = z.output<typeof PartnerOrderDataSchema>

/**
 * PartnerOrderResource
 */
export const PartnerOrderResourceSchema = z.object({
  acceptance_deadline: z.string().nullable(),
  actual_delivery_time: z.string().nullable(),
  beo_agreement_url: z.string().nullable(),
  beo_invoice_url: z.string().nullable(),
  can_be_accepted: z.boolean(),
  can_be_completed: z.boolean(),
  can_be_declined: z.boolean(),
  can_be_preparing: z.boolean(),
  can_be_ready: z.boolean(),
  created_at: z.string().nullable(),
  customer_application_fee: z.number(),
  customer_processing_fee: z.number(),
  delivery_address: z.string().nullable(),
  delivery_business_name: z.string().nullable(),
  delivery_contact_person: z.string().nullable(),
  delivery_contact_phone: z.string().nullable(),
  delivery_contact_type: z.string().nullable(),
  delivery_fee: z.number(),
  delivery_fee_deduction: z.number(),
  delivery_phone: z.string().nullable(),
  delivery_suite: z.string().nullable(),
  estimated_delivery_time: z.string().nullable(),
  guest_count: z.int(),
  id: z.int(),
  modification_requests: z.array(OrderModificationRequestResourceSchema).optional(),
  net_payout: z.number(),
  order_items: z.array(OrderItemResourceSchema).optional(),
  order_items_count: z.int().optional(),
  order_number: z.string(),
  order_type: OrderTypeSchema,
  partner_total: z.number(),
  payment_status: PaymentStatusSchema,
  requested_date: z.string(),
  requested_time: z.string(),
  setup_for_me: z.boolean(),
  special_instructions: z.string().nullable(),
  status: OrderStatusSchema,
  store: StoreSummaryResourceSchema.nullable(),
  subtotal: z.number(),
  tax: z.number(),
  tax_deduction: z.number(),
  timeline: z.array(OrderLedgerResourceSchema).optional(),
  tip: z.number(),
  total: z.number(),
  updated_at: z.string().nullable(),
  user: OrderRequesterSummaryResourceSchema.nullish()
})

export type PartnerOrderResource = z.output<typeof PartnerOrderResourceSchema>

/**
 * PublicMenuDto
 */
export const PublicMenuDtoSchema = z.strictObject({
  availability: z.string().nullable(),
  availability_code: z.string(),
  availability_message: z.string().nullable(),
  availability_mode: z.string(),
  availability_reason: z.string().nullable(),
  available_from: z.string().nullable(),
  available_until: z.string().nullable(),
  categories: z.array(MenuCategoryDtoSchema),
  categories_count: z.int(),
  created_at: z.string().nullable(),
  custom_hours: z.array(CustomHoursDtoSchema),
  description: z.string().nullable(),
  id: z.int(),
  is_available: z.boolean(),
  name: z.string(),
  order_types: z.array(z.string()),
  partner_id: z.int().nullable(),
  schedule: z.array(CustomHoursDtoSchema),
  sort_order: z.int(),
  status: z.string(),
  sync_with_store_hours: z.boolean(),
  tag_ids: z.array(z.int()),
  tags: z.array(MenuTagSummaryDtoSchema),
  type: z.string().nullable(),
  type_ids: z.array(z.int()),
  types: z.array(MenuTypeSummaryDtoSchema),
  updated_at: z.string().nullable()
})

export type PublicMenuDto = z.output<typeof PublicMenuDtoSchema>

/**
 * PublicStoreMenuCatalog
 */
export const PublicStoreMenuCatalogSchema = z.strictObject({
  menus: z.array(PublicMenuDtoSchema),
  store: StoreSummarySchema,
  total_categories: z.int(),
  total_menu_items: z.int(),
  total_menus: z.int()
})

export type PublicStoreMenuCatalog = z.output<typeof PublicStoreMenuCatalogSchema>

/**
 * StoreMenuCatalog
 */
export const StoreMenuCatalogSchema = z.strictObject({
  menus: z.array(MenuDtoSchema),
  store: StoreSummarySchema,
  total_categories: z.int(),
  total_menu_items: z.int(),
  total_menus: z.int()
})

export type StoreMenuCatalog = z.output<typeof StoreMenuCatalogSchema>

/**
 * StoreMenuItemRequest
 */
export const StoreMenuItemRequestSchema = z.object({
  customization_group_ids: z.array(z.int().gte(1)).optional(),
  customization_groups: z
    .array(
      z.object({
        id: z.int().gte(1),
        sort_order: z.int().gte(0).optional()
      })
    )
    .optional(),
  default_price: z.number().gte(0).lte(999999.99),
  description: z.string().max(65535).nullish(),
  dietary_attribute_ids: z.array(z.int().gte(1)).optional(),
  individual_packaging_available: z.boolean().optional(),
  is_available: z.boolean().optional(),
  is_featured: z.boolean().optional(),
  is_package: z.boolean().optional(),
  menu_category_id: z.int().gte(1).nullish(),
  menu_id: z.int().optional(),
  minimum_guest_count: z.int().gte(1).optional(),
  name: z.string().min(1).max(255),
  out_of_stock: z.boolean().optional(),
  photo: z.string().optional(),
  price_type: MenuItemPriceTypeSchema,
  serves_count: z
    .string()
    .regex(/^\d+(?:-\d+)?$/)
    .nullish(),
  sort_order: z.int().gte(0).optional(),
  status: MenuItemStatusSchema.optional(),
  tax_category: TaxCategoryCodeSchema,
  weight_unit: MenuItemWeightUnitSchema.nullish(),
  weight_value: z.number().gt(0).nullish()
})

export type StoreMenuItemRequest = z.output<typeof StoreMenuItemRequestSchema>

/**
 * TwoFactorChallengeRequest
 *
 * Resolves the challenged user from an encrypted challenge_token (see
 * App\Support\TwoFactorChallengeToken) instead of the vendor parent's
 * session-backed login.id/login.remember -- the login->2FA-challenge handoff
 * needs to survive a cross-site frontend/API split the same way bearer
 * tokens do post-INFRA-46. hasValidCode()/validRecoveryCode() are likewise
 * overridden to drop the vendor parent's session()->forget('login.id') calls
 * -- there is no session anywhere in this flow to forget a key from.
 */
export const TwoFactorChallengeRequestSchema = z.object({
  challenge_token: z.string().min(1),
  code: z.string().nullish(),
  recovery_code: z.string().nullish()
})

export type TwoFactorChallengeRequest = z.output<typeof TwoFactorChallengeRequestSchema>

/**
 * TwoFactorQrCode
 */
export const TwoFactorQrCodeSchema = z.strictObject({
  svg: z.string(),
  url: z.string()
})

export type TwoFactorQrCode = z.output<typeof TwoFactorQrCodeSchema>

/**
 * TwoFactorSecretKey
 */
export const TwoFactorSecretKeySchema = z.strictObject({
  secret_key: z.string()
})

export type TwoFactorSecretKey = z.output<typeof TwoFactorSecretKeySchema>

/**
 * TwoFactorTestAssistCode
 */
export const TwoFactorTestAssistCodeSchema = z.strictObject({
  code: z.string(),
  seconds_remaining: z.int()
})

export type TwoFactorTestAssistCode = z.output<typeof TwoFactorTestAssistCodeSchema>

/**
 * UpdateBrandRequest
 */
export const UpdateBrandRequestSchema = z.object({
  cover: z.string().nullish(),
  description: z.string().max(5000).nullish(),
  logo: z.string().nullish(),
  name: z.string().min(1).max(255).optional(),
  slug: z.string().min(1).max(255).optional(),
  status: z.enum(['pending', 'active', 'inactive']).optional(),
  website: z.url().max(500).nullish()
})

export type UpdateBrandRequest = z.output<typeof UpdateBrandRequestSchema>

/**
 * UpdateCartRequest
 */
export const UpdateCartRequestSchema = z.object({
  customizations: z
    .array(
      z.object({
        group_id: z.int().optional(),
        option_id: z.int().optional()
      })
    )
    .nullish(),
  guest_token: z.string().optional(),
  menu_id: z.int().nullish(),
  quantity: z.int().gte(1),
  special_instructions: z.string().max(500).nullish()
})

export type UpdateCartRequest = z.output<typeof UpdateCartRequestSchema>

/**
 * UpdateMenuCategoryRequest
 */
export const UpdateMenuCategoryRequestSchema = z.object({
  description: z.string().max(5000).nullish(),
  menu_ids: z.array(z.int()).min(1).optional(),
  name: z.string().min(1).max(255).optional(),
  status: MenuCategoryStatusSchema.nullish()
})

export type UpdateMenuCategoryRequest = z.output<typeof UpdateMenuCategoryRequestSchema>

/**
 * UpdateMenuCustomizationGroupRequest
 */
export const UpdateMenuCustomizationGroupRequestSchema = z.object({
  allow_repeated_selection: z.boolean().optional(),
  description: z.string().max(5000).nullish(),
  linked_items: z
    .array(
      z.object({
        id: z.int(),
        name: z.string().min(1)
      })
    )
    .optional(),
  max_per_option: z.string().optional(),
  max_selections: z.int().gte(1),
  max_total_selections: z.string().optional(),
  min_selections: z.int().gte(0),
  name: z.string().min(1).max(255),
  note: z.string().max(5000).nullish(),
  options: z
    .array(
      z.object({
        description: z.string().max(5000).nullish(),
        id: z.int().optional(),
        is_available: z.boolean().optional(),
        name: z.string().min(1).max(255),
        price_adjustment: z.number().gte(0).nullish(),
        sort_order: z.int().gte(0).optional()
      })
    )
    .min(1),
  selection_type: SelectionTypeSchema,
  status: CustomizationGroupStatusSchema.optional()
})

export type UpdateMenuCustomizationGroupRequest = z.output<
  typeof UpdateMenuCustomizationGroupRequestSchema
>

/**
 * UpdateMenuItemRequest
 */
export const UpdateMenuItemRequestSchema = z.object({
  customization_group_ids: z.array(z.int().gte(1)).optional(),
  customization_groups: z
    .array(
      z.object({
        id: z.int().gte(1),
        sort_order: z.int().gte(0).optional()
      })
    )
    .optional(),
  default_price: z.number().gte(0).lte(999999.99).optional(),
  description: z.string().max(65535).nullish(),
  dietary_attribute_ids: z.array(z.int().gte(1)).optional(),
  individual_packaging_available: z.boolean().optional(),
  is_available: z.boolean().optional(),
  is_featured: z.boolean().optional(),
  is_package: z.boolean().optional(),
  menu_category_id: z.int().gte(1).optional(),
  minimum_guest_count: z.int().gte(1).optional(),
  name: z.string().min(1).max(255).optional(),
  out_of_stock: z.boolean().optional(),
  photo: z.string().optional(),
  price_type: MenuItemPriceTypeSchema.optional(),
  serves_count: z
    .string()
    .regex(/^\d+(?:-\d+)?$/)
    .nullish(),
  sort_order: z.int().gte(0).optional(),
  status: MenuItemStatusSchema.optional(),
  tax_category: TaxCategoryCodeSchema.optional(),
  weight_unit: MenuItemWeightUnitSchema.nullish(),
  weight_value: z.number().gt(0).nullish()
})

export type UpdateMenuItemRequest = z.output<typeof UpdateMenuItemRequestSchema>

/**
 * UpdateMenuItemStatusRequest
 */
export const UpdateMenuItemStatusRequestSchema = z.object({
  status: MenuItemStatusSchema
})

export type UpdateMenuItemStatusRequest = z.output<typeof UpdateMenuItemStatusRequestSchema>

/**
 * UpdateMenuOverviewRequest
 */
export const UpdateMenuOverviewRequestSchema = z.object({
  categories: z
    .array(
      z.object({
        category_id: z.int(),
        items: z
          .array(
            z.object({
              item_id: z.int(),
              order: z.int().gte(0),
              price: z.number().gte(0)
            })
          )
          .optional(),
        order: z.int().gte(0)
      })
    )
    .min(1)
})

export type UpdateMenuOverviewRequest = z.output<typeof UpdateMenuOverviewRequestSchema>

/**
 * UpdateMenuRequest
 */
export const UpdateMenuRequestSchema = z.object({
  availability: MenuAvailabilitySchema.nullish(),
  availability_mode: MenuAvailabilityModeSchema.nullish(),
  available_from: z.iso.date().nullish(),
  available_until: z.iso.date().nullish(),
  custom_hours: z
    .array(
      z.object({
        day_of_week: DayOfWeekSchema.optional(),
        end_time: z
          .string()
          .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
          .nullish(),
        is_enabled: z.boolean().optional(),
        start_time: z
          .string()
          .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
          .nullish()
      })
    )
    .nullish(),
  description: z.string().max(500).nullish(),
  menu_type_ids: z.array(z.int()).optional(),
  name: z.string().min(1).max(255).optional(),
  partner_id: z.string().optional(),
  schedule: z
    .array(
      z.object({
        day_of_week: DayOfWeekSchema.optional(),
        end_time: z
          .string()
          .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
          .optional(),
        is_enabled: z.boolean().optional(),
        start_time: z
          .string()
          .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
          .optional()
      })
    )
    .nullish(),
  sort_order: z.int().gte(0).nullish(),
  status: MenuStatusSchema.nullish(),
  store_id: z.string().optional(),
  store_ids: z.array(z.int()).optional(),
  sync_with_store_hours: z.boolean().optional(),
  tag_ids: z.array(z.int()).optional(),
  tags: z.array(z.string()).optional(),
  type_ids: z.array(z.int()).optional(),
  types: z.array(z.string()).optional()
})

export type UpdateMenuRequest = z.output<typeof UpdateMenuRequestSchema>

/**
 * UpdateMenuStatusRequest
 */
export const UpdateMenuStatusRequestSchema = z.object({
  status: MenuStatusSchema
})

export type UpdateMenuStatusRequest = z.output<typeof UpdateMenuStatusRequestSchema>

/**
 * UpdatePartnerRequest
 */
export const UpdatePartnerRequestSchema = z.object({
  description: z.string().max(5000).nullish(),
  gratuity_percentage: z.number().gte(18).lte(25).nullish(),
  legal_entity_type: z
    .enum([
      'sole_proprietorship',
      'single_member_llc',
      'multi_member_llc',
      'partnership',
      'private_corporation',
      'public_corporation',
      'nonprofit'
    ])
    .optional(),
  name: z.string().min(1).max(255).optional(),
  number_of_locations: PartnerLocationRangeSchema.nullish(),
  partner_type: PartnerBusinessTypeSchema.optional()
})

export type UpdatePartnerRequest = z.output<typeof UpdatePartnerRequestSchema>

/**
 * UpdatePasswordRequest
 */
export const UpdatePasswordRequestSchema = z.object({
  current_password: z.string().min(1),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    )
})

export type UpdatePasswordRequest = z.output<typeof UpdatePasswordRequestSchema>

/**
 * UpdateStatusRequest
 */
export const UpdateStatusRequestSchema = z.object({
  status: OrderStatusSchema
})

export type UpdateStatusRequest = z.output<typeof UpdateStatusRequestSchema>

/**
 * UpdateStoreDetailsRequest
 *
 * Step 1: Store Details
 * - Basic Information (name, description, optional brand_id)
 * - Contact Information (phone, email via contacts table, website on store)
 * - Address (address, city, state, zip).
 */
export const UpdateStoreDetailsRequestSchema = z.object({
  address: z.string().max(500).nullish(),
  brand_id: z.int().nullish(),
  city: z.string().max(255).nullish(),
  coordinates: z
    .array(
      z.object({
        latitude: z.number().gte(-90).lte(90),
        longitude: z.number().gte(-180).lte(180)
      })
    )
    .max(1)
    .optional(),
  cover: z.string().nullish(),
  description: z.string().max(5000).nullish(),
  email: z.email().max(255).nullish(),
  enable_google_reviews: z.boolean().optional(),
  google_places_address: z.string().max(500).nullish(),
  logo: z.string().nullish(),
  name: z.string().min(1).max(255).optional(),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .optional(),
  state: z.string().max(100).nullish(),
  website: z.url().max(500).nullish(),
  zip: z.string().max(20).nullish()
})

export type UpdateStoreDetailsRequest = z.output<typeof UpdateStoreDetailsRequestSchema>

/**
 * UpdateStoreLeadTimeRequest
 *
 * Step 5: Lead Time
 * The minimum advance notice required for new orders.
 * - same_day: I accept same day orders
 * - day_before: I need to know the day before
 * - multiple_days: I need multiple days' notice.
 */
export const UpdateStoreLeadTimeRequestSchema = z.object({
  day_before_cutoff_time: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
    .nullish(),
  lead_time_hours: z.number().gte(0).lte(168).nullish(),
  lead_time_type: LeadTimeTypeSchema.optional(),
  multiple_days_notice: z.int().gte(0).lte(30).nullish()
})

export type UpdateStoreLeadTimeRequest = z.output<typeof UpdateStoreLeadTimeRequestSchema>

/**
 * UpdateStoreMenuOrderRequest
 */
export const UpdateStoreMenuOrderRequestSchema = z.object({
  menus: z
    .array(
      z.object({
        menu_id: z.int(),
        order: z.int().gte(1)
      })
    )
    .min(1)
})

export type UpdateStoreMenuOrderRequest = z.output<typeof UpdateStoreMenuOrderRequestSchema>

/**
 * UpdateStoreOperatingHoursRequest
 *
 * Step 3: Service hours
 * One weekly schedule shared by Group Dining and Pickup: opening and closing times for each day.
 */
export const UpdateStoreOperatingHoursRequestSchema = z.object({
  operating_hours: z
    .array(
      z.object({
        close_time: z
          .string()
          .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
          .nullish(),
        day_of_week: DayOfWeekSchema,
        is_open: z.boolean(),
        open_time: z
          .string()
          .regex(/^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/)
          .nullish()
      })
    )
    .min(1)
})

export type UpdateStoreOperatingHoursRequest = z.output<
  typeof UpdateStoreOperatingHoursRequestSchema
>

/**
 * UpdateStorePricingRequest
 *
 * Pricing & Fees
 * Configure delivery fees and minimum orders for your store.
 */
export const UpdateStorePricingRequestSchema = z.object({
  delivery_fee: z.number().gte(0).optional(),
  minimum_order: z.number().gte(0).optional()
})

export type UpdateStorePricingRequest = z.output<typeof UpdateStorePricingRequestSchema>

/**
 * UpdateStoreServicesRequest
 *
 * Service Availability
 * Configure which services your store offers and delivery settings.
 */
export const UpdateStoreServicesRequestSchema = z.object({
  delivery_available: z.boolean().optional(),
  delivery_radius: z.number().gte(0).lte(1000).nullish(),
  dine_in_available: z.boolean().optional(),
  pickup_available: z.boolean().optional(),
  pickup_instructions: z.string().max(2000).nullish()
})

export type UpdateStoreServicesRequest = z.output<typeof UpdateStoreServicesRequestSchema>

/**
 * UpdateStoreStatusRequest
 */
export const UpdateStoreStatusRequestSchema = z.object({
  status: StoreStatusSchema
})

export type UpdateStoreStatusRequest = z.output<typeof UpdateStoreStatusRequestSchema>

/**
 * UpdateStoreTemporaryClosuresRequest
 */
export const UpdateStoreTemporaryClosuresRequestSchema = z.object({
  temporary_closures: z
    .array(
      z.object({
        ends_at: z.iso.datetime({ offset: true }),
        id: z.int().nullish(),
        starts_at: z.iso.datetime({ offset: true })
      })
    )
    .min(1)
})

export type UpdateStoreTemporaryClosuresRequest = z.output<
  typeof UpdateStoreTemporaryClosuresRequestSchema
>

/**
 * UpdateStoreVenueRequest
 *
 * The store's Venue, saved as one unit: at least one cuisine category, the venue tags (occasions,
 * amenities, parking; every tag is optional, so an empty set is valid, and each selected id must be
 * an active tag of the closed {@see TagGroup} vocabulary) and the seating capacity. Every part is
 * validated before any of it is written.
 */
export const UpdateStoreVenueRequestSchema = z.object({
  category_ids: z.array(z.int()).min(1),
  seating_capacity: z.int().gte(1).lte(100000),
  tag_ids: z.array(z.int())
})

export type UpdateStoreVenueRequest = z.output<typeof UpdateStoreVenueRequestSchema>

/**
 * UserAccessCapabilities
 */
export const UserAccessCapabilitiesSchema = z.strictObject({
  can_manage_partner: z.boolean(),
  can_manage_stores: z.boolean(),
  can_use_consumer_portal: z.boolean()
})

export type UserAccessCapabilities = z.output<typeof UserAccessCapabilitiesSchema>

/**
 * UserAgreementTerms
 */
export const UserAgreementTermsSchema = z.strictObject({
  clauses: z.array(LegalClauseSchema),
  preamble: z.string(),
  title: z.string(),
  version: z.string()
})

export type UserAgreementTerms = z.output<typeof UserAgreementTermsSchema>

/**
 * AcceptedPrivacyPolicy
 */
export const AcceptedPrivacyPolicySchema = z.strictObject({
  accepted_at: z.string(),
  created_at: z.string(),
  current_terms_version: z.string(),
  effective_at: z.string(),
  id: z.string(),
  signatory: LegalAgreementSignatorySchema,
  status: z.literal('accepted'),
  terms: UserAgreementTermsSchema,
  type: z.literal('privacy_policy'),
  user: LegalAgreementUserSchema
})

export type AcceptedPrivacyPolicy = z.output<typeof AcceptedPrivacyPolicySchema>

/**
 * AcceptedTermsAndConditions
 */
export const AcceptedTermsAndConditionsSchema = z.strictObject({
  accepted_at: z.string(),
  created_at: z.string(),
  current_terms_version: z.string(),
  effective_at: z.string(),
  id: z.string(),
  signatory: LegalAgreementSignatorySchema,
  status: z.literal('accepted'),
  terms: UserAgreementTermsSchema,
  type: z.literal('terms_and_conditions'),
  user: LegalAgreementUserSchema
})

export type AcceptedTermsAndConditions = z.output<typeof AcceptedTermsAndConditionsSchema>

/**
 * CurrentLegalTerms
 */
export const CurrentLegalTermsSchema = z.strictObject({
  terms: UserAgreementTermsSchema,
  type: LegalTermsTypeSchema
})

export type CurrentLegalTerms = z.output<typeof CurrentLegalTermsSchema>

/**
 * PendingPrivacyPolicy
 */
export const PendingPrivacyPolicySchema = z.strictObject({
  created_at: z.string(),
  id: z.string(),
  status: z.literal('pending'),
  terms: UserAgreementTermsSchema,
  type: z.literal('privacy_policy'),
  user: LegalAgreementUserSchema
})

export type PendingPrivacyPolicy = z.output<typeof PendingPrivacyPolicySchema>

/**
 * PendingTermsAndConditions
 */
export const PendingTermsAndConditionsSchema = z.strictObject({
  created_at: z.string(),
  id: z.string(),
  status: z.literal('pending'),
  terms: UserAgreementTermsSchema,
  type: z.literal('terms_and_conditions'),
  user: LegalAgreementUserSchema
})

export type PendingTermsAndConditions = z.output<typeof PendingTermsAndConditionsSchema>

/**
 * SupersededPrivacyPolicy
 */
export const SupersededPrivacyPolicySchema = z.strictObject({
  accepted_at: z.string(),
  created_at: z.string(),
  effective_at: z.string(),
  id: z.string(),
  signatory: LegalAgreementSignatorySchema,
  status: z.literal('superseded'),
  superseded_at: z.string(),
  terms: UserAgreementTermsSchema,
  type: z.literal('privacy_policy'),
  user: LegalAgreementUserSchema
})

export type SupersededPrivacyPolicy = z.output<typeof SupersededPrivacyPolicySchema>

/**
 * SupersededTermsAndConditions
 */
export const SupersededTermsAndConditionsSchema = z.strictObject({
  accepted_at: z.string(),
  created_at: z.string(),
  effective_at: z.string(),
  id: z.string(),
  signatory: LegalAgreementSignatorySchema,
  status: z.literal('superseded'),
  superseded_at: z.string(),
  terms: UserAgreementTermsSchema,
  type: z.literal('terms_and_conditions'),
  user: LegalAgreementUserSchema
})

export type SupersededTermsAndConditions = z.output<typeof SupersededTermsAndConditionsSchema>

/**
 * UnacceptedSupersededPrivacyPolicy
 */
export const UnacceptedSupersededPrivacyPolicySchema = z.strictObject({
  created_at: z.string(),
  id: z.string(),
  status: z.literal('superseded'),
  superseded_at: z.string(),
  terms: UserAgreementTermsSchema,
  type: z.literal('privacy_policy'),
  user: LegalAgreementUserSchema
})

export type UnacceptedSupersededPrivacyPolicy = z.output<
  typeof UnacceptedSupersededPrivacyPolicySchema
>

/**
 * UnacceptedSupersededTermsAndConditions
 */
export const UnacceptedSupersededTermsAndConditionsSchema = z.strictObject({
  created_at: z.string(),
  id: z.string(),
  status: z.literal('superseded'),
  superseded_at: z.string(),
  terms: UserAgreementTermsSchema,
  type: z.literal('terms_and_conditions'),
  user: LegalAgreementUserSchema
})

export type UnacceptedSupersededTermsAndConditions = z.output<
  typeof UnacceptedSupersededTermsAndConditionsSchema
>

/**
 * LegalAgreementPage
 */
export const LegalAgreementPageSchema = z.strictObject({
  agreements: z.array(
    z.union([
      PendingPartnerAgreementSchema,
      AcceptedPartnerAgreementSchema,
      SupersededPartnerAgreementSchema,
      PendingBeoAgreementSchema,
      AcceptedBeoAgreementSchema,
      PendingTermsAndConditionsSchema,
      AcceptedTermsAndConditionsSchema,
      SupersededTermsAndConditionsSchema,
      PendingPrivacyPolicySchema,
      AcceptedPrivacyPolicySchema,
      SupersededPrivacyPolicySchema,
      UnacceptedSupersededTermsAndConditionsSchema,
      UnacceptedSupersededPrivacyPolicySchema
    ])
  ),
  pagination: PaginationMetaDtoSchema
})

export type LegalAgreementPage = z.output<typeof LegalAgreementPageSchema>

/**
 * UserInvitationStatus
 */
export const UserInvitationStatusSchema = z.enum(['none', 'pending', 'accepted', 'cancelled'])

export type UserInvitationStatus = z.output<typeof UserInvitationStatusSchema>

/**
 * UserLifecycleEventType
 */
export const UserLifecycleEventTypeSchema = z.enum([
  'email_verified',
  'phone_verified',
  'two_factor_confirmed',
  'invited',
  'invite_sent',
  'invite_accepted',
  'invite_cancelled'
])

export type UserLifecycleEventType = z.output<typeof UserLifecycleEventTypeSchema>

/**
 * UserLifecycleEvent
 */
export const UserLifecycleEventSchema = z.strictObject({
  occurred_at: z.string(),
  type: UserLifecycleEventTypeSchema
})

export type UserLifecycleEvent = z.output<typeof UserLifecycleEventSchema>

/**
 * UserNotificationPreferenceData
 */
export const UserNotificationPreferenceDataSchema = z.strictObject({
  channel: NotificationChannelSchema,
  created_at: z.iso.datetime({ offset: true }).nullable(),
  id: z.int(),
  is_assigned: z.boolean(),
  is_enabled: z.boolean(),
  notification_type: NotificationTypeSchema,
  updated_at: z.iso.datetime({ offset: true }).nullable(),
  user_id: z.int()
})

export type UserNotificationPreferenceData = z.output<typeof UserNotificationPreferenceDataSchema>

/**
 * UserRole
 */
export const UserRoleSchema = z.enum([
  'super_admin',
  'admin',
  'account_owner',
  'partner_manager',
  'store_manager',
  'customer'
])

export type UserRole = z.output<typeof UserRoleSchema>

/**
 * AuditActivityResource
 */
export const AuditActivityResourceSchema = z.object({
  causer: z
    .object({
      email: z.string(),
      id: z.int(),
      name: z.string(),
      role: UserRoleSchema.nullable()
    })
    .nullable(),
  changes: z.array(AuditActivityChangeResourceSchema),
  created_at: z.string().nullable(),
  description: z.string(),
  event: z.string(),
  id: z.int(),
  log_name: z.string(),
  properties: z.array(AuditActivityPropertyResourceSchema),
  subject: z.object({
    id: z.int().nullable(),
    type: z.string()
  })
})

export type AuditActivityResource = z.output<typeof AuditActivityResourceSchema>

/**
 * DashboardRoleEntry
 */
export const DashboardRoleEntrySchema = z.strictObject({
  description: z.string(),
  id: z.int(),
  label: z.string(),
  name: UserRoleSchema,
  permissions: z.array(DashboardPermissionEntrySchema),
  permissions_count: z.int()
})

export type DashboardRoleEntry = z.output<typeof DashboardRoleEntrySchema>

/**
 * DashboardRolePermissions
 */
export const DashboardRolePermissionsSchema = z.strictObject({
  grouped: z.record(z.string(), z.array(DashboardPermissionEntryResourceSchema)),
  permissions: z.array(DashboardPermissionEntryResourceSchema),
  role: UserRoleSchema
})

export type DashboardRolePermissions = z.output<typeof DashboardRolePermissionsSchema>

/**
 * OrganizerInvitationLookup
 */
export const OrganizerInvitationLookupSchema = z.strictObject({
  email: z.string(),
  expires_minutes: z.int().nullable(),
  invitation_status: UserInvitationStatusSchema,
  invite_sent_at: z.string().nullable(),
  last_name: z.string().nullable(),
  name: z.string(),
  organizer_account: OrganizerInvitationLookupOrganizerAccountSchema,
  phone: z.string().nullable(),
  role: UserRoleSchema.nullable()
})

export type OrganizerInvitationLookup = z.output<typeof OrganizerInvitationLookupSchema>

/**
 * PartnerInvitationLookup
 */
export const PartnerInvitationLookupSchema = z.strictObject({
  email: z.string(),
  expires_minutes: z.int().nullable(),
  invitation_status: UserInvitationStatusSchema,
  invite_sent_at: z.string().nullable(),
  last_name: z.string().nullable(),
  name: z.string(),
  partner: PartnerInvitationLookupPartnerSchema,
  phone: z.string().nullable(),
  role: UserRoleSchema.nullable()
})

export type PartnerInvitationLookup = z.output<typeof PartnerInvitationLookupSchema>

/**
 * UserCreateRequest
 */
export const UserCreateRequestSchema = z.object({
  email: z.email(),
  has_custom_permissions: z.boolean().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  manage_all_stores: z.boolean().optional(),
  managed_stores: z
    .array(
      z.object({
        id: z.int(),
        name: z.string().min(1).max(255)
      })
    )
    .optional(),
  name: z.string().min(2).max(255),
  partner_id: z.int().nullish(),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  permissions: z.array(PermissionSchema).nullish(),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  roles: z.tuple([UserRoleSchema]),
  status: z.enum(['active', 'inactive'])
})

export type UserCreateRequest = z.output<typeof UserCreateRequestSchema>

/**
 * UserDto
 */
export const UserDtoSchema = z.strictObject({
  avatar: z.string(),
  broadcast_channel_identifier: z.string(),
  contacts: z.array(ContactRecordSchema),
  created_at: z.string(),
  email: z.string(),
  has_custom_permissions: z.boolean(),
  id: z.int(),
  inviter_user_ids: z.array(z.int()),
  is_organizer: z.boolean(),
  last_name: z.string(),
  lifecycle: z.array(UserLifecycleEventSchema),
  manage_all_stores: z.boolean(),
  managed_stores: z.array(StoreReferenceSchema),
  name: z.string(),
  organizer_accounts: z.array(OrganizerAccountSummarySchema),
  permissions: z.array(PermissionSchema),
  phone: z.string(),
  preferences: z.array(UserNotificationPreferenceDataSchema),
  roles: z.array(UserRoleSchema),
  status: z.string(),
  timezone: z.string(),
  two_factor_enabled: z.boolean(),
  updated_at: z.string()
})

export type UserDto = z.output<typeof UserDtoSchema>

/**
 * DashboardProfileUpdateResult
 */
export const DashboardProfileUpdateResultSchema = z.strictObject({
  email_verification_sent: z.boolean(),
  user: UserDtoSchema
})

export type DashboardProfileUpdateResult = z.output<typeof DashboardProfileUpdateResultSchema>

/**
 * IssuedPartnerRegistrationResult
 */
export const IssuedPartnerRegistrationResultSchema = z.strictObject({
  token: z.string(),
  user: UserDtoSchema
})

export type IssuedPartnerRegistrationResult = z.output<typeof IssuedPartnerRegistrationResultSchema>

/**
 * UserDirectoryPage
 */
export const UserDirectoryPageSchema = z.strictObject({
  items: z.array(UserDtoSchema),
  pagination: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  })
})

export type UserDirectoryPage = z.output<typeof UserDirectoryPageSchema>

/**
 * UserPreferencesDto
 */
export const UserPreferencesDtoSchema = z.strictObject({
  created_at: z.string(),
  email: z.string(),
  has_custom_permissions: z.boolean(),
  id: z.int(),
  inviter_user_ids: z.array(z.int()),
  last_name: z.string(),
  lifecycle: z.array(UserLifecycleEventSchema),
  manage_all_stores: z.boolean(),
  managed_stores: z.array(StoreReferenceSchema),
  name: z.string(),
  permissions: z.array(PermissionSchema),
  phone: z.string(),
  preferences: NotificationPreferenceAssignmentsSchema,
  roles: z.array(UserRoleSchema),
  status: z.string(),
  two_factor_enabled: z.boolean(),
  updated_at: z.string()
})

export type UserPreferencesDto = z.output<typeof UserPreferencesDtoSchema>

/**
 * UserStatus
 */
export const UserStatusSchema = z.enum(['active', 'invited', 'inactive'])

export type UserStatus = z.output<typeof UserStatusSchema>

/**
 * UserUpdateRequest
 */
export const UserUpdateRequestSchema = z.object({
  email: z.email(),
  has_custom_permissions: z.boolean().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  manage_all_stores: z.boolean().optional(),
  managed_stores: z
    .array(
      z.object({
        id: z.int(),
        name: z.string().min(1).max(255)
      })
    )
    .optional(),
  name: z.string().min(2).max(255),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u
    )
    .nullish(),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u
    )
    .nullish(),
  permissions: z.array(PermissionSchema).nullish(),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  roles: z.tuple([UserRoleSchema]).optional(),
  status: UserStatusSchema.optional()
})

export type UserUpdateRequest = z.output<typeof UserUpdateRequestSchema>

/**
 * MerchantOnboardingDto
 */
export const MerchantOnboardingDtoSchema = z.strictObject({
  business_type: ConnectBusinessTypeSchema,
  business_type_change: ConnectBusinessTypeChangeSchema,
  business_type_stage: ConnectAccountStageSchema,
  can_be_destroyed: z.boolean(),
  created_at: z.string().nullable(),
  deadline: z.string().nullable(),
  details_submitted: z.boolean(),
  disabled_reason: z.string().nullable(),
  external_accounts: z.array(ExternalAccountResourceSchema),
  has_external_accounts: z.boolean(),
  id: z.int(),
  payable: z
    .union([
      StoreSummaryResourceSchema,
      z.lazy((): any => PartnerSummaryResourceSchema),
      BrandSummarySchema
    ])
    .nullable(),
  payable_id: z.int(),
  payable_name: z.string(),
  payable_type: z.string(),
  payable_type_code: PayableTypeCodeSchema,
  payment_account_id: z.string().nullable(),
  payment_onboarding_completed: z.boolean(),
  payout_enabled: z.boolean(),
  status: MerchantAccountStatusSchema,
  updated_at: z.string().nullable()
})

export type MerchantOnboardingDto = z.output<typeof MerchantOnboardingDtoSchema>

/**
 * MerchantOnboardingWithChildrenDto
 */
export const MerchantOnboardingWithChildrenDtoSchema = z.strictObject({
  business_type: ConnectBusinessTypeSchema,
  business_type_change: ConnectBusinessTypeChangeSchema,
  business_type_stage: ConnectAccountStageSchema,
  can_be_destroyed: z.boolean(),
  children: z.array(MerchantOnboardingDtoSchema),
  created_at: z.string().nullable(),
  deadline: z.string().nullable(),
  details_submitted: z.boolean(),
  disabled_reason: z.string().nullable(),
  external_accounts: z.array(ExternalAccountResourceSchema),
  has_external_accounts: z.boolean(),
  id: z.int(),
  payable: z
    .union([
      StoreSummaryResourceSchema,
      z.lazy((): any => PartnerSummaryResourceSchema),
      BrandSummarySchema
    ])
    .nullable(),
  payable_id: z.int(),
  payable_name: z.string(),
  payable_type: z.string(),
  payable_type_code: PayableTypeCodeSchema,
  payment_account_id: z.string().nullable(),
  payment_onboarding_completed: z.boolean(),
  payout_enabled: z.boolean(),
  status: MerchantAccountStatusSchema,
  updated_at: z.string().nullable()
})

export type MerchantOnboardingWithChildrenDto = z.output<
  typeof MerchantOnboardingWithChildrenDtoSchema
>

/**
 * PartnerSummaryDto
 */
export const PartnerSummaryDtoSchema = z.strictObject({
  deleted_at: z.string().nullable(),
  description: z.string().nullable(),
  gratuity_percentage: z.number(),
  has_custom_gratuity_percentage: z.boolean(),
  id: z.int(),
  legal_entity_type: PartnerLegalEntityTypeSchema,
  merchant_onboardings: z.array(MerchantOnboardingDtoSchema),
  name: z.string(),
  partner_type: PartnerBusinessTypeSchema,
  payment_account_id: z.string().nullable(),
  payment_onboarding_completed: z.boolean(),
  payout_enabled: z.boolean(),
  selected_services: z.array(z.string()),
  status: PartnerStatusSchema
})

export type PartnerSummaryDto = z.output<typeof PartnerSummaryDtoSchema>

/**
 * PartnerSummaryResource
 */
export const PartnerSummaryResourceSchema = z.object({
  deleted_at: z.string().nullable(),
  description: z.string().nullable(),
  gratuity_percentage: z.number(),
  has_custom_gratuity_percentage: z.boolean(),
  id: z.int(),
  legal_entity_type: PartnerLegalEntityTypeSchema,
  merchant_onboardings: z.array(MerchantOnboardingDtoSchema),
  name: z.string(),
  partner_type: PartnerBusinessTypeSchema,
  payment_account_id: z.string().nullable(),
  payment_onboarding_completed: z.boolean(),
  payout_enabled: z.boolean(),
  selected_services: z.array(z.string()),
  status: PartnerStatusSchema
})

export type PartnerSummaryResource = z.output<typeof PartnerSummaryResourceSchema>

/**
 * UserAccess
 */
export const UserAccessSchema = z.strictObject({
  capabilities: UserAccessCapabilitiesSchema,
  context: z.lazy((): any => UserAccessContextSchema),
  partner_onboarding_state: PartnerOnboardingStateSchema,
  permissions: z.array(PermissionSchema)
})

export type UserAccess = z.output<typeof UserAccessSchema>

/**
 * UserAccessContext
 */
export const UserAccessContextSchema = z.strictObject({
  partner: PartnerSummaryDtoSchema.nullable(),
  stores: z.array(StoreSummarySchema)
})

export type UserAccessContext = z.output<typeof UserAccessContextSchema>

export const PasswordResetSendResetLinkRequestSchema = ForgotPasswordRequestSchema

export type PasswordResetSendResetLinkRequest = z.output<
  typeof PasswordResetSendResetLinkRequestSchema
>

export const PasswordResetSendResetLinkSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PasswordResetSendResetLinkSuccess = z.output<
  typeof PasswordResetSendResetLinkSuccessSchema
>

export const AuthLoginRequestSchema = LoginRequestSchema

export type AuthLoginRequest = z.output<typeof AuthLoginRequestSchema>

export const AuthLoginSuccessSchema = z.union([
  z.strictObject({
    data: LoginResultWithoutTokenSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: LoginResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: LoginChallengeResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type AuthLoginSuccess = z.output<typeof AuthLoginSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const AuthLogoutRequestSchema = z.record(z.string(), z.unknown())

export type AuthLogoutRequest = z.output<typeof AuthLogoutRequestSchema>

export const AuthLogoutSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type AuthLogoutSuccess = z.output<typeof AuthLogoutSuccessSchema>

export const PasswordResetResetRequestSchema = ResetPasswordRequestSchema

export type PasswordResetResetRequest = z.output<typeof PasswordResetResetRequestSchema>

export const PasswordResetResetSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PasswordResetResetSuccess = z.output<typeof PasswordResetResetSuccessSchema>

export const BrandsIndexQuerySchema = z.object({
  partner_id: z.int().gte(1).optional(),
  status: z.union([z.string(), z.enum(['all'])]).optional(),
  search: z.string().optional()
})

export type BrandsIndexQuery = z.output<typeof BrandsIndexQuerySchema>

export const BrandsIndexSuccessSchema = z.strictObject({
  data: BrandDetailPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsIndexSuccess = z.output<typeof BrandsIndexSuccessSchema>

export const BrandsStoreRequestSchema = CreateBrandRequestSchema

export type BrandsStoreRequest = z.output<typeof BrandsStoreRequestSchema>

export const BrandsStoreSuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsStoreSuccess = z.output<typeof BrandsStoreSuccessSchema>

export const BrandsPublicIndexQuerySchema = z.object({
  search: z.string().optional(),
  per_page: z.string().optional()
})

export type BrandsPublicIndexQuery = z.output<typeof BrandsPublicIndexQuerySchema>

export const BrandsPublicIndexSuccessSchema = z.strictObject({
  data: PublicBrandPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsPublicIndexSuccess = z.output<typeof BrandsPublicIndexSuccessSchema>

export const BrandsPublicShowPathSchema = z.object({
  slug: z.string()
})

export type BrandsPublicShowPath = z.output<typeof BrandsPublicShowPathSchema>

export const BrandsPublicShowSuccessSchema = z.strictObject({
  data: BrandPublicRecordSchema.nullable(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsPublicShowSuccess = z.output<typeof BrandsPublicShowSuccessSchema>

export const BrandsPublicStoreSearchPathSchema = z.object({
  slug: z.string()
})

export type BrandsPublicStoreSearchPath = z.output<typeof BrandsPublicStoreSearchPathSchema>

export const BrandsPublicStoreSearchQuerySchema = z.object({
  q: z.string().min(1).max(255),
  lat: z.number().gte(-90).lte(90).nullish(),
  lng: z.number().gte(-180).lte(180).nullish(),
  bbox: z
    .string()
    .regex(/^-?\d+\.?\d*,-?\d+\.?\d*,-?\d+\.?\d*,-?\d+\.?\d*$/)
    .nullish(),
  place_type: z.enum(['address', 'region', 'place', 'neighborhood', 'postcode']).nullish()
})

export type BrandsPublicStoreSearchQuery = z.output<typeof BrandsPublicStoreSearchQuerySchema>

export const BrandsPublicStoreSearchSuccessSchema = z.strictObject({
  data: BrandStoreSearchPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsPublicStoreSearchSuccess = z.output<typeof BrandsPublicStoreSearchSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const BrandsDestroyRequestSchema = z.record(z.string(), z.unknown())

export type BrandsDestroyRequest = z.output<typeof BrandsDestroyRequestSchema>

export const BrandsDestroyPathSchema = z.object({
  identifier: z.string()
})

export type BrandsDestroyPath = z.output<typeof BrandsDestroyPathSchema>

/**
 * No content
 */
export const BrandsDestroySuccessSchema = z.void()

export type BrandsDestroySuccess = z.output<typeof BrandsDestroySuccessSchema>

export const BrandsShowPathSchema = z.object({
  identifier: z.string()
})

export type BrandsShowPath = z.output<typeof BrandsShowPathSchema>

export const BrandsShowSuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsShowSuccess = z.output<typeof BrandsShowSuccessSchema>

export const BrandsUpdatePostRequestSchema = UpdateBrandRequestSchema

export type BrandsUpdatePostRequest = z.output<typeof BrandsUpdatePostRequestSchema>

export const BrandsUpdatePostPathSchema = z.object({
  identifier: z.string()
})

export type BrandsUpdatePostPath = z.output<typeof BrandsUpdatePostPathSchema>

export const BrandsUpdatePostSuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsUpdatePostSuccess = z.output<typeof BrandsUpdatePostSuccessSchema>

export const BrandsUpdateRequestSchema = UpdateBrandRequestSchema

export type BrandsUpdateRequest = z.output<typeof BrandsUpdateRequestSchema>

export const BrandsUpdatePathSchema = z.object({
  identifier: z.string()
})

export type BrandsUpdatePath = z.output<typeof BrandsUpdatePathSchema>

export const BrandsUpdateSuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type BrandsUpdateSuccess = z.output<typeof BrandsUpdateSuccessSchema>

/**
 * Private or presence channel authorization request.
 */
export const BroadcastAuthenticateRequestSchema = z.object({
  channel_name: z.string(),
  socket_id: z.string()
})

export type BroadcastAuthenticateRequest = z.output<typeof BroadcastAuthenticateRequestSchema>

/**
 * Broadcast channel authorization.
 */
export const BroadcastAuthenticateSuccessSchema = z.object({
  auth: z.string(),
  channel_data: z.string().optional()
})

export type BroadcastAuthenticateSuccess = z.output<typeof BroadcastAuthenticateSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const CartClearRequestSchema = z.record(z.string(), z.unknown())

export type CartClearRequest = z.output<typeof CartClearRequestSchema>

export const CartClearHeaderSchema = z.object({
  'X-Guest-Token': z.string().optional()
})

export type CartClearHeader = z.output<typeof CartClearHeaderSchema>

export const CartClearQuerySchema = z.object({
  store_id: z.string().optional(),
  store_slug: z.string().optional(),
  guest_token: z.string().optional()
})

export type CartClearQuery = z.output<typeof CartClearQuerySchema>

export const CartClearSuccessSchema = z.strictObject({
  data: z.object({
    deleted_count: z.int()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type CartClearSuccess = z.output<typeof CartClearSuccessSchema>

export const CartIndexHeaderSchema = z.object({
  'X-Guest-Token': z.string().optional()
})

export type CartIndexHeader = z.output<typeof CartIndexHeaderSchema>

export const CartIndexQuerySchema = z.object({
  guest_token: z.string().optional(),
  order_type: OrderTypeSchema,
  store_id: z.string().optional(),
  store_slug: z.string().optional()
})

export type CartIndexQuery = z.output<typeof CartIndexQuerySchema>

export const CartIndexSuccessSchema = z.strictObject({
  data: CartIndexSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type CartIndexSuccess = z.output<typeof CartIndexSuccessSchema>

export const CartStoreRequestSchema = StoreCartRequestSchema

export type CartStoreRequest = z.output<typeof CartStoreRequestSchema>

export const CartStoreHeaderSchema = z.object({
  'X-Guest-Token': z.string().optional()
})

export type CartStoreHeader = z.output<typeof CartStoreHeaderSchema>

export const CartStoreQuerySchema = z.object({
  guest_token: z.string().optional()
})

export type CartStoreQuery = z.output<typeof CartStoreQuerySchema>

export const CartStoreSuccessSchema = z.union([
  z.strictObject({
    data: CartItemViewSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: CartItemViewSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type CartStoreSuccess = z.output<typeof CartStoreSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const CartDestroyRequestSchema = z.record(z.string(), z.unknown())

export type CartDestroyRequest = z.output<typeof CartDestroyRequestSchema>

export const CartDestroyHeaderSchema = z.object({
  'X-Guest-Token': z.string().optional()
})

export type CartDestroyHeader = z.output<typeof CartDestroyHeaderSchema>

export const CartDestroyQuerySchema = z.object({
  item_id: z.int(),
  guest_token: z.string().optional()
})

export type CartDestroyQuery = z.output<typeof CartDestroyQuerySchema>

/**
 * No content
 */
export const CartDestroySuccessSchema = z.void()

export type CartDestroySuccess = z.output<typeof CartDestroySuccessSchema>

export const CartMigrateGuestCartRequestSchema = z.object({
  guest_token: z.string().optional()
})

export type CartMigrateGuestCartRequest = z.output<typeof CartMigrateGuestCartRequestSchema>

export const CartMigrateGuestCartSuccessSchema = z.strictObject({
  data: GuestCartMigrationSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type CartMigrateGuestCartSuccess = z.output<typeof CartMigrateGuestCartSuccessSchema>

export const CartSummaryQuerySchema = z.object({
  order_type: OrderTypeSchema,
  store_id: z.string().optional(),
  store_slug: z.string().optional()
})

export type CartSummaryQuery = z.output<typeof CartSummaryQuerySchema>

export const CartSummarySuccessSchema = z.strictObject({
  data: CartSummarySchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type CartSummarySuccess = z.output<typeof CartSummarySuccessSchema>

export const CartUpdateRequestSchema = UpdateCartRequestSchema

export type CartUpdateRequest = z.output<typeof CartUpdateRequestSchema>

export const CartUpdateHeaderSchema = z.object({
  'X-Guest-Token': z.string().optional()
})

export type CartUpdateHeader = z.output<typeof CartUpdateHeaderSchema>

export const CartUpdatePathSchema = z.object({
  cartItem: z.int()
})

export type CartUpdatePath = z.output<typeof CartUpdatePathSchema>

export const CartUpdateQuerySchema = z.object({
  guest_token: z.string().optional()
})

export type CartUpdateQuery = z.output<typeof CartUpdateQuerySchema>

export const CartUpdateSuccessSchema = z.strictObject({
  data: CartItemViewSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type CartUpdateSuccess = z.output<typeof CartUpdateSuccessSchema>

export const CheckoutCheckoutRequestSchema = CheckoutRequestSchema

export type CheckoutCheckoutRequest = z.output<typeof CheckoutCheckoutRequestSchema>

export const CheckoutCheckoutSuccessSchema = z.strictObject({
  data: z.object({
    order: CustomerOrderDataSchema,
    store_auto_favorited: z.boolean()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type CheckoutCheckoutSuccess = z.output<typeof CheckoutCheckoutSuccessSchema>

export const ClientLogsStoreRequestSchema = ClientLogRequestSchema

export type ClientLogsStoreRequest = z.output<typeof ClientLogsStoreRequestSchema>

/**
 * No content
 */
export const ClientLogsStoreSuccessSchema = z.void()

export type ClientLogsStoreSuccess = z.output<typeof ClientLogsStoreSuccessSchema>

export const ContactLeadStoreRequestSchema2 = ContactLeadStoreRequestSchema

export type ContactLeadStoreRequest2 = z.output<typeof ContactLeadStoreRequestSchema2>

export const ContactLeadStoreSuccessSchema = z.strictObject({
  data: ContactLeadReceiptSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type ContactLeadStoreSuccess = z.output<typeof ContactLeadStoreSuccessSchema>

/**
 * Either a legacy report-uri `csp-report` object, or a Reporting API batch (array) or single report object.
 */
export const CspReportRequestSchema = z.union([
  z.object({
    'csp-report': z.object({
      'blocked-uri': z.string(),
      'column-number': z.int().nullish(),
      'document-uri': z.string(),
      'effective-directive': z.string().optional(),
      'line-number': z.int().nullish(),
      'original-policy': z.string().optional(),
      referrer: z.string().nullish(),
      'source-file': z.string().nullish(),
      'status-code': z.int().nullish(),
      'violated-directive': z.string()
    })
  }),
  z.array(
    z.object({
      age: z.int().optional(),
      body: z.object({
        blockedURL: z.string().nullish(),
        columnNumber: z.int().nullish(),
        disposition: z.string().optional(),
        documentURL: z.string().optional(),
        effectiveDirective: z.string().optional(),
        lineNumber: z.int().nullish(),
        originalPolicy: z.string().optional(),
        referrer: z.string().nullish(),
        sourceFile: z.string().nullish(),
        statusCode: z.int().nullish()
      }),
      type: z.literal('csp-violation'),
      url: z.string().optional(),
      user_agent: z.string().optional()
    })
  ),
  z.object({
    age: z.int().optional(),
    body: z.object({
      blockedURL: z.string().nullish(),
      columnNumber: z.int().nullish(),
      disposition: z.string().optional(),
      documentURL: z.string().optional(),
      effectiveDirective: z.string().optional(),
      lineNumber: z.int().nullish(),
      originalPolicy: z.string().optional(),
      referrer: z.string().nullish(),
      sourceFile: z.string().nullish(),
      statusCode: z.int().nullish()
    }),
    type: z.literal('csp-violation'),
    url: z.string().optional(),
    user_agent: z.string().optional()
  })
])

export type CspReportRequest = z.output<typeof CspReportRequestSchema>

/**
 * No content
 */
export const CspReportSuccessSchema = z.void()

export type CspReportSuccess = z.output<typeof CspReportSuccessSchema>

export const DashboardDashboardQuerySchema = z.object({
  period: z.string().optional()
})

export type DashboardDashboardQuery = z.output<typeof DashboardDashboardQuerySchema>

export const DashboardDashboardSuccessSchema = z.strictObject({
  data: DashboardSummarySchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardDashboardSuccess = z.output<typeof DashboardDashboardSuccessSchema>

export const AuditLogAccountAuditQuerySchema = z.object({
  per_page: z.string().optional()
})

export type AuditLogAccountAuditQuery = z.output<typeof AuditLogAccountAuditQuerySchema>

/**
 * Array of `AuditActivityResource`
 */
export const AuditLogAccountAuditSuccessSchema = z.object({
  data: z.array(AuditActivityResourceSchema),
  meta: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  })
})

export type AuditLogAccountAuditSuccess = z.output<typeof AuditLogAccountAuditSuccessSchema>

export const DashboardBrandsQuerySchema = z.object({
  partner_id: z.int().gte(1).optional(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(100).nullish(),
  name: z.string().max(255).nullish(),
  status: z.union([BrandStatusSchema, z.enum(['all'])]).optional()
})

export type DashboardBrandsQuery = z.output<typeof DashboardBrandsQuerySchema>

export const DashboardBrandsSuccessSchema = z.strictObject({
  data: BrandDetailPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardBrandsSuccess = z.output<typeof DashboardBrandsSuccessSchema>

export const DashboardCreateBrandRequestSchema = CreateBrandRequestSchema

export type DashboardCreateBrandRequest = z.output<typeof DashboardCreateBrandRequestSchema>

export const DashboardCreateBrandSuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('brand')
  }),
  success: z.literal(true)
})

export type DashboardCreateBrandSuccess = z.output<typeof DashboardCreateBrandSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const DashboardDeleteBrandRequestSchema = z.record(z.string(), z.unknown())

export type DashboardDeleteBrandRequest = z.output<typeof DashboardDeleteBrandRequestSchema>

export const DashboardDeleteBrandPathSchema = z.object({
  identifier: z.string()
})

export type DashboardDeleteBrandPath = z.output<typeof DashboardDeleteBrandPathSchema>

export const DashboardDeleteBrandSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('brand')
  }),
  success: z.literal(true)
})

export type DashboardDeleteBrandSuccess = z.output<typeof DashboardDeleteBrandSuccessSchema>

export const DashboardBrandDetailsPathSchema = z.object({
  identifier: z.string()
})

export type DashboardBrandDetailsPath = z.output<typeof DashboardBrandDetailsPathSchema>

export const DashboardBrandDetailsSuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardBrandDetailsSuccess = z.output<typeof DashboardBrandDetailsSuccessSchema>

export const DashboardUpdateBrand2RequestSchema = UpdateBrandRequestSchema

export type DashboardUpdateBrand2Request = z.output<typeof DashboardUpdateBrand2RequestSchema>

export const DashboardUpdateBrand2PathSchema = z.object({
  identifier: z.string()
})

export type DashboardUpdateBrand2Path = z.output<typeof DashboardUpdateBrand2PathSchema>

export const DashboardUpdateBrand2SuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('brand')
  }),
  success: z.literal(true)
})

export type DashboardUpdateBrand2Success = z.output<typeof DashboardUpdateBrand2SuccessSchema>

export const DashboardUpdateBrand1RequestSchema = UpdateBrandRequestSchema

export type DashboardUpdateBrand1Request = z.output<typeof DashboardUpdateBrand1RequestSchema>

export const DashboardUpdateBrand1PathSchema = z.object({
  identifier: z.string()
})

export type DashboardUpdateBrand1Path = z.output<typeof DashboardUpdateBrand1PathSchema>

export const DashboardUpdateBrand1SuccessSchema = z.strictObject({
  data: BrandDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('brand')
  }),
  success: z.literal(true)
})

export type DashboardUpdateBrand1Success = z.output<typeof DashboardUpdateBrand1SuccessSchema>

export const MenuCategoryPartnerIndexQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCategoryPartnerIndexQuery = z.output<typeof MenuCategoryPartnerIndexQuerySchema>

export const MenuCategoryPartnerIndexSuccessSchema = z.strictObject({
  data: MenuCategoryManagementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryPartnerIndexSuccess = z.output<typeof MenuCategoryPartnerIndexSuccessSchema>

export const MenuCategoryStoreForPartnerRequestSchema = StoreMenuCategoryRequestSchema

export type MenuCategoryStoreForPartnerRequest = z.output<
  typeof MenuCategoryStoreForPartnerRequestSchema
>

export const MenuCategoryStoreForPartnerSuccessSchema = z.strictObject({
  data: MenuCategoryManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_category')
  }),
  success: z.literal(true)
})

export type MenuCategoryStoreForPartnerSuccess = z.output<
  typeof MenuCategoryStoreForPartnerSuccessSchema
>

export const MenuCategoryFiltersSuccessSchema = z.strictObject({
  data: z.array(MenuOptionSummarySchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryFiltersSuccess = z.output<typeof MenuCategoryFiltersSuccessSchema>

export const MenuCategoryPartnerOptionsQuerySchema = z.object({
  search: z.string().max(255).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCategoryPartnerOptionsQuery = z.output<typeof MenuCategoryPartnerOptionsQuerySchema>

export const MenuCategoryPartnerOptionsSuccessSchema = z.strictObject({
  data: MenuCategoryOptionPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryPartnerOptionsSuccess = z.output<
  typeof MenuCategoryPartnerOptionsSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuCategoryDestroyForPartnerRequestSchema = z.record(z.string(), z.unknown())

export type MenuCategoryDestroyForPartnerRequest = z.output<
  typeof MenuCategoryDestroyForPartnerRequestSchema
>

export const MenuCategoryDestroyForPartnerPathSchema = z.object({
  categoryId: z.int()
})

export type MenuCategoryDestroyForPartnerPath = z.output<
  typeof MenuCategoryDestroyForPartnerPathSchema
>

/**
 * No content
 */
export const MenuCategoryDestroyForPartnerSuccessSchema = z.void()

export type MenuCategoryDestroyForPartnerSuccess = z.output<
  typeof MenuCategoryDestroyForPartnerSuccessSchema
>

export const MenuCategoryUpdateForPartnerRequestSchema = UpdateMenuCategoryRequestSchema

export type MenuCategoryUpdateForPartnerRequest = z.output<
  typeof MenuCategoryUpdateForPartnerRequestSchema
>

export const MenuCategoryUpdateForPartnerPathSchema = z.object({
  categoryId: z.int()
})

export type MenuCategoryUpdateForPartnerPath = z.output<
  typeof MenuCategoryUpdateForPartnerPathSchema
>

export const MenuCategoryUpdateForPartnerSuccessSchema = z.strictObject({
  data: MenuCategoryManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_category')
  }),
  success: z.literal(true)
})

export type MenuCategoryUpdateForPartnerSuccess = z.output<
  typeof MenuCategoryUpdateForPartnerSuccessSchema
>

export const MenuCategoryPartnerDetailPathSchema = z.object({
  categoryId: z.int()
})

export type MenuCategoryPartnerDetailPath = z.output<typeof MenuCategoryPartnerDetailPathSchema>

export const MenuCategoryPartnerDetailSuccessSchema = z.strictObject({
  data: MenuCategoryManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryPartnerDetailSuccess = z.output<
  typeof MenuCategoryPartnerDetailSuccessSchema
>

export const FavoritesIndexQuerySchema = z.object({
  per_page: z.int().gte(1).lte(100).nullish(),
  page: z.int().gte(1).nullish()
})

export type FavoritesIndexQuery = z.output<typeof FavoritesIndexQuerySchema>

export const FavoritesIndexSuccessSchema = z.strictObject({
  data: FavoriteStorePageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type FavoritesIndexSuccess = z.output<typeof FavoritesIndexSuccessSchema>

export const MenuItemPartnerIndexQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  category: z.string().max(50).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  'category_ids[]': z.array(z.string().max(50)).optional(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuItemPartnerIndexQuery = z.output<typeof MenuItemPartnerIndexQuerySchema>

export const MenuItemPartnerIndexSuccessSchema = z.strictObject({
  data: MenuItemManagementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuItemPartnerIndexSuccess = z.output<typeof MenuItemPartnerIndexSuccessSchema>

export const MenuItemStoreForPartnerRequestSchema = StoreMenuItemRequestSchema

export type MenuItemStoreForPartnerRequest = z.output<typeof MenuItemStoreForPartnerRequestSchema>

export const MenuItemStoreForPartnerSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemStoreForPartnerSuccess = z.output<typeof MenuItemStoreForPartnerSuccessSchema>

export const MenuItemPartnerCreateOptionsQuerySchema = z.object({
  menu_id: z.string().optional()
})

export type MenuItemPartnerCreateOptionsQuery = z.output<
  typeof MenuItemPartnerCreateOptionsQuerySchema
>

export const MenuItemPartnerCreateOptionsSuccessSchema = z.strictObject({
  data: MenuItemPartnerCreateOptionsDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuItemPartnerCreateOptionsSuccess = z.output<
  typeof MenuItemPartnerCreateOptionsSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuItemDestroyByItemRequestSchema = z.record(z.string(), z.unknown())

export type MenuItemDestroyByItemRequest = z.output<typeof MenuItemDestroyByItemRequestSchema>

export const MenuItemDestroyByItemPathSchema = z.object({
  itemId: z.int()
})

export type MenuItemDestroyByItemPath = z.output<typeof MenuItemDestroyByItemPathSchema>

/**
 * No content
 */
export const MenuItemDestroyByItemSuccessSchema = z.void()

export type MenuItemDestroyByItemSuccess = z.output<typeof MenuItemDestroyByItemSuccessSchema>

export const MenuItemShowPathSchema = z.object({
  itemId: z.int()
})

export type MenuItemShowPath = z.output<typeof MenuItemShowPathSchema>

export const MenuItemShowSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuItemShowSuccess = z.output<typeof MenuItemShowSuccessSchema>

export const MenuItemUpdateByItemRequestSchema = UpdateMenuItemRequestSchema

export type MenuItemUpdateByItemRequest = z.output<typeof MenuItemUpdateByItemRequestSchema>

export const MenuItemUpdateByItemPathSchema = z.object({
  itemId: z.int()
})

export type MenuItemUpdateByItemPath = z.output<typeof MenuItemUpdateByItemPathSchema>

export const MenuItemUpdateByItemSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemUpdateByItemSuccess = z.output<typeof MenuItemUpdateByItemSuccessSchema>

export const MenuItemAssignCategoryRequestSchema = AssignMenuItemCategoryRequestSchema

export type MenuItemAssignCategoryRequest = z.output<typeof MenuItemAssignCategoryRequestSchema>

export const MenuItemAssignCategoryPathSchema = z.object({
  itemId: z.int()
})

export type MenuItemAssignCategoryPath = z.output<typeof MenuItemAssignCategoryPathSchema>

export const MenuItemAssignCategorySuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemAssignCategorySuccess = z.output<typeof MenuItemAssignCategorySuccessSchema>

export const MenuItemAssignCustomizationGroupsRequestSchema =
  AssignMenuItemCustomizationGroupsRequestSchema

export type MenuItemAssignCustomizationGroupsRequest = z.output<
  typeof MenuItemAssignCustomizationGroupsRequestSchema
>

export const MenuItemAssignCustomizationGroupsPathSchema = z.object({
  itemId: z.int()
})

export type MenuItemAssignCustomizationGroupsPath = z.output<
  typeof MenuItemAssignCustomizationGroupsPathSchema
>

export const MenuItemAssignCustomizationGroupsSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemAssignCustomizationGroupsSuccess = z.output<
  typeof MenuItemAssignCustomizationGroupsSuccessSchema
>

export const MenuItemItemOptionsPathSchema = z.object({
  itemId: z.int()
})

export type MenuItemItemOptionsPath = z.output<typeof MenuItemItemOptionsPathSchema>

export const MenuItemItemOptionsSuccessSchema = z.strictObject({
  data: MenuItemLevelOptionsDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuItemItemOptionsSuccess = z.output<typeof MenuItemItemOptionsSuccessSchema>

export const MenuItemUpdateStatusByItemRequestSchema = UpdateMenuItemStatusRequestSchema

export type MenuItemUpdateStatusByItemRequest = z.output<
  typeof MenuItemUpdateStatusByItemRequestSchema
>

export const MenuItemUpdateStatusByItemPathSchema = z.object({
  itemId: z.int()
})

export type MenuItemUpdateStatusByItemPath = z.output<typeof MenuItemUpdateStatusByItemPathSchema>

export const MenuItemUpdateStatusByItemSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemUpdateStatusByItemSuccess = z.output<
  typeof MenuItemUpdateStatusByItemSuccessSchema
>

export const MenuMenusQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  status: z.union([z.string().max(50), z.enum(['all'])]).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  assignable_to_store_id: z.int().gte(1).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  per_page: z.int().gte(1).lte(100).nullish(),
  page: z.int().gte(1).nullish()
})

export type MenuMenusQuery = z.output<typeof MenuMenusQuerySchema>

export const MenuMenusSuccessSchema = z.strictObject({
  data: MenuListPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuMenusSuccess = z.output<typeof MenuMenusSuccessSchema>

export const MenuStoreRequestSchema = CreateMenuRequestSchema

export type MenuStoreRequest = z.output<typeof MenuStoreRequestSchema>

export const MenuStoreSuccessSchema = z.strictObject({
  data: MenuDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuStoreSuccess = z.output<typeof MenuStoreSuccessSchema>

export const MenuCountsSuccessSchema = z.strictObject({
  data: MenuCatalogCountsSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCountsSuccess = z.output<typeof MenuCountsSuccessSchema>

export const MenuFormOptionsSuccessSchema = z.strictObject({
  data: MenuFormOptionsSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuFormOptionsSuccess = z.output<typeof MenuFormOptionsSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuDestroyRequestSchema = z.record(z.string(), z.unknown())

export type MenuDestroyRequest = z.output<typeof MenuDestroyRequestSchema>

export const MenuDestroyPathSchema = z.object({
  menuId: z.int()
})

export type MenuDestroyPath = z.output<typeof MenuDestroyPathSchema>

/**
 * No content
 */
export const MenuDestroySuccessSchema = z.void()

export type MenuDestroySuccess = z.output<typeof MenuDestroySuccessSchema>

export const MenuMenuDetailsPathSchema = z.object({
  menuId: z.int()
})

export type MenuMenuDetailsPath = z.output<typeof MenuMenuDetailsPathSchema>

export const MenuMenuDetailsSuccessSchema = z.strictObject({
  data: MenuDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuMenuDetailsSuccess = z.output<typeof MenuMenuDetailsSuccessSchema>

export const MenuUpdateRequestSchema = UpdateMenuRequestSchema

export type MenuUpdateRequest = z.output<typeof MenuUpdateRequestSchema>

export const MenuUpdatePathSchema = z.object({
  menuId: z.int()
})

export type MenuUpdatePath = z.output<typeof MenuUpdatePathSchema>

export const MenuUpdateSuccessSchema = z.strictObject({
  data: MenuDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuUpdateSuccess = z.output<typeof MenuUpdateSuccessSchema>

export const MenuBasicPathSchema = z.object({
  menuId: z.int()
})

export type MenuBasicPath = z.output<typeof MenuBasicPathSchema>

export const MenuBasicSuccessSchema = z.strictObject({
  data: MenuBasicOverviewSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuBasicSuccess = z.output<typeof MenuBasicSuccessSchema>

export const MenuCategoryIndexPathSchema = z.object({
  menuId: z.int()
})

export type MenuCategoryIndexPath = z.output<typeof MenuCategoryIndexPathSchema>

export const MenuCategoryIndexQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCategoryIndexQuery = z.output<typeof MenuCategoryIndexQuerySchema>

export const MenuCategoryIndexSuccessSchema = z.strictObject({
  data: MenuCategoryManagementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryIndexSuccess = z.output<typeof MenuCategoryIndexSuccessSchema>

export const MenuCategoryStoreRequestSchema = StoreMenuCategoryRequestSchema

export type MenuCategoryStoreRequest = z.output<typeof MenuCategoryStoreRequestSchema>

export const MenuCategoryStorePathSchema = z.object({
  menuId: z.int()
})

export type MenuCategoryStorePath = z.output<typeof MenuCategoryStorePathSchema>

export const MenuCategoryStoreSuccessSchema = z.strictObject({
  data: MenuCategoryManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_category')
  }),
  success: z.literal(true)
})

export type MenuCategoryStoreSuccess = z.output<typeof MenuCategoryStoreSuccessSchema>

export const MenuCategoryAvailableMenusPathSchema = z.object({
  menuId: z.int()
})

export type MenuCategoryAvailableMenusPath = z.output<typeof MenuCategoryAvailableMenusPathSchema>

export const MenuCategoryAvailableMenusQuerySchema = z.object({
  search: z.string().max(255).nullish(),
  category_id: z.union([z.int(), z.enum(['all'])]).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCategoryAvailableMenusQuery = z.output<typeof MenuCategoryAvailableMenusQuerySchema>

export const MenuCategoryAvailableMenusSuccessSchema = z.strictObject({
  data: MenuAssignmentOptionPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryAvailableMenusSuccess = z.output<
  typeof MenuCategoryAvailableMenusSuccessSchema
>

export const MenuCategoryOptionsPathSchema = z.object({
  menuId: z.int()
})

export type MenuCategoryOptionsPath = z.output<typeof MenuCategoryOptionsPathSchema>

export const MenuCategoryOptionsQuerySchema = z.object({
  search: z.string().nullish(),
  search_scope: SearchScopeSchema.nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(100).nullish()
})

export type MenuCategoryOptionsQuery = z.output<typeof MenuCategoryOptionsQuerySchema>

export const MenuCategoryOptionsSuccessSchema = z.strictObject({
  data: MenuCategoryItemOptionPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryOptionsSuccess = z.output<typeof MenuCategoryOptionsSuccessSchema>

export const MenuCategorySuggestedPathSchema = z.object({
  menuId: z.int()
})

export type MenuCategorySuggestedPath = z.output<typeof MenuCategorySuggestedPathSchema>

export const MenuCategorySuggestedQuerySchema = z.object({
  'type_ids[]': z.array(z.union([z.int(), z.enum(['all'])])).optional(),
  'types[]': z.array(z.union([z.string(), z.enum(['all'])])).optional(),
  search: z.string().nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(100).nullish()
})

export type MenuCategorySuggestedQuery = z.output<typeof MenuCategorySuggestedQuerySchema>

export const MenuCategorySuggestedSuccessSchema = z.strictObject({
  data: MenuCategoryManagementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategorySuggestedSuccess = z.output<typeof MenuCategorySuggestedSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuCategoryDestroyRequestSchema = z.record(z.string(), z.unknown())

export type MenuCategoryDestroyRequest = z.output<typeof MenuCategoryDestroyRequestSchema>

export const MenuCategoryDestroyPathSchema = z.object({
  menuId: z.int(),
  categoryId: z.int()
})

export type MenuCategoryDestroyPath = z.output<typeof MenuCategoryDestroyPathSchema>

/**
 * No content
 */
export const MenuCategoryDestroySuccessSchema = z.void()

export type MenuCategoryDestroySuccess = z.output<typeof MenuCategoryDestroySuccessSchema>

export const MenuCategoryUpdateRequestSchema = UpdateMenuCategoryRequestSchema

export type MenuCategoryUpdateRequest = z.output<typeof MenuCategoryUpdateRequestSchema>

export const MenuCategoryUpdatePathSchema = z.object({
  menuId: z.int(),
  categoryId: z.int()
})

export type MenuCategoryUpdatePath = z.output<typeof MenuCategoryUpdatePathSchema>

export const MenuCategoryUpdateSuccessSchema = z.strictObject({
  data: MenuCategoryManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_category')
  }),
  success: z.literal(true)
})

export type MenuCategoryUpdateSuccess = z.output<typeof MenuCategoryUpdateSuccessSchema>

export const MenuCategoryAssignRequestSchema = AssignMenuCategoriesRequestSchema

export type MenuCategoryAssignRequest = z.output<typeof MenuCategoryAssignRequestSchema>

export const MenuCategoryAssignPathSchema = z.object({
  menuId: z.int(),
  categoryId: z.int()
})

export type MenuCategoryAssignPath = z.output<typeof MenuCategoryAssignPathSchema>

export const MenuCategoryAssignSuccessSchema = z.strictObject({
  data: z.array(MenuCategoryManagementDtoSchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_category')
  }),
  success: z.literal(true)
})

export type MenuCategoryAssignSuccess = z.output<typeof MenuCategoryAssignSuccessSchema>

export const MenuCategoryDetailPathSchema = z.object({
  menuId: z.int(),
  categoryId: z.int()
})

export type MenuCategoryDetailPath = z.output<typeof MenuCategoryDetailPathSchema>

export const MenuCategoryDetailSuccessSchema = z.strictObject({
  data: MenuCategoryDetailSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCategoryDetailSuccess = z.output<typeof MenuCategoryDetailSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuCategoryUnassignRequestSchema = z.record(z.string(), z.unknown())

export type MenuCategoryUnassignRequest = z.output<typeof MenuCategoryUnassignRequestSchema>

export const MenuCategoryUnassignPathSchema = z.object({
  menuId: z.int(),
  categoryId: z.int()
})

export type MenuCategoryUnassignPath = z.output<typeof MenuCategoryUnassignPathSchema>

export const MenuCategoryUnassignQuerySchema = z.object({
  'category_ids[]': z.array(z.int())
})

export type MenuCategoryUnassignQuery = z.output<typeof MenuCategoryUnassignQuerySchema>

export const MenuCategoryUnassignSuccessSchema = z.strictObject({
  data: z.array(MenuCategoryManagementDtoSchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_category')
  }),
  success: z.literal(true)
})

export type MenuCategoryUnassignSuccess = z.output<typeof MenuCategoryUnassignSuccessSchema>

export const MenuCustomizationGroupIndexPathSchema = z.object({
  menuId: z.int()
})

export type MenuCustomizationGroupIndexPath = z.output<typeof MenuCustomizationGroupIndexPathSchema>

export const MenuCustomizationGroupIndexQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCustomizationGroupIndexQuery = z.output<
  typeof MenuCustomizationGroupIndexQuerySchema
>

export const MenuCustomizationGroupIndexSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCustomizationGroupIndexSuccess = z.output<
  typeof MenuCustomizationGroupIndexSuccessSchema
>

export const MenuCustomizationGroupStoreRequestSchema = StoreMenuCustomizationGroupRequestSchema

export type MenuCustomizationGroupStoreRequest = z.output<
  typeof MenuCustomizationGroupStoreRequestSchema
>

export const MenuCustomizationGroupStorePathSchema = z.object({
  menuId: z.int()
})

export type MenuCustomizationGroupStorePath = z.output<typeof MenuCustomizationGroupStorePathSchema>

export const MenuCustomizationGroupStoreSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_customization_group')
  }),
  success: z.literal(true)
})

export type MenuCustomizationGroupStoreSuccess = z.output<
  typeof MenuCustomizationGroupStoreSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuCustomizationGroupDestroyRequestSchema = z.record(z.string(), z.unknown())

export type MenuCustomizationGroupDestroyRequest = z.output<
  typeof MenuCustomizationGroupDestroyRequestSchema
>

export const MenuCustomizationGroupDestroyPathSchema = z.object({
  menuId: z.int(),
  groupId: z.int()
})

export type MenuCustomizationGroupDestroyPath = z.output<
  typeof MenuCustomizationGroupDestroyPathSchema
>

/**
 * No content
 */
export const MenuCustomizationGroupDestroySuccessSchema = z.void()

export type MenuCustomizationGroupDestroySuccess = z.output<
  typeof MenuCustomizationGroupDestroySuccessSchema
>

export const MenuCustomizationGroupUpdateRequestSchema = UpdateMenuCustomizationGroupRequestSchema

export type MenuCustomizationGroupUpdateRequest = z.output<
  typeof MenuCustomizationGroupUpdateRequestSchema
>

export const MenuCustomizationGroupUpdatePathSchema = z.object({
  menuId: z.int(),
  groupId: z.int()
})

export type MenuCustomizationGroupUpdatePath = z.output<
  typeof MenuCustomizationGroupUpdatePathSchema
>

export const MenuCustomizationGroupUpdateSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_customization_group')
  }),
  success: z.literal(true)
})

export type MenuCustomizationGroupUpdateSuccess = z.output<
  typeof MenuCustomizationGroupUpdateSuccessSchema
>

export const MenuDuplicateRequestSchema = DuplicateMenuRequestSchema

export type MenuDuplicateRequest = z.output<typeof MenuDuplicateRequestSchema>

export const MenuDuplicatePathSchema = z.object({
  menuId: z.int()
})

export type MenuDuplicatePath = z.output<typeof MenuDuplicatePathSchema>

export const MenuDuplicateSuccessSchema = z.strictObject({
  data: DuplicatedMenuDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuDuplicateSuccess = z.output<typeof MenuDuplicateSuccessSchema>

export const MenuItemIndexPathSchema = z.object({
  menuId: z.int()
})

export type MenuItemIndexPath = z.output<typeof MenuItemIndexPathSchema>

export const MenuItemIndexQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  category: z.string().max(50).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  'category_ids[]': z.array(z.string().max(50)).optional(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuItemIndexQuery = z.output<typeof MenuItemIndexQuerySchema>

export const MenuItemIndexSuccessSchema = z.strictObject({
  data: MenuItemManagementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuItemIndexSuccess = z.output<typeof MenuItemIndexSuccessSchema>

export const MenuItemStoreRequestSchema = StoreMenuItemRequestSchema

export type MenuItemStoreRequest = z.output<typeof MenuItemStoreRequestSchema>

export const MenuItemStorePathSchema = z.object({
  menuId: z.int()
})

export type MenuItemStorePath = z.output<typeof MenuItemStorePathSchema>

export const MenuItemStoreSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemStoreSuccess = z.output<typeof MenuItemStoreSuccessSchema>

export const MenuItemOptionsPathSchema = z.object({
  menuId: z.int()
})

export type MenuItemOptionsPath = z.output<typeof MenuItemOptionsPathSchema>

export const MenuItemOptionsQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  category: z.string().max(50).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  'category_ids[]': z.array(z.string().max(50)).optional(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuItemOptionsQuery = z.output<typeof MenuItemOptionsQuerySchema>

export const MenuItemOptionsSuccessSchema = z.strictObject({
  data: MenuItemOptionsDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuItemOptionsSuccess = z.output<typeof MenuItemOptionsSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuItemDestroyRequestSchema = z.record(z.string(), z.unknown())

export type MenuItemDestroyRequest = z.output<typeof MenuItemDestroyRequestSchema>

export const MenuItemDestroyPathSchema = z.object({
  menuId: z.int(),
  itemId: z.int()
})

export type MenuItemDestroyPath = z.output<typeof MenuItemDestroyPathSchema>

/**
 * No content
 */
export const MenuItemDestroySuccessSchema = z.void()

export type MenuItemDestroySuccess = z.output<typeof MenuItemDestroySuccessSchema>

export const MenuItemUpdateRequestSchema = UpdateMenuItemRequestSchema

export type MenuItemUpdateRequest = z.output<typeof MenuItemUpdateRequestSchema>

export const MenuItemUpdatePathSchema = z.object({
  menuId: z.int(),
  itemId: z.int()
})

export type MenuItemUpdatePath = z.output<typeof MenuItemUpdatePathSchema>

export const MenuItemUpdateSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemUpdateSuccess = z.output<typeof MenuItemUpdateSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuItemAssignToMenuRequestSchema = z.record(z.string(), z.unknown())

export type MenuItemAssignToMenuRequest = z.output<typeof MenuItemAssignToMenuRequestSchema>

export const MenuItemAssignToMenuPathSchema = z.object({
  menuId: z.int(),
  itemId: z.int()
})

export type MenuItemAssignToMenuPath = z.output<typeof MenuItemAssignToMenuPathSchema>

export const MenuItemAssignToMenuSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemAssignToMenuSuccess = z.output<typeof MenuItemAssignToMenuSuccessSchema>

export const MenuItemSyncPlacementsRequestSchema = SyncMenuItemPlacementsRequestSchema

export type MenuItemSyncPlacementsRequest = z.output<typeof MenuItemSyncPlacementsRequestSchema>

export const MenuItemSyncPlacementsPathSchema = z.object({
  menuId: z.int(),
  itemId: z.int()
})

export type MenuItemSyncPlacementsPath = z.output<typeof MenuItemSyncPlacementsPathSchema>

export const MenuItemSyncPlacementsSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemSyncPlacementsSuccess = z.output<typeof MenuItemSyncPlacementsSuccessSchema>

export const MenuItemUpdateStatusRequestSchema = UpdateMenuItemStatusRequestSchema

export type MenuItemUpdateStatusRequest = z.output<typeof MenuItemUpdateStatusRequestSchema>

export const MenuItemUpdateStatusPathSchema = z.object({
  menuId: z.int(),
  itemId: z.int()
})

export type MenuItemUpdateStatusPath = z.output<typeof MenuItemUpdateStatusPathSchema>

export const MenuItemUpdateStatusSuccessSchema = z.strictObject({
  data: MenuItemManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_item')
  }),
  success: z.literal(true)
})

export type MenuItemUpdateStatusSuccess = z.output<typeof MenuItemUpdateStatusSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuItemUnassignFromMenuRequestSchema = z.record(z.string(), z.unknown())

export type MenuItemUnassignFromMenuRequest = z.output<typeof MenuItemUnassignFromMenuRequestSchema>

export const MenuItemUnassignFromMenuPathSchema = z.object({
  menuId: z.int(),
  itemId: z.int()
})

export type MenuItemUnassignFromMenuPath = z.output<typeof MenuItemUnassignFromMenuPathSchema>

/**
 * No content
 */
export const MenuItemUnassignFromMenuSuccessSchema = z.void()

export type MenuItemUnassignFromMenuSuccess = z.output<typeof MenuItemUnassignFromMenuSuccessSchema>

export const MenuOverviewPathSchema = z.object({
  menuId: z.int()
})

export type MenuOverviewPath = z.output<typeof MenuOverviewPathSchema>

export const MenuOverviewQuerySchema = z.object({
  search: z.string().nullish(),
  search_scope: SearchScopeSchema.nullish()
})

export type MenuOverviewQuery = z.output<typeof MenuOverviewQuerySchema>

export const MenuOverviewSuccessSchema = z.strictObject({
  data: MenuOverviewDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuOverviewSuccess = z.output<typeof MenuOverviewSuccessSchema>

export const MenuUpdateOverviewRequestSchema = UpdateMenuOverviewRequestSchema

export type MenuUpdateOverviewRequest = z.output<typeof MenuUpdateOverviewRequestSchema>

export const MenuUpdateOverviewPathSchema = z.object({
  menuId: z.int()
})

export type MenuUpdateOverviewPath = z.output<typeof MenuUpdateOverviewPathSchema>

export const MenuUpdateOverviewSuccessSchema = z.strictObject({
  data: MenuOverviewDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuUpdateOverviewSuccess = z.output<typeof MenuUpdateOverviewSuccessSchema>

export const MenuUpdateStatusRequestSchema = UpdateMenuStatusRequestSchema

export type MenuUpdateStatusRequest = z.output<typeof MenuUpdateStatusRequestSchema>

export const MenuUpdateStatusPathSchema = z.object({
  menuId: z.int()
})

export type MenuUpdateStatusPath = z.output<typeof MenuUpdateStatusPathSchema>

export const MenuUpdateStatusSuccessSchema = z.strictObject({
  data: MenuDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuUpdateStatusSuccess = z.output<typeof MenuUpdateStatusSuccessSchema>

/**
 * Paginated set of `OrderModificationRequestResource`
 */
export const PartnerOrderModificationRequestIndexSuccessSchema = z.object({
  data: z.array(OrderModificationRequestResourceSchema),
  links: z.object({
    first: z.string().nullable(),
    last: z.string().nullable(),
    next: z.string().nullable(),
    prev: z.string().nullable()
  }),
  meta: z.object({
    current_page: z.int().gte(1),
    from: z.int().gte(1).nullable(),
    last_page: z.int().gte(1),
    links: z.array(
      z.object({
        active: z.boolean(),
        label: z.string(),
        page: z.int().nullish(),
        url: z.string().nullable()
      })
    ),
    path: z.string().nullable(),
    per_page: z.int().gte(0),
    to: z.int().gte(1).nullable(),
    total: z.int().gte(0)
  }),
  success: z.literal(true)
})

export type PartnerOrderModificationRequestIndexSuccess = z.output<
  typeof PartnerOrderModificationRequestIndexSuccessSchema
>

export const PartnerOrderModificationRequestReviewRequestSchema =
  ReviewOrderModificationRequestSchema

export type PartnerOrderModificationRequestReviewRequest = z.output<
  typeof PartnerOrderModificationRequestReviewRequestSchema
>

export const PartnerOrderModificationRequestReviewSuccessSchema = z.union([
  z.strictObject({
    data: z.object({
      modification_request: OrderModificationRequestResourceSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.object({
      modification_request: OrderModificationRequestResourceSchema,
      order: CustomerOrderDataSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type PartnerOrderModificationRequestReviewSuccess = z.output<
  typeof PartnerOrderModificationRequestReviewSuccessSchema
>

export const MenuCustomizationGroupPartnerIndexQuerySchema = z.object({
  name: z.string().max(255).nullish(),
  brand_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).nullish(),
  sort_by: z.string().max(50).nullish(),
  sort_direction: z.string().max(10).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCustomizationGroupPartnerIndexQuery = z.output<
  typeof MenuCustomizationGroupPartnerIndexQuerySchema
>

export const MenuCustomizationGroupPartnerIndexSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCustomizationGroupPartnerIndexSuccess = z.output<
  typeof MenuCustomizationGroupPartnerIndexSuccessSchema
>

export const MenuCustomizationGroupStoreForPartnerRequestSchema =
  StoreMenuCustomizationGroupRequestSchema

export type MenuCustomizationGroupStoreForPartnerRequest = z.output<
  typeof MenuCustomizationGroupStoreForPartnerRequestSchema
>

export const MenuCustomizationGroupStoreForPartnerSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_customization_group')
  }),
  success: z.literal(true)
})

export type MenuCustomizationGroupStoreForPartnerSuccess = z.output<
  typeof MenuCustomizationGroupStoreForPartnerSuccessSchema
>

export const MenuCustomizationGroupPartnerOptionsQuerySchema = z.object({
  search: z.string().max(255).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCustomizationGroupPartnerOptionsQuery = z.output<
  typeof MenuCustomizationGroupPartnerOptionsQuerySchema
>

export const MenuCustomizationGroupPartnerOptionsSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupOptionPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCustomizationGroupPartnerOptionsSuccess = z.output<
  typeof MenuCustomizationGroupPartnerOptionsSuccessSchema
>

export const MenuCustomizationGroupPartnerItemOptionsQuerySchema = z.object({
  search: z.string().max(255).nullish(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(50).nullish()
})

export type MenuCustomizationGroupPartnerItemOptionsQuery = z.output<
  typeof MenuCustomizationGroupPartnerItemOptionsQuerySchema
>

export const MenuCustomizationGroupPartnerItemOptionsSuccessSchema = z.strictObject({
  data: MenuCategoryItemOptionPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuCustomizationGroupPartnerItemOptionsSuccess = z.output<
  typeof MenuCustomizationGroupPartnerItemOptionsSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuCustomizationGroupDestroyByModifierRequestSchema = z.record(
  z.string(),
  z.unknown()
)

export type MenuCustomizationGroupDestroyByModifierRequest = z.output<
  typeof MenuCustomizationGroupDestroyByModifierRequestSchema
>

export const MenuCustomizationGroupDestroyByModifierPathSchema = z.object({
  groupId: z.int()
})

export type MenuCustomizationGroupDestroyByModifierPath = z.output<
  typeof MenuCustomizationGroupDestroyByModifierPathSchema
>

/**
 * No content
 */
export const MenuCustomizationGroupDestroyByModifierSuccessSchema = z.void()

export type MenuCustomizationGroupDestroyByModifierSuccess = z.output<
  typeof MenuCustomizationGroupDestroyByModifierSuccessSchema
>

export const MenuCustomizationGroupUpdateByModifierRequestSchema =
  UpdateMenuCustomizationGroupRequestSchema

export type MenuCustomizationGroupUpdateByModifierRequest = z.output<
  typeof MenuCustomizationGroupUpdateByModifierRequestSchema
>

export const MenuCustomizationGroupUpdateByModifierPathSchema = z.object({
  groupId: z.int()
})

export type MenuCustomizationGroupUpdateByModifierPath = z.output<
  typeof MenuCustomizationGroupUpdateByModifierPathSchema
>

export const MenuCustomizationGroupUpdateByModifierSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_customization_group')
  }),
  success: z.literal(true)
})

export type MenuCustomizationGroupUpdateByModifierSuccess = z.output<
  typeof MenuCustomizationGroupUpdateByModifierSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const MenuCustomizationGroupDuplicateByModifierRequestSchema = z.record(
  z.string(),
  z.unknown()
)

export type MenuCustomizationGroupDuplicateByModifierRequest = z.output<
  typeof MenuCustomizationGroupDuplicateByModifierRequestSchema
>

export const MenuCustomizationGroupDuplicateByModifierPathSchema = z.object({
  groupId: z.int()
})

export type MenuCustomizationGroupDuplicateByModifierPath = z.output<
  typeof MenuCustomizationGroupDuplicateByModifierPathSchema
>

export const MenuCustomizationGroupDuplicateByModifierSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_customization_group')
  }),
  success: z.literal(true)
})

export type MenuCustomizationGroupDuplicateByModifierSuccess = z.output<
  typeof MenuCustomizationGroupDuplicateByModifierSuccessSchema
>

export const MenuCustomizationGroupReplaceLinkedItemsRequestSchema =
  ReplaceMenuCustomizationGroupLinkedItemsRequestSchema

export type MenuCustomizationGroupReplaceLinkedItemsRequest = z.output<
  typeof MenuCustomizationGroupReplaceLinkedItemsRequestSchema
>

export const MenuCustomizationGroupReplaceLinkedItemsPathSchema = z.object({
  groupId: z.int()
})

export type MenuCustomizationGroupReplaceLinkedItemsPath = z.output<
  typeof MenuCustomizationGroupReplaceLinkedItemsPathSchema
>

export const MenuCustomizationGroupReplaceLinkedItemsSuccessSchema = z.strictObject({
  data: MenuCustomizationGroupManagementDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu_customization_group')
  }),
  success: z.literal(true)
})

export type MenuCustomizationGroupReplaceLinkedItemsSuccess = z.output<
  typeof MenuCustomizationGroupReplaceLinkedItemsSuccessSchema
>

export const NotificationPreferencesSchemaQuerySchema = z.object({
  role: UserRoleSchema.nullish()
})

export type NotificationPreferencesSchemaQuery = z.output<
  typeof NotificationPreferencesSchemaQuerySchema
>

export const NotificationPreferencesSchemaSuccessSchema = z.strictObject({
  data: NotificationPreferenceCatalogSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type NotificationPreferencesSchemaSuccess = z.output<
  typeof NotificationPreferencesSchemaSuccessSchema
>

export const DashboardOrdersQuerySchema = z.object({
  per_page: z.int().gte(1).lte(100).nullish(),
  page: z.int().gte(1).nullish(),
  'status[]': z.array(z.union([OrderStatusSchema, z.enum(['all'])])).optional(),
  store_id: z.union([z.int(), z.enum(['all'])]).nullish(),
  order_type: z.union([OrderTypeSchema, z.enum(['all'])]).nullish(),
  date: z.iso.date().nullish(),
  month: z.int().gte(1).lte(12).nullish(),
  year: z.int().gte(2000).lte(2100).nullish(),
  section: OrderListSectionSchema.nullish(),
  sort_by: OrderSortFieldSchema.nullish(),
  order: SortDirectionSchema.nullish()
})

export type DashboardOrdersQuery = z.output<typeof DashboardOrdersQuerySchema>

export const DashboardOrdersSuccessSchema = z.union([
  z.strictObject({
    data: CustomerOrderDataPageSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: PartnerOrderSummaryDataPageSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type DashboardOrdersSuccess = z.output<typeof DashboardOrdersSuccessSchema>

export const DashboardOrderDatesQuerySchema = z.object({
  month: z.int().gte(1).lte(12),
  year: z.int().gte(2000).lte(2100),
  'status[]': z.array(z.union([OrderStatusSchema, z.enum(['all'])])).optional(),
  store_id: z.union([z.int(), z.enum(['all'])]).nullish(),
  order_type: z.union([OrderTypeSchema, z.enum(['all'])]).nullish()
})

export type DashboardOrderDatesQuery = z.output<typeof DashboardOrderDatesQuerySchema>

export const DashboardOrderDatesSuccessSchema = z.strictObject({
  data: DashboardOrderDatesResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardOrderDatesSuccess = z.output<typeof DashboardOrderDatesSuccessSchema>

export const DashboardOrderDetailsPathSchema = z.object({
  identifier: z.string()
})

export type DashboardOrderDetailsPath = z.output<typeof DashboardOrderDetailsPathSchema>

/**
 * `PartnerOrderResource`
 *
 * `CustomerOrderResource`
 */
export const DashboardOrderDetailsSuccessSchema = z.union([
  z.object({
    data: PartnerOrderResourceSchema
  }),
  z.object({
    data: CustomerOrderResourceSchema
  })
])

export type DashboardOrderDetailsSuccess = z.output<typeof DashboardOrderDetailsSuccessSchema>

export const OrderPaymentsPathSchema = z.object({
  identifier: z.string()
})

export type OrderPaymentsPath = z.output<typeof OrderPaymentsPathSchema>

export const OrderPaymentsSuccessSchema = z.strictObject({
  data: z.object({
    payment_error: PaymentFailureCodeSchema.nullable(),
    payment_error_at: z.string().nullable(),
    payment_status: PaymentStatusSchema,
    payments: z.array(PaymentDataSchema)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type OrderPaymentsSuccess = z.output<typeof OrderPaymentsSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const OrdersAutoDeclineRequestSchema = z.record(z.string(), z.unknown())

export type OrdersAutoDeclineRequest = z.output<typeof OrdersAutoDeclineRequestSchema>

export const OrdersAutoDeclinePathSchema = z.object({
  order: z.string()
})

export type OrdersAutoDeclinePath = z.output<typeof OrdersAutoDeclinePathSchema>

export const OrdersAutoDeclineSuccessSchema = z.union([
  z.strictObject({
    data: z.object({
      order: PartnerOrderDataSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.object({
      entity_type: z.literal('order')
    }),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.object({
      order: PartnerOrderDataSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type OrdersAutoDeclineSuccess = z.output<typeof OrdersAutoDeclineSuccessSchema>

export const OrdersStatusPatchRequestSchema = UpdateStatusRequestSchema

export type OrdersStatusPatchRequest = z.output<typeof OrdersStatusPatchRequestSchema>

export const OrdersStatusPatchPathSchema = z.object({
  order: z.string()
})

export type OrdersStatusPatchPath = z.output<typeof OrdersStatusPatchPathSchema>

export const OrdersStatusPatchSuccessSchema = z.union([
  z.strictObject({
    data: z.object({
      order: PartnerOrderDataSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.object({
      entity_type: z.literal('order')
    }),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.object({
      order: PartnerOrderDataSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type OrdersStatusPatchSuccess = z.output<typeof OrdersStatusPatchSuccessSchema>

export const OrdersStatusPutRequestSchema = UpdateStatusRequestSchema

export type OrdersStatusPutRequest = z.output<typeof OrdersStatusPutRequestSchema>

export const OrdersStatusPutPathSchema = z.object({
  order: z.string()
})

export type OrdersStatusPutPath = z.output<typeof OrdersStatusPutPathSchema>

export const OrdersStatusPutSuccessSchema = z.union([
  z.strictObject({
    data: z.object({
      order: PartnerOrderDataSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.object({
      entity_type: z.literal('order')
    }),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.object({
      order: PartnerOrderDataSchema
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type OrdersStatusPutSuccess = z.output<typeof OrdersStatusPutSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PartnerDestroyRequestSchema = z.record(z.string(), z.unknown())

export type PartnerDestroyRequest = z.output<typeof PartnerDestroyRequestSchema>

/**
 * No content
 */
export const PartnerDestroySuccessSchema = z.void()

export type PartnerDestroySuccess = z.output<typeof PartnerDestroySuccessSchema>

export const PartnerAccessStatusSuccessSchema = z.union([
  z.object({
    data: z.object({
      active: z.literal(true),
      expires_at: z.string().nullable(),
      partner_id: z.int(),
      partner_name: z.string().nullable()
    })
  }),
  z.object({
    data: z.object({
      active: z.literal(false),
      expires_at: z.null(),
      partner_id: z.null(),
      partner_name: z.null()
    })
  })
])

export type PartnerAccessStatusSuccess = z.output<typeof PartnerAccessStatusSuccessSchema>

export const PartnerAccessStoreRequestSchema = RequestPartnerAccessRequestSchema

export type PartnerAccessStoreRequest = z.output<typeof PartnerAccessStoreRequestSchema>

export const PartnerAccessStoreSuccessSchema = z.object({
  data: z.object({
    expires_at: z.string().nullable(),
    id: z.int(),
    partner_id: z.int(),
    scope: z.literal('partner:dashboard:access'),
    subject_type: z.string()
  })
})

export type PartnerAccessStoreSuccess = z.output<typeof PartnerAccessStoreSuccessSchema>

export const DashboardPaymentsQuerySchema = z.object({
  per_page: z.int().gte(1).lte(100).nullish(),
  page: z.int().gte(1).nullish(),
  status: z.union([PaymentStatusSchema, z.enum(['all'])]).nullish(),
  date_from: z.iso.datetime({ offset: true }).nullish(),
  date_to: z.iso.datetime({ offset: true }).nullish(),
  sort_by: z.enum(['date', 'amount']).nullish(),
  sort_direction: SortDirectionSchema.nullish()
})

export type DashboardPaymentsQuery = z.output<typeof DashboardPaymentsQuerySchema>

/**
 * Paginated set of `PaymentResource`
 */
export const DashboardPaymentsSuccessSchema = z.object({
  data: z.array(PaymentResourceSchema),
  links: z.object({
    first: z.string().nullable(),
    last: z.string().nullable(),
    next: z.string().nullable(),
    prev: z.string().nullable()
  }),
  meta: z.object({
    current_page: z.int().gte(1),
    from: z.int().gte(1).nullable(),
    last_page: z.int().gte(1),
    links: z.array(
      z.object({
        active: z.boolean(),
        label: z.string(),
        page: z.int().nullish(),
        url: z.string().nullable()
      })
    ),
    path: z.string().nullable(),
    per_page: z.int().gte(0),
    to: z.int().gte(1).nullable(),
    total: z.int().gte(0)
  }),
  success: z.literal(true)
})

export type DashboardPaymentsSuccess = z.output<typeof DashboardPaymentsSuccessSchema>

export const DashboardPaymentDetailsPathSchema = z.object({
  payment: z.string()
})

export type DashboardPaymentDetailsPath = z.output<typeof DashboardPaymentDetailsPathSchema>

/**
 * `PaymentResource`
 */
export const DashboardPaymentDetailsSuccessSchema = z.object({
  data: PaymentResourceSchema
})

export type DashboardPaymentDetailsSuccess = z.output<typeof DashboardPaymentDetailsSuccessSchema>

export const DashboardPermissionsSuccessSchema = z.strictObject({
  data: DashboardPermissionCatalogSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardPermissionsSuccess = z.output<typeof DashboardPermissionsSuccessSchema>

export const DashboardQuickActionsSuccessSchema = z.strictObject({
  data: DashboardQuickActionsResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardQuickActionsSuccess = z.output<typeof DashboardQuickActionsSuccessSchema>

export const PartnerReportIndexQuerySchema = z.object({
  period: ReportPeriodSchema.optional(),
  store_id: z.union([z.int(), z.enum(['all'])]).optional()
})

export type PartnerReportIndexQuery = z.output<typeof PartnerReportIndexQuerySchema>

export const PartnerReportIndexSuccessSchema = z.strictObject({
  data: PartnerReportShapeSchema.nullable(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z
    .object({
      store_id: z.int(),
      store_name: z.string()
    })
    .nullable(),
  success: z.literal(true)
})

export type PartnerReportIndexSuccess = z.output<typeof PartnerReportIndexSuccessSchema>

export const DashboardStoreReviewIndexQuerySchema = z.object({
  store_slug: z.string().max(255).optional(),
  order_number: z.string().max(255).optional(),
  rating: z.union([z.int().gte(1).lte(5), z.enum(['all'])]).optional(),
  customer_id: z.int().gte(1).optional(),
  status: z.union([StoreReviewStatusSchema, z.enum(['all'])]).optional(),
  sort: StoreReviewSortSchema.optional(),
  search: z.string().max(255).optional(),
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional()
})

export type DashboardStoreReviewIndexQuery = z.output<typeof DashboardStoreReviewIndexQuerySchema>

export const DashboardStoreReviewIndexSuccessSchema = z.strictObject({
  data: DashboardStoreReviewListSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardStoreReviewIndexSuccess = z.output<
  typeof DashboardStoreReviewIndexSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreReviewApproveRequestSchema = z.record(z.string(), z.unknown())

export type StoreReviewApproveRequest = z.output<typeof StoreReviewApproveRequestSchema>

export const StoreReviewApprovePathSchema = z.object({
  review: z.int()
})

export type StoreReviewApprovePath = z.output<typeof StoreReviewApprovePathSchema>

export const StoreReviewApproveSuccessSchema = z.strictObject({
  data: DashboardStoreReviewModerationSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store_review')
  }),
  success: z.literal(true)
})

export type StoreReviewApproveSuccess = z.output<typeof StoreReviewApproveSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreReviewRejectRequestSchema = z.record(z.string(), z.unknown())

export type StoreReviewRejectRequest = z.output<typeof StoreReviewRejectRequestSchema>

export const StoreReviewRejectPathSchema = z.object({
  review: z.int()
})

export type StoreReviewRejectPath = z.output<typeof StoreReviewRejectPathSchema>

export const StoreReviewRejectSuccessSchema = z.strictObject({
  data: DashboardStoreReviewModerationSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store_review')
  }),
  success: z.literal(true)
})

export type StoreReviewRejectSuccess = z.output<typeof StoreReviewRejectSuccessSchema>

export const DashboardRolesSuccessSchema = z.strictObject({
  data: z.array(DashboardRoleEntrySchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardRolesSuccess = z.output<typeof DashboardRolesSuccessSchema>

export const DashboardRolePermissionsPathSchema = z.object({
  role: z.string()
})

export type DashboardRolePermissionsPath = z.output<typeof DashboardRolePermissionsPathSchema>

export const DashboardRolePermissionsSuccessSchema = z.strictObject({
  data: DashboardRolePermissionsSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardRolePermissionsSuccess = z.output<typeof DashboardRolePermissionsSuccessSchema>

export const SearchQuerySchema = z.object({
  q: z.string().min(1).max(128),
  per_type: z.int().gte(1).lte(25).nullish()
})

export type SearchQuery = z.output<typeof SearchQuerySchema>

export const SearchSuccessSchema = z.strictObject({
  data: z.array(DashboardSearchResultItemSchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type SearchSuccess = z.output<typeof SearchSuccessSchema>

export const StoresDashboardQuerySchema = z.object({
  partner_id: z.int().gte(1).optional(),
  brand_id: z.union([z.int(), z.enum(['all'])]).optional(),
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional(),
  search: z.string().max(255).optional(),
  status: z.union([StoreStatusSchema, z.enum(['all'])]).optional()
})

export type StoresDashboardQuery = z.output<typeof StoresDashboardQuerySchema>

export const StoresDashboardSuccessSchema = z.strictObject({
  data: StoreSummaryPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoresDashboardSuccess = z.output<typeof StoresDashboardSuccessSchema>

export const StoreStoreRequestSchema = CreateStoreRequestSchema

export type StoreStoreRequest = z.output<typeof StoreStoreRequestSchema>

export const StoreStoreSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreStoreSuccess = z.output<typeof StoreStoreSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreDestroyRequestSchema = z.record(z.string(), z.unknown())

export type StoreDestroyRequest = z.output<typeof StoreDestroyRequestSchema>

export const StoreDestroyPathSchema = z.object({
  identifier: z.string()
})

export type StoreDestroyPath = z.output<typeof StoreDestroyPathSchema>

/**
 * No content
 */
export const StoreDestroySuccessSchema = z.void()

export type StoreDestroySuccess = z.output<typeof StoreDestroySuccessSchema>

export const DashboardStoreShowPathSchema = z.object({
  identifier: z.string()
})

export type DashboardStoreShowPath = z.output<typeof DashboardStoreShowPathSchema>

export const DashboardStoreShowSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardStoreShowSuccess = z.output<typeof DashboardStoreShowSuccessSchema>

export const StoreUpdateDetailsRequestSchema = UpdateStoreDetailsRequestSchema

export type StoreUpdateDetailsRequest = z.output<typeof StoreUpdateDetailsRequestSchema>

export const StoreUpdateDetailsPathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateDetailsPath = z.output<typeof StoreUpdateDetailsPathSchema>

export const StoreUpdateDetailsSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateDetailsSuccess = z.output<typeof StoreUpdateDetailsSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreDuplicateRequestSchema = z.record(z.string(), z.unknown())

export type StoreDuplicateRequest = z.output<typeof StoreDuplicateRequestSchema>

export const StoreDuplicatePathSchema = z.object({
  identifier: z.string()
})

export type StoreDuplicatePath = z.output<typeof StoreDuplicatePathSchema>

export const StoreDuplicateSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreDuplicateSuccess = z.output<typeof StoreDuplicateSuccessSchema>

export const StoreHealthPathSchema = z.object({
  identifier: z.string()
})

export type StoreHealthPath = z.output<typeof StoreHealthPathSchema>

export const StoreHealthSuccessSchema = z.strictObject({
  data: StoreOperationalHealthSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreHealthSuccess = z.output<typeof StoreHealthSuccessSchema>

export const StoreUpdateHoursRequestSchema = UpdateStoreOperatingHoursRequestSchema

export type StoreUpdateHoursRequest = z.output<typeof StoreUpdateHoursRequestSchema>

export const StoreUpdateHoursPathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateHoursPath = z.output<typeof StoreUpdateHoursPathSchema>

export const StoreUpdateHoursSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateHoursSuccess = z.output<typeof StoreUpdateHoursSuccessSchema>

export const StoreUpdateImageRequestSchema = StoreImageRequestSchema

export type StoreUpdateImageRequest = z.output<typeof StoreUpdateImageRequestSchema>

export const StoreUpdateImagePathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateImagePath = z.output<typeof StoreUpdateImagePathSchema>

export const StoreUpdateImageSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateImageSuccess = z.output<typeof StoreUpdateImageSuccessSchema>

export const StoreUpdateLeadTimeRequestSchema = UpdateStoreLeadTimeRequestSchema

export type StoreUpdateLeadTimeRequest = z.output<typeof StoreUpdateLeadTimeRequestSchema>

export const StoreUpdateLeadTimePathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateLeadTimePath = z.output<typeof StoreUpdateLeadTimePathSchema>

export const StoreUpdateLeadTimeSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateLeadTimeSuccess = z.output<typeof StoreUpdateLeadTimeSuccessSchema>

export const MenuStoreMenusPathSchema = z.object({
  identifier: z.string()
})

export type MenuStoreMenusPath = z.output<typeof MenuStoreMenusPathSchema>

export const MenuStoreMenusSuccessSchema = z.strictObject({
  data: StoreMenuCatalogSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuStoreMenusSuccess = z.output<typeof MenuStoreMenusSuccessSchema>

export const MenuStoreForStoreRequestSchema = CreateMenuRequestSchema

export type MenuStoreForStoreRequest = z.output<typeof MenuStoreForStoreRequestSchema>

export const MenuStoreForStorePathSchema = z.object({
  identifier: z.string()
})

export type MenuStoreForStorePath = z.output<typeof MenuStoreForStorePathSchema>

export const MenuStoreForStoreSuccessSchema = z.strictObject({
  data: MenuDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuStoreForStoreSuccess = z.output<typeof MenuStoreForStoreSuccessSchema>

export const MenuAssignStoreMenusRequestSchema = AssignStoreMenusRequestSchema

export type MenuAssignStoreMenusRequest = z.output<typeof MenuAssignStoreMenusRequestSchema>

export const MenuAssignStoreMenusPathSchema = z.object({
  identifier: z.string()
})

export type MenuAssignStoreMenusPath = z.output<typeof MenuAssignStoreMenusPathSchema>

export const MenuAssignStoreMenusSuccessSchema = z.strictObject({
  data: StoreMenuCatalogSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuAssignStoreMenusSuccess = z.output<typeof MenuAssignStoreMenusSuccessSchema>

export const MenuUpdateStoreMenuOrderRequestSchema = UpdateStoreMenuOrderRequestSchema

export type MenuUpdateStoreMenuOrderRequest = z.output<typeof MenuUpdateStoreMenuOrderRequestSchema>

export const MenuUpdateStoreMenuOrderPathSchema = z.object({
  identifier: z.string()
})

export type MenuUpdateStoreMenuOrderPath = z.output<typeof MenuUpdateStoreMenuOrderPathSchema>

export const MenuUpdateStoreMenuOrderSuccessSchema = z.strictObject({
  data: StoreMenuCatalogSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('menu')
  }),
  success: z.literal(true)
})

export type MenuUpdateStoreMenuOrderSuccess = z.output<typeof MenuUpdateStoreMenuOrderSuccessSchema>

export const StoreUpdatePricingRequestSchema = UpdateStorePricingRequestSchema

export type StoreUpdatePricingRequest = z.output<typeof StoreUpdatePricingRequestSchema>

export const StoreUpdatePricingPathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdatePricingPath = z.output<typeof StoreUpdatePricingPathSchema>

export const StoreUpdatePricingSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdatePricingSuccess = z.output<typeof StoreUpdatePricingSuccessSchema>

export const StoreUpdateServicesRequestSchema = UpdateStoreServicesRequestSchema

export type StoreUpdateServicesRequest = z.output<typeof StoreUpdateServicesRequestSchema>

export const StoreUpdateServicesPathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateServicesPath = z.output<typeof StoreUpdateServicesPathSchema>

export const StoreUpdateServicesSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateServicesSuccess = z.output<typeof StoreUpdateServicesSuccessSchema>

export const StoreSetupProgressPathSchema = z.object({
  identifier: z.string()
})

export type StoreSetupProgressPath = z.output<typeof StoreSetupProgressPathSchema>

export const StoreSetupProgressSuccessSchema = z.strictObject({
  data: StoreSetupProgressSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreSetupProgressSuccess = z.output<typeof StoreSetupProgressSuccessSchema>

export const StoreUpdateStatusRequestSchema = UpdateStoreStatusRequestSchema

export type StoreUpdateStatusRequest = z.output<typeof StoreUpdateStatusRequestSchema>

export const StoreUpdateStatusPathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateStatusPath = z.output<typeof StoreUpdateStatusPathSchema>

export const StoreUpdateStatusSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateStatusSuccess = z.output<typeof StoreUpdateStatusSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreSubmitRequestSchema = z.record(z.string(), z.unknown())

export type StoreSubmitRequest = z.output<typeof StoreSubmitRequestSchema>

export const StoreSubmitPathSchema = z.object({
  identifier: z.string()
})

export type StoreSubmitPath = z.output<typeof StoreSubmitPathSchema>

export const StoreSubmitSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreSubmitSuccess = z.output<typeof StoreSubmitSuccessSchema>

export const StoreTemporaryClosuresPathSchema = z.object({
  identifier: z.string()
})

export type StoreTemporaryClosuresPath = z.output<typeof StoreTemporaryClosuresPathSchema>

export const StoreTemporaryClosuresSuccessSchema = z.strictObject({
  data: StoreTemporaryClosureListSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreTemporaryClosuresSuccess = z.output<typeof StoreTemporaryClosuresSuccessSchema>

export const StoreUpdateTemporaryClosuresRequestSchema = UpdateStoreTemporaryClosuresRequestSchema

export type StoreUpdateTemporaryClosuresRequest = z.output<
  typeof StoreUpdateTemporaryClosuresRequestSchema
>

export const StoreUpdateTemporaryClosuresPathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateTemporaryClosuresPath = z.output<
  typeof StoreUpdateTemporaryClosuresPathSchema
>

export const StoreUpdateTemporaryClosuresSuccessSchema = z.strictObject({
  data: StoreTemporaryClosureListSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateTemporaryClosuresSuccess = z.output<
  typeof StoreUpdateTemporaryClosuresSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreDestroyTemporaryClosureRequestSchema = z.record(z.string(), z.unknown())

export type StoreDestroyTemporaryClosureRequest = z.output<
  typeof StoreDestroyTemporaryClosureRequestSchema
>

export const StoreDestroyTemporaryClosurePathSchema = z.object({
  identifier: z.string(),
  temporaryClosure: z.string()
})

export type StoreDestroyTemporaryClosurePath = z.output<
  typeof StoreDestroyTemporaryClosurePathSchema
>

/**
 * No content
 */
export const StoreDestroyTemporaryClosureSuccessSchema = z.void()

export type StoreDestroyTemporaryClosureSuccess = z.output<
  typeof StoreDestroyTemporaryClosureSuccessSchema
>

export const StoreUpdateVenueRequestSchema = UpdateStoreVenueRequestSchema

export type StoreUpdateVenueRequest = z.output<typeof StoreUpdateVenueRequestSchema>

export const StoreUpdateVenuePathSchema = z.object({
  identifier: z.string()
})

export type StoreUpdateVenuePath = z.output<typeof StoreUpdateVenuePathSchema>

export const StoreUpdateVenueSuccessSchema = z.strictObject({
  data: StoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('store')
  }),
  success: z.literal(true)
})

export type StoreUpdateVenueSuccess = z.output<typeof StoreUpdateVenueSuccessSchema>

export const StoreReviewStoreReviewsPathSchema = z.object({
  store: z.int()
})

export type StoreReviewStoreReviewsPath = z.output<typeof StoreReviewStoreReviewsPathSchema>

export const StoreReviewStoreReviewsQuerySchema = z.object({
  store_slug: z.string().max(255).optional(),
  order_number: z.string().max(255).optional(),
  rating: z.union([z.int().gte(1).lte(5), z.enum(['all'])]).optional(),
  customer_id: z.int().gte(1).optional(),
  status: z.union([StoreReviewStatusSchema, z.enum(['all'])]).optional(),
  sort: StoreReviewSortSchema.optional(),
  search: z.string().max(255).optional(),
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional()
})

export type StoreReviewStoreReviewsQuery = z.output<typeof StoreReviewStoreReviewsQuerySchema>

export const StoreReviewStoreReviewsSuccessSchema = z.strictObject({
  data: DashboardStoreScopedReviewListSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreReviewStoreReviewsSuccess = z.output<typeof StoreReviewStoreReviewsSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const DashboardDeleteAvatarRequestSchema = z.record(z.string(), z.unknown())

export type DashboardDeleteAvatarRequest = z.output<typeof DashboardDeleteAvatarRequestSchema>

export const DashboardDeleteAvatarSuccessSchema = z.strictObject({
  data: UserDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardDeleteAvatarSuccess = z.output<typeof DashboardDeleteAvatarSuccessSchema>

export const DashboardUploadAvatarRequestSchema = AvatarUploadRequestSchema

export type DashboardUploadAvatarRequest = z.output<typeof DashboardUploadAvatarRequestSchema>

export const DashboardUploadAvatarSuccessSchema = z.strictObject({
  data: UserDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardUploadAvatarSuccess = z.output<typeof DashboardUploadAvatarSuccessSchema>

export const NotificationPreferencesShowSuccessSchema = z.strictObject({
  data: NotificationPreferenceSettingsSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type NotificationPreferencesShowSuccess = z.output<
  typeof NotificationPreferencesShowSuccessSchema
>

export const NotificationPreferencesUpdateRequestSchema2 =
  NotificationPreferencesUpdateRequestSchema

export type NotificationPreferencesUpdateRequest2 = z.output<
  typeof NotificationPreferencesUpdateRequestSchema2
>

export const NotificationPreferencesUpdateSuccessSchema = z.strictObject({
  data: NotificationPreferenceSettingsSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type NotificationPreferencesUpdateSuccess = z.output<
  typeof NotificationPreferencesUpdateSuccessSchema
>

export const DashboardUpdateProfileRequestSchema = ProfileUpdateRequestSchema

export type DashboardUpdateProfileRequest = z.output<typeof DashboardUpdateProfileRequestSchema>

export const DashboardUpdateProfileSuccessSchema = z.strictObject({
  data: DashboardProfileUpdateResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardUpdateProfileSuccess = z.output<typeof DashboardUpdateProfileSuccessSchema>

export const DashboardUsersQuerySchema = z.object({
  per_page: z.int().gte(1).lte(100).nullish(),
  page: z.int().gte(1).nullish(),
  search: z.string().max(255).nullish(),
  role: z.union([UserRoleSchema, z.enum(['all'])]).nullish(),
  status: z.union([UserStatusSchema, z.enum(['all'])]).nullish(),
  partner_id: z.int().nullish()
})

export type DashboardUsersQuery = z.output<typeof DashboardUsersQuerySchema>

export const DashboardUsersSuccessSchema = z.strictObject({
  data: UserDirectoryPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardUsersSuccess = z.output<typeof DashboardUsersSuccessSchema>

export const DashboardCreateUserRequestSchema = UserCreateRequestSchema

export type DashboardCreateUserRequest = z.output<typeof DashboardCreateUserRequestSchema>

export const DashboardCreateUserSuccessSchema = z.strictObject({
  data: UserPreferencesDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardCreateUserSuccess = z.output<typeof DashboardCreateUserSuccessSchema>

/**
 * The authenticated actor account and permissions select the applicable invitation contract.
 */
export const PartnerUserInvitationStoreRequestSchema = z.union([
  OrganizerUserInvitationPayloadSchema,
  PartnerUserInvitationPayloadSchema
])

export type PartnerUserInvitationStoreRequest = z.output<
  typeof PartnerUserInvitationStoreRequestSchema
>

export const PartnerUserInvitationStoreSuccessSchema = z.strictObject({
  data: UserPreferencesDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUserInvitationStoreSuccess = z.output<
  typeof PartnerUserInvitationStoreSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PartnerUserInvitationDestroyRequestSchema = z.record(z.string(), z.unknown())

export type PartnerUserInvitationDestroyRequest = z.output<
  typeof PartnerUserInvitationDestroyRequestSchema
>

export const PartnerUserInvitationDestroyPathSchema = z.object({
  userId: z.int()
})

export type PartnerUserInvitationDestroyPath = z.output<
  typeof PartnerUserInvitationDestroyPathSchema
>

/**
 * No content
 */
export const PartnerUserInvitationDestroySuccessSchema = z.void()

export type PartnerUserInvitationDestroySuccess = z.output<
  typeof PartnerUserInvitationDestroySuccessSchema
>

export const DashboardUserDetailsPathSchema = z.object({
  userId: z.int()
})

export type DashboardUserDetailsPath = z.output<typeof DashboardUserDetailsPathSchema>

export const DashboardUserDetailsSuccessSchema = z.strictObject({
  data: UserDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardUserDetailsSuccess = z.output<typeof DashboardUserDetailsSuccessSchema>

export const DashboardUpdateUserRequestSchema = UserUpdateRequestSchema

export type DashboardUpdateUserRequest = z.output<typeof DashboardUpdateUserRequestSchema>

export const DashboardUpdateUserPathSchema = z.object({
  userId: z.int()
})

export type DashboardUpdateUserPath = z.output<typeof DashboardUpdateUserPathSchema>

export const DashboardUpdateUserSuccessSchema = z.strictObject({
  data: UserPreferencesDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardUpdateUserSuccess = z.output<typeof DashboardUpdateUserSuccessSchema>

export const AuditLogUserActivityPathSchema = z.object({
  userId: z.int()
})

export type AuditLogUserActivityPath = z.output<typeof AuditLogUserActivityPathSchema>

export const AuditLogUserActivityQuerySchema = z.object({
  per_page: z.string().optional()
})

export type AuditLogUserActivityQuery = z.output<typeof AuditLogUserActivityQuerySchema>

/**
 * Array of `AuditActivityResource`
 */
export const AuditLogUserActivitySuccessSchema = z.object({
  data: z.array(AuditActivityResourceSchema),
  meta: z.object({
    current_page: z.int(),
    last_page: z.int(),
    per_page: z.int(),
    total: z.int()
  })
})

export type AuditLogUserActivitySuccess = z.output<typeof AuditLogUserActivitySuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PartnerUserInvitationCancelRequestSchema = z.record(z.string(), z.unknown())

export type PartnerUserInvitationCancelRequest = z.output<
  typeof PartnerUserInvitationCancelRequestSchema
>

export const PartnerUserInvitationCancelPathSchema = z.object({
  userId: z.int()
})

export type PartnerUserInvitationCancelPath = z.output<typeof PartnerUserInvitationCancelPathSchema>

export const PartnerUserInvitationCancelSuccessSchema = z.strictObject({
  data: UserPreferencesDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUserInvitationCancelSuccess = z.output<
  typeof PartnerUserInvitationCancelSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PartnerUserInvitationResendRequestSchema = z.record(z.string(), z.unknown())

export type PartnerUserInvitationResendRequest = z.output<
  typeof PartnerUserInvitationResendRequestSchema
>

export const PartnerUserInvitationResendPathSchema = z.object({
  userId: z.int()
})

export type PartnerUserInvitationResendPath = z.output<typeof PartnerUserInvitationResendPathSchema>

export const PartnerUserInvitationResendSuccessSchema = z.strictObject({
  data: UserPreferencesDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUserInvitationResendSuccess = z.output<
  typeof PartnerUserInvitationResendSuccessSchema
>

export const DashboardUserPreferencesPathSchema = z.object({
  userId: z.int()
})

export type DashboardUserPreferencesPath = z.output<typeof DashboardUserPreferencesPathSchema>

export const DashboardUserPreferencesSuccessSchema = z.strictObject({
  data: UserPreferencesDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type DashboardUserPreferencesSuccess = z.output<typeof DashboardUserPreferencesSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const VerificationResendRequestSchema = z.record(z.string(), z.unknown())

export type VerificationResendRequest = z.output<typeof VerificationResendRequestSchema>

export const VerificationResendSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type VerificationResendSuccess = z.output<typeof VerificationResendSuccessSchema>

export const VerificationCheckSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type VerificationCheckSuccess = z.output<typeof VerificationCheckSuccessSchema>

export const VerificationVerifyPathSchema = z.object({
  id: z.int().gte(0),
  hash: z.string().regex(/^[a-f0-9]{40}$/)
})

export type VerificationVerifyPath = z.output<typeof VerificationVerifyPathSchema>

export const VerificationVerifyQuerySchema = z.object({
  expires: z.int().gte(1),
  signature: z
    .string()
    .min(1)
    .regex(/^[a-f0-9]{64}$/)
})

export type VerificationVerifyQuery = z.output<typeof VerificationVerifyQuerySchema>

export const VerificationVerifySuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type VerificationVerifySuccess = z.output<typeof VerificationVerifySuccessSchema>

export const EventSearchAgeGroupsSuccessSchema = z.strictObject({
  data: z.object({
    age_groups: z.array(AgeGroupSummarySchema),
    count: z.int()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchAgeGroupsSuccess = z.output<typeof EventSearchAgeGroupsSuccessSchema>

export const EventSearchCitiesQuerySchema = z.object({
  state: z.string().optional()
})

export type EventSearchCitiesQuery = z.output<typeof EventSearchCitiesQuerySchema>

export const EventSearchCitiesSuccessSchema = z.strictObject({
  data: z.object({
    cities: z.array(CityStateSchema),
    count: z.int()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchCitiesSuccess = z.output<typeof EventSearchCitiesSuccessSchema>

export const EventSearchClassificationsSuccessSchema = z.strictObject({
  data: z.object({
    classifications: z.array(ClassificationSummarySchema),
    count: z.int()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchClassificationsSuccess = z.output<
  typeof EventSearchClassificationsSuccessSchema
>

export const EventSearchDirectorsSuccessSchema = z.strictObject({
  data: z.object({
    count: z.int(),
    directors: z.array(DirectorSummarySchema)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchDirectorsSuccess = z.output<typeof EventSearchDirectorsSuccessSchema>

export const EventSearchEventTypesSuccessSchema = z.strictObject({
  data: z.object({
    count: z.int(),
    event_types: z.array(EventTypeSummarySchema)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchEventTypesSuccess = z.output<typeof EventSearchEventTypesSuccessSchema>

export const EventSearchSportTypesSuccessSchema = z.strictObject({
  data: z.object({
    count: z.int(),
    sport_types: z.array(SportTypeSummarySchema)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchSportTypesSuccess = z.output<typeof EventSearchSportTypesSuccessSchema>

export const EventSearchStatesSuccessSchema = z.strictObject({
  data: z.object({
    count: z.int(),
    states: z.array(z.string())
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchStatesSuccess = z.output<typeof EventSearchStatesSuccessSchema>

export const EventSearchIndexQuerySchema = z.object({
  q: z.string().max(255).nullish(),
  lat: z.number().nullish(),
  lng: z.number().nullish(),
  radius_miles: z.number().gte(1).lte(200).nullish(),
  bbox: z.string().nullish(),
  place_type: GeocodingPlaceTypeSchema.nullish(),
  startDate: z.iso.date().nullish(),
  endDate: z.iso.date().nullish(),
  event_type: z.union([z.string().max(255), z.enum(['all'])]).nullish(),
  sportType: z.union([z.string().max(255), z.enum(['all'])]).nullish(),
  state: z.string().max(255).nullish(),
  city: z.string().max(255).nullish(),
  ageGroup: z.union([z.string(), z.enum(['all'])]).nullish(),
  classification: z.union([z.string().max(255), z.enum(['all'])]).nullish(),
  directors: z.string().nullish(),
  status: z.union([z.enum(['upcoming', 'active', 'past']), z.enum(['all'])]).nullish(),
  minTeams: z.int().gte(0).nullish(),
  featured: z.boolean().optional(),
  page: z.int().gte(1).nullish(),
  per_page: z.int().gte(1).lte(100).nullish()
})

export type EventSearchIndexQuery = z.output<typeof EventSearchIndexQuerySchema>

export const EventSearchIndexSuccessSchema = z.strictObject({
  data: EventSearchPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type EventSearchIndexSuccess = z.output<typeof EventSearchIndexSuccessSchema>

export const EventSearchShowPathSchema = z.object({
  slug: z.string()
})

export type EventSearchShowPath = z.output<typeof EventSearchShowPathSchema>

export const EventSearchShowSuccessSchema = z.object({
  data: EventSearchResultSchema
})

export type EventSearchShowSuccess = z.output<typeof EventSearchShowSuccessSchema>

export const FavoritesSyncRequestSchema = SyncGuestFavoritesRequestSchema

export type FavoritesSyncRequest = z.output<typeof FavoritesSyncRequestSchema>

export const FavoritesSyncSuccessSchema = z.strictObject({
  data: GuestFavoritesSyncResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type FavoritesSyncSuccess = z.output<typeof FavoritesSyncSuccessSchema>

export const FavoritesToggleRequestSchema = FavoriteStoreToggleRequestSchema

export type FavoritesToggleRequest = z.output<typeof FavoritesToggleRequestSchema>

export const FavoritesToggleSuccessSchema = z.strictObject({
  data: FavoriteToggleResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type FavoritesToggleSuccess = z.output<typeof FavoritesToggleSuccessSchema>

export const FavoritesCheckPathSchema = z.object({
  store: z.int()
})

export type FavoritesCheckPath = z.output<typeof FavoritesCheckPathSchema>

export const FavoritesCheckSuccessSchema = z.strictObject({
  data: FavoriteToggleResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type FavoritesCheckSuccess = z.output<typeof FavoritesCheckSuccessSchema>

export const PartnerUserInvitationShowOrganizerQuerySchema = z.object({
  email: z.email(),
  token: z.string().min(1)
})

export type PartnerUserInvitationShowOrganizerQuery = z.output<
  typeof PartnerUserInvitationShowOrganizerQuerySchema
>

export const PartnerUserInvitationShowOrganizerSuccessSchema = z.strictObject({
  data: OrganizerInvitationLookupSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUserInvitationShowOrganizerSuccess = z.output<
  typeof PartnerUserInvitationShowOrganizerSuccessSchema
>

export const PartnerUserInvitationAcceptOrganizerRequestSchema =
  AcceptPartnerUserInviteRequestSchema

export type PartnerUserInvitationAcceptOrganizerRequest = z.output<
  typeof PartnerUserInvitationAcceptOrganizerRequestSchema
>

export const PartnerUserInvitationAcceptOrganizerSuccessSchema = z.strictObject({
  data: UserDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUserInvitationAcceptOrganizerSuccess = z.output<
  typeof PartnerUserInvitationAcceptOrganizerSuccessSchema
>

export const PartnerUserInvitationShowQuerySchema = z.object({
  email: z.email(),
  token: z.string().min(1)
})

export type PartnerUserInvitationShowQuery = z.output<typeof PartnerUserInvitationShowQuerySchema>

export const PartnerUserInvitationShowSuccessSchema = z.strictObject({
  data: PartnerInvitationLookupSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUserInvitationShowSuccess = z.output<
  typeof PartnerUserInvitationShowSuccessSchema
>

export const PartnerUserInvitationAcceptRequestSchema = AcceptPartnerUserInviteRequestSchema

export type PartnerUserInvitationAcceptRequest = z.output<
  typeof PartnerUserInvitationAcceptRequestSchema
>

export const PartnerUserInvitationAcceptSuccessSchema = z.strictObject({
  data: UserDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUserInvitationAcceptSuccess = z.output<
  typeof PartnerUserInvitationAcceptSuccessSchema
>

export const LeadStoreRequestSchema2 = LeadStoreRequestSchema

export type LeadStoreRequest2 = z.output<typeof LeadStoreRequestSchema2>

export const LeadStoreSuccessSchema = z.strictObject({
  data: LeadSubmissionSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type LeadStoreSuccess = z.output<typeof LeadStoreSuccessSchema>

export const LegalAgreementIndexQuerySchema = z.object({
  type: LegalAgreementTypeSchema.optional(),
  order_number: z.string().max(64).optional(),
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional()
})

export type LegalAgreementIndexQuery = z.output<typeof LegalAgreementIndexQuerySchema>

export const LegalAgreementIndexSuccessSchema = z.strictObject({
  data: LegalAgreementPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type LegalAgreementIndexSuccess = z.output<typeof LegalAgreementIndexSuccessSchema>

export const LegalAgreementShowPathSchema = z.object({
  id: z.string()
})

export type LegalAgreementShowPath = z.output<typeof LegalAgreementShowPathSchema>

export const LegalAgreementShowSuccessSchema = z.strictObject({
  data: z.union([
    PendingPartnerAgreementSchema,
    AcceptedPartnerAgreementSchema,
    SupersededPartnerAgreementSchema,
    PendingBeoAgreementSchema,
    AcceptedBeoAgreementSchema,
    PendingTermsAndConditionsSchema,
    AcceptedTermsAndConditionsSchema,
    SupersededTermsAndConditionsSchema,
    PendingPrivacyPolicySchema,
    AcceptedPrivacyPolicySchema,
    SupersededPrivacyPolicySchema,
    UnacceptedSupersededTermsAndConditionsSchema,
    UnacceptedSupersededPrivacyPolicySchema
  ]),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type LegalAgreementShowSuccess = z.output<typeof LegalAgreementShowSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const LegalAgreementAcceptRequestSchema = z.record(z.string(), z.unknown())

export type LegalAgreementAcceptRequest = z.output<typeof LegalAgreementAcceptRequestSchema>

export const LegalAgreementAcceptPathSchema = z.object({
  id: z.string()
})

export type LegalAgreementAcceptPath = z.output<typeof LegalAgreementAcceptPathSchema>

export const LegalAgreementAcceptSuccessSchema = z.strictObject({
  data: z.union([
    PendingPartnerAgreementSchema,
    AcceptedPartnerAgreementSchema,
    SupersededPartnerAgreementSchema,
    PendingBeoAgreementSchema,
    AcceptedBeoAgreementSchema,
    PendingTermsAndConditionsSchema,
    AcceptedTermsAndConditionsSchema,
    SupersededTermsAndConditionsSchema,
    PendingPrivacyPolicySchema,
    AcceptedPrivacyPolicySchema,
    SupersededPrivacyPolicySchema,
    UnacceptedSupersededTermsAndConditionsSchema,
    UnacceptedSupersededPrivacyPolicySchema
  ]),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type LegalAgreementAcceptSuccess = z.output<typeof LegalAgreementAcceptSuccessSchema>

export const LegalAgreementDocumentPathSchema = z.object({
  id: z.string()
})

export type LegalAgreementDocumentPath = z.output<typeof LegalAgreementDocumentPathSchema>

/**
 * Legal agreement PDF.
 */
export const LegalAgreementDocumentSuccessSchema = z.string()

export type LegalAgreementDocumentSuccess = z.output<typeof LegalAgreementDocumentSuccessSchema>

export const LegalAgreementEmailRequestSchema = EmailLegalAgreementRequestSchema

export type LegalAgreementEmailRequest = z.output<typeof LegalAgreementEmailRequestSchema>

export const LegalAgreementEmailPathSchema = z.object({
  id: z.string()
})

export type LegalAgreementEmailPath = z.output<typeof LegalAgreementEmailPathSchema>

export const LegalAgreementEmailSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type LegalAgreementEmailSuccess = z.output<typeof LegalAgreementEmailSuccessSchema>

export const LegalTermsShowPathSchema = z.object({
  type: LegalTermsTypeSchema
})

export type LegalTermsShowPath = z.output<typeof LegalTermsShowPathSchema>

export const LegalTermsShowSuccessSchema = z.strictObject({
  data: CurrentLegalTermsSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type LegalTermsShowSuccess = z.output<typeof LegalTermsShowSuccessSchema>

export const MenuOptionsSuccessSchema = z.strictObject({
  data: z.array(MenuOptionSummarySchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuOptionsSuccess = z.output<typeof MenuOptionsSuccessSchema>

export const OrderIndexQuerySchema = z.object({
  status: z.union([OrderStatusSchema, z.enum(['all'])]).optional(),
  store_id: z.union([z.int().gte(1), z.enum(['all'])]).optional(),
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional()
})

export type OrderIndexQuery = z.output<typeof OrderIndexQuerySchema>

export const OrderIndexSuccessSchema = z.strictObject({
  data: CustomerOrderPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type OrderIndexSuccess = z.output<typeof OrderIndexSuccessSchema>

export const OrderShowPathSchema = z.object({
  identifier: z.string()
})

export type OrderShowPath = z.output<typeof OrderShowPathSchema>

export const OrderShowSuccessSchema = z.strictObject({
  data: z.object({
    order: CustomerOrderDataSchema
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type OrderShowSuccess = z.output<typeof OrderShowSuccessSchema>

export const OrderShowPaymentPathSchema = z.object({
  identifier: z.string()
})

export type OrderShowPaymentPath = z.output<typeof OrderShowPaymentPathSchema>

export const OrderShowPaymentSuccessSchema = z.union([
  z.strictObject({
    data: z.object({
      balance_due: z.literal(0),
      charge_amount: z.number(),
      is_balance_payment: z.literal(false),
      is_full_charge: z.boolean(),
      order: CustomerOrderDataSchema,
      remaining_charge_at: z.string().nullable()
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.object({
      balance_due: z.number(),
      charge_amount: z.number(),
      is_balance_payment: z.literal(true),
      is_full_charge: z.boolean(),
      order: CustomerOrderDataSchema,
      remaining_charge_at: z.string().nullable()
    }),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type OrderShowPaymentSuccess = z.output<typeof OrderShowPaymentSuccessSchema>

export const PaymentStorePaymentRequestSchema = ProcessOrderPaymentRequestSchema

export type PaymentStorePaymentRequest = z.output<typeof PaymentStorePaymentRequestSchema>

export const PaymentStorePaymentPathSchema = z.object({
  identifier: z.string()
})

export type PaymentStorePaymentPath = z.output<typeof PaymentStorePaymentPathSchema>

export const PaymentStorePaymentSuccessSchema = z.strictObject({
  data: z.object({
    charge_amount: z.number(),
    is_full_charge: z.boolean(),
    order: CustomerOrderDataSchema,
    payment: PaymentDataSchema,
    payment_status: PaymentStatusSchema,
    remaining_charge_at: z.string().nullable()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentStorePaymentSuccess = z.output<typeof PaymentStorePaymentSuccessSchema>

export const PaymentRetryPaymentRequestSchema = ProcessOrderPaymentRequestSchema

export type PaymentRetryPaymentRequest = z.output<typeof PaymentRetryPaymentRequestSchema>

export const PaymentRetryPaymentPathSchema = z.object({
  identifier: z.string()
})

export type PaymentRetryPaymentPath = z.output<typeof PaymentRetryPaymentPathSchema>

export const PaymentRetryPaymentSuccessSchema = z.strictObject({
  data: z.object({
    balance_due: z.number(),
    charge_amount: z.number(),
    is_balance_payment: z.literal(true),
    is_full_charge: z.boolean(),
    order: CustomerOrderDataSchema,
    payment: PaymentDataSchema,
    payment_status: PaymentStatusSchema,
    remaining_charge_at: z.string().nullable()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentRetryPaymentSuccess = z.output<typeof PaymentRetryPaymentSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const OrderCancelRequestSchema = z.record(z.string(), z.unknown())

export type OrderCancelRequest = z.output<typeof OrderCancelRequestSchema>

export const OrderCancelPathSchema = z.object({
  order: z.string()
})

export type OrderCancelPath = z.output<typeof OrderCancelPathSchema>

export const OrderCancelSuccessSchema = z.strictObject({
  data: z.object({
    order: CustomerOrderDataSchema
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type OrderCancelSuccess = z.output<typeof OrderCancelSuccessSchema>

export const OrderModificationRequestStoreRequestSchema = StoreOrderModificationRequestSchema

export type OrderModificationRequestStoreRequest = z.output<
  typeof OrderModificationRequestStoreRequestSchema
>

export const OrderModificationRequestStorePathSchema = z.object({
  order: z.string()
})

export type OrderModificationRequestStorePath = z.output<
  typeof OrderModificationRequestStorePathSchema
>

export const OrderModificationRequestStoreSuccessSchema = z.strictObject({
  data: OrderModificationSubmissionSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type OrderModificationRequestStoreSuccess = z.output<
  typeof OrderModificationRequestStoreSuccessSchema
>

export const OrderPricingPreviewRequestSchema2 = OrderPricingPreviewRequestSchema

export type OrderPricingPreviewRequest2 = z.output<typeof OrderPricingPreviewRequestSchema2>

export const OrderPricingPreviewPathSchema = z.object({
  order: z.string()
})

export type OrderPricingPreviewPath = z.output<typeof OrderPricingPreviewPathSchema>

export const OrderPricingPreviewSuccessSchema = z.strictObject({
  data: z.object({
    application_fee: z.number(),
    delivery_fee: z.number(),
    item_count: z.number(),
    order_number: z.string(),
    sales_tax: z.number(),
    sales_tax_percentage: z.number(),
    sales_tax_rate: z.number(),
    store_id: z.int(),
    subtotal: z.number(),
    tip: z.number(),
    total: z.number()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type OrderPricingPreviewSuccess = z.output<typeof OrderPricingPreviewSuccessSchema>

export const PartnersIndexSuccessSchema = z.array(z.string()).length(0)

export type PartnersIndexSuccess = z.output<typeof PartnersIndexSuccessSchema>

export const PaymentMethodListSuccessSchema = z.strictObject({
  data: z.array(z.union([PaymentMethodLinkViewSchema, PaymentMethodCardViewSchema])),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentMethodListSuccess = z.output<typeof PaymentMethodListSuccessSchema>

export const PaymentMethodSaveRequestSchema = SavePaymentMethodRequestSchema

export type PaymentMethodSaveRequest = z.output<typeof PaymentMethodSaveRequestSchema>

export const PaymentMethodSaveSuccessSchema = z.strictObject({
  data: z.union([PaymentMethodLinkViewSchema, PaymentMethodCardViewSchema]),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentMethodSaveSuccess = z.output<typeof PaymentMethodSaveSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PaymentMethodSetupIntentRequestSchema = z.record(z.string(), z.unknown())

export type PaymentMethodSetupIntentRequest = z.output<typeof PaymentMethodSetupIntentRequestSchema>

export const PaymentMethodSetupIntentSuccessSchema = z.strictObject({
  data: z.object({
    client_secret: z.string().nullable(),
    setup_intent_id: z.string().nullable()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentMethodSetupIntentSuccess = z.output<typeof PaymentMethodSetupIntentSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PaymentMethodDeleteRequestSchema = z.record(z.string(), z.unknown())

export type PaymentMethodDeleteRequest = z.output<typeof PaymentMethodDeleteRequestSchema>

export const PaymentMethodDeletePathSchema = z.object({
  paymentMethod: z.int().gte(0)
})

export type PaymentMethodDeletePath = z.output<typeof PaymentMethodDeletePathSchema>

/**
 * No content
 */
export const PaymentMethodDeleteSuccessSchema = z.void()

export type PaymentMethodDeleteSuccess = z.output<typeof PaymentMethodDeleteSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PaymentMethodSetDefaultRequestSchema = z.record(z.string(), z.unknown())

export type PaymentMethodSetDefaultRequest = z.output<typeof PaymentMethodSetDefaultRequestSchema>

export const PaymentMethodSetDefaultPathSchema = z.object({
  paymentMethod: z.int().gte(0)
})

export type PaymentMethodSetDefaultPath = z.output<typeof PaymentMethodSetDefaultPathSchema>

export const PaymentMethodSetDefaultSuccessSchema = z.strictObject({
  data: z.union([PaymentMethodLinkViewSchema, PaymentMethodCardViewSchema]),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentMethodSetDefaultSuccess = z.output<typeof PaymentMethodSetDefaultSuccessSchema>

export const PaymentOnboardingWebsiteCandidatesQuerySchema = z.object({
  payable_type: PayableTypeSchema,
  payable_id: z.int().gte(1)
})

export type PaymentOnboardingWebsiteCandidatesQuery = z.output<
  typeof PaymentOnboardingWebsiteCandidatesQuerySchema
>

export const PaymentOnboardingWebsiteCandidatesSuccessSchema = z.strictObject({
  data: z.array(BrandWebsiteCandidateSchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentOnboardingWebsiteCandidatesSuccess = z.output<
  typeof PaymentOnboardingWebsiteCandidatesSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PaymentOnboardingDestroyRequestSchema = z.record(z.string(), z.unknown())

export type PaymentOnboardingDestroyRequest = z.output<typeof PaymentOnboardingDestroyRequestSchema>

export const PaymentOnboardingDestroyPathSchema = z.object({
  onboarding: z.int().gte(0)
})

export type PaymentOnboardingDestroyPath = z.output<typeof PaymentOnboardingDestroyPathSchema>

export const PaymentOnboardingDestroySuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('merchant_onboarding')
  }),
  success: z.literal(true)
})

export type PaymentOnboardingDestroySuccess = z.output<typeof PaymentOnboardingDestroySuccessSchema>

export const PaymentOnboardingSessionRequestSchema = CreateAccountSessionRequestSchema

export type PaymentOnboardingSessionRequest = z.output<typeof PaymentOnboardingSessionRequestSchema>

export const PaymentOnboardingSessionPathSchema = z.object({
  onboarding: z.int().gte(0)
})

export type PaymentOnboardingSessionPath = z.output<typeof PaymentOnboardingSessionPathSchema>

export const PaymentOnboardingSessionSuccessSchema = z.strictObject({
  data: z.object({
    account_id: z.string(),
    client_secret: z.string(),
    expires_at: z.int()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('merchant_onboarding_session')
  }),
  success: z.literal(true)
})

export type PaymentOnboardingSessionSuccess = z.output<typeof PaymentOnboardingSessionSuccessSchema>

export const PaymentOnboardingSyncPathSchema = z.object({
  onboarding: z.int().gte(0)
})

export type PaymentOnboardingSyncPath = z.output<typeof PaymentOnboardingSyncPathSchema>

export const PaymentOnboardingSyncSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('merchant_onboarding')
  }),
  success: z.literal(true)
})

export type PaymentOnboardingSyncSuccess = z.output<typeof PaymentOnboardingSyncSuccessSchema>

export const PayoutsForPartnerQuerySchema = z.object({
  status: z.union([PayoutStatusSchema, z.enum(['all'])]).optional(),
  order_number: z.string().optional(),
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional()
})

export type PayoutsForPartnerQuery = z.output<typeof PayoutsForPartnerQuerySchema>

/**
 * Paginated set of `PayoutResource`
 */
export const PayoutsForPartnerSuccessSchema = z.object({
  data: z.array(PayoutResourceSchema),
  links: z.object({
    first: z.string().nullable(),
    last: z.string().nullable(),
    next: z.string().nullable(),
    prev: z.string().nullable()
  }),
  meta: z.object({
    current_page: z.int().gte(1),
    from: z.int().gte(1).nullable(),
    last_page: z.int().gte(1),
    links: z.array(
      z.object({
        active: z.boolean(),
        label: z.string(),
        page: z.int().nullish(),
        url: z.string().nullable()
      })
    ),
    path: z.string().nullable(),
    per_page: z.int().gte(0),
    to: z.int().gte(1).nullable(),
    total: z.int().gte(0)
  })
})

export type PayoutsForPartnerSuccess = z.output<typeof PayoutsForPartnerSuccessSchema>

export const PayoutsForStorePathSchema = z.object({
  store: z.int().gte(0)
})

export type PayoutsForStorePath = z.output<typeof PayoutsForStorePathSchema>

export const PayoutsForStoreQuerySchema = z.object({
  status: z.union([PayoutStatusSchema, z.enum(['all'])]).optional(),
  order_number: z.string().optional(),
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional()
})

export type PayoutsForStoreQuery = z.output<typeof PayoutsForStoreQuerySchema>

/**
 * Paginated set of `PayoutResource`
 */
export const PayoutsForStoreSuccessSchema = z.object({
  data: z.array(PayoutResourceSchema),
  links: z.object({
    first: z.string().nullable(),
    last: z.string().nullable(),
    next: z.string().nullable(),
    prev: z.string().nullable()
  }),
  meta: z.object({
    current_page: z.int().gte(1),
    from: z.int().gte(1).nullable(),
    last_page: z.int().gte(1),
    links: z.array(
      z.object({
        active: z.boolean(),
        label: z.string(),
        page: z.int().nullish(),
        url: z.string().nullable()
      })
    ),
    path: z.string().nullable(),
    per_page: z.int().gte(0),
    to: z.int().gte(1).nullable(),
    total: z.int().gte(0)
  })
})

export type PayoutsForStoreSuccess = z.output<typeof PayoutsForStoreSuccessSchema>

export const PayoutsShowPathSchema = z.object({
  payout: z.string().regex(/^[0-9A-F]{7}$/)
})

export type PayoutsShowPath = z.output<typeof PayoutsShowPathSchema>

/**
 * `PayoutResource`
 */
export const PayoutsShowSuccessSchema = z.object({
  data: PayoutResourceSchema
})

export type PayoutsShowSuccess = z.output<typeof PayoutsShowSuccessSchema>

export const PayoutsDownloadPathSchema = z.object({
  payout: z.string().regex(/^[0-9A-F]{7}$/)
})

export type PayoutsDownloadPath = z.output<typeof PayoutsDownloadPathSchema>

/**
 * Payout statement PDF.
 */
export const PayoutsDownloadSuccessSchema = z.string()

export type PayoutsDownloadSuccess = z.output<typeof PayoutsDownloadSuccessSchema>

/**
 * Register using first_name and last_name.
 */
export const CustomerRegistrationRegisterRequestSchema = z.object({
  email: z.email().min(1).max(255),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  guest_token: z.string().nullish(),
  hubspotutk: z.string().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  recaptcha_token: z.string().optional(),
  sms_marketing_consent: z.boolean().optional(),
  sms_transactional_consent: z.union([
    z.literal('yes'),
    z.literal('on'),
    z.literal('1'),
    z.literal(1),
    z.literal('true'),
    z.literal(true)
  ]),
  timezone: z.string().nullish()
})

export type CustomerRegistrationRegisterRequest = z.output<
  typeof CustomerRegistrationRegisterRequestSchema
>

export const CustomerRegistrationRegisterSuccessSchema = z.strictObject({
  data: z.object({
    token: z.string(),
    user: UserDtoSchema
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type CustomerRegistrationRegisterSuccess = z.output<
  typeof CustomerRegistrationRegisterSuccessSchema
>

/**
 * Register using first_name and last_name.
 */
export const OrganizerRegistrationRegisterRequestSchema = z.object({
  email: z.email().min(1).max(255),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  guest_token: z.string().nullish(),
  hubspotutk: z.string().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  organization_address: z.string().max(255).nullish(),
  organization_address2: z.string().max(255).nullish(),
  organization_city: z.string().max(255).nullish(),
  organization_country: z.string().max(255).nullish(),
  organization_name: z.string().min(1).max(255),
  organization_state: z.string().max(255).nullish(),
  organization_zip_code: z.string().max(20).nullish(),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  phone: z
    .string()
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .nullish(),
  recaptcha_token: z.string().optional(),
  remember: z.boolean().optional(),
  sms_marketing_consent: z.boolean().optional(),
  sms_transactional_consent: z.union([
    z.literal('yes'),
    z.literal('on'),
    z.literal('1'),
    z.literal(1),
    z.literal('true'),
    z.literal(true)
  ]),
  timezone: z.string().nullish()
})

export type OrganizerRegistrationRegisterRequest = z.output<
  typeof OrganizerRegistrationRegisterRequestSchema
>

export const OrganizerRegistrationRegisterSuccessSchema = z.strictObject({
  data: z.object({
    token: z.string(),
    user: UserDtoSchema
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type OrganizerRegistrationRegisterSuccess = z.output<
  typeof OrganizerRegistrationRegisterSuccessSchema
>

/**
 * Complete registration with account details.
 */
export const PartnerRegistrationRegisterRequestSchema = z.object({
  email: z.email().min(1).max(255),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  guest_token: z.string().nullish(),
  hubspotutk: z.string().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/),
  recaptcha_token: z.string().optional(),
  remember: z.boolean().optional(),
  sms_marketing_consent: z.boolean().optional(),
  sms_transactional_consent: z.union([
    z.literal('yes'),
    z.literal('on'),
    z.literal('1'),
    z.literal(1),
    z.literal('true'),
    z.literal(true)
  ])
})

export type PartnerRegistrationRegisterRequest = z.output<
  typeof PartnerRegistrationRegisterRequestSchema
>

export const PartnerRegistrationRegisterSuccessSchema = z.strictObject({
  data: IssuedPartnerRegistrationResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerRegistrationRegisterSuccess = z.output<
  typeof PartnerRegistrationRegisterSuccessSchema
>

/**
 * Capture partial account details without final registration side effects.
 */
export const PartnerRegistrationDraftRequestSchema = z.object({
  application_token: z.string().nullish(),
  email: z.email().min(1).max(255).optional(),
  first_name: z.string().min(1).max(255).optional(),
  'g-recaptcha-response': z.string().optional(),
  guest_token: z.string().nullish(),
  hubspotutk: z.string().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/)
    .optional(),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/)
    .optional(),
  recaptcha_token: z.string().optional(),
  sms_marketing_consent: z.boolean().optional(),
  sms_transactional_consent: z
    .union([
      z.literal('yes'),
      z.literal('on'),
      z.literal('1'),
      z.literal(1),
      z.literal('true'),
      z.literal(true)
    ])
    .optional()
})

export type PartnerRegistrationDraftRequest = z.output<typeof PartnerRegistrationDraftRequestSchema>

export const PartnerRegistrationDraftSuccessSchema = z.strictObject({
  data: z.object({
    captured: z.literal(true)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerRegistrationDraftSuccess = z.output<typeof PartnerRegistrationDraftSuccessSchema>

/**
 * Validate account details.
 */
export const PartnerRegistrationValidateRequestSchema = z.object({
  email: z.email().min(1).max(255),
  first_name: z.string().min(1).max(255),
  'g-recaptcha-response': z.string().optional(),
  guest_token: z.string().nullish(),
  hubspotutk: z.string().optional(),
  last_name: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[^<>]+$/),
  pageName: z.string().optional(),
  pageUri: z.string().optional(),
  password: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  password_confirmation: z
    .string()
    .min(8)
    .regex(
      /^(?=[\s\S]*\p{Ll})(?=[\s\S]*\p{Lu})(?=[\s\S]*\p{N})(?=[\s\S]*[\p{Z}\p{S}\p{P}])(?![\s\S]*[\u{10000}-\u{10FFFF}])(?![\s\S]*\p{Extended_Pictographic})(?![\s\S]*\u{20E3})[\s\S]*$/u,
      'Password must include an uppercase letter, a lowercase letter, a number, and a symbol.'
    ),
  phone: z
    .string()
    .min(1)
    .regex(/^(?:\+?1[-.\s]?)?(?:\([2-9]\d{2}\)|[2-9]\d{2})[-.\s]?[2-9]\d{2}[-.\s]?\d{4}$/),
  recaptcha_token: z.string().optional(),
  sms_marketing_consent: z.boolean().optional(),
  sms_transactional_consent: z.union([
    z.literal('yes'),
    z.literal('on'),
    z.literal('1'),
    z.literal(1),
    z.literal('true'),
    z.literal(true)
  ])
})

export type PartnerRegistrationValidateRequest = z.output<
  typeof PartnerRegistrationValidateRequestSchema
>

export const PartnerRegistrationValidateSuccessSchema = z.strictObject({
  data: z.object({
    valid: z.literal(true)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerRegistrationValidateSuccess = z.output<
  typeof PartnerRegistrationValidateSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreReviewDestroyRequestSchema = z.record(z.string(), z.unknown())

export type StoreReviewDestroyRequest = z.output<typeof StoreReviewDestroyRequestSchema>

export const StoreReviewDestroyPathSchema = z.object({
  review: z.int()
})

export type StoreReviewDestroyPath = z.output<typeof StoreReviewDestroyPathSchema>

/**
 * No content
 */
export const StoreReviewDestroySuccessSchema = z.void()

export type StoreReviewDestroySuccess = z.output<typeof StoreReviewDestroySuccessSchema>

export const StoreReviewUpdateRequestSchema2 = StoreReviewUpdateRequestSchema

export type StoreReviewUpdateRequest2 = z.output<typeof StoreReviewUpdateRequestSchema2>

export const StoreReviewUpdatePathSchema = z.object({
  review: z.int()
})

export type StoreReviewUpdatePath = z.output<typeof StoreReviewUpdatePathSchema>

export const StoreReviewUpdateSuccessSchema = z.strictObject({
  data: StoreReviewSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreReviewUpdateSuccess = z.output<typeof StoreReviewUpdateSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const StoreReviewMarkHelpfulRequestSchema = z.record(z.string(), z.unknown())

export type StoreReviewMarkHelpfulRequest = z.output<typeof StoreReviewMarkHelpfulRequestSchema>

export const StoreReviewMarkHelpfulPathSchema = z.object({
  review: z.int()
})

export type StoreReviewMarkHelpfulPath = z.output<typeof StoreReviewMarkHelpfulPathSchema>

export const StoreReviewMarkHelpfulSuccessSchema = z.strictObject({
  data: StoreReviewSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreReviewMarkHelpfulSuccess = z.output<typeof StoreReviewMarkHelpfulSuccessSchema>

export const SearchCategoriesSuccessSchema = z.strictObject({
  data: z.object({
    categories: z.array(CategoryDtoSchema),
    count: z.int()
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type SearchCategoriesSuccess = z.output<typeof SearchCategoriesSuccessSchema>

export const SearchDietaryOptionsSuccessSchema = z.strictObject({
  data: z.object({
    count: z.int(),
    dietaryOptions: z.array(DietaryOptionDtoSchema)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type SearchDietaryOptionsSuccess = z.output<typeof SearchDietaryOptionsSuccessSchema>

export const SearchPopularTagsSuccessSchema = z.strictObject({
  data: z.object({
    count: z.int(),
    tags: z.array(TagDtoSchema)
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type SearchPopularTagsSuccess = z.output<typeof SearchPopularTagsSuccessSchema>

export const SearchSearchQuerySchema = z.object({
  q: z.string().max(255).nullish(),
  lat: z.number().nullish(),
  lng: z.number().nullish(),
  radius_miles: z.number().gte(1).lte(200).nullish(),
  bbox: z.string().nullish(),
  place_type: GeocodingPlaceTypeSchema.nullish(),
  brand_id: z.union([z.int(), z.enum(['all'])]).nullish(),
  cuisineOption: z.union([z.int(), z.enum(['all'])]).nullish(),
  dietaryOptions: z.string().nullish(),
  tags: z.string().nullish(),
  deliveryFee: z.number().gte(0).lte(100).nullish(),
  ratings: z.union([z.number().gte(0).lte(5), z.enum(['all'])]).nullish(),
  reliabilitySuperstar: z.boolean().optional(),
  isNew: z.boolean().optional(),
  smallBusiness: z.boolean().optional(),
  featured: z.boolean().optional(),
  orderMinimum: z.number().gte(0).nullish(),
  distance: z.number().gte(1).lte(200).nullish(),
  groupOrdering: z.boolean().optional(),
  individualPackaging: z.boolean().optional(),
  order_type: OrderTypeSchema.nullish(),
  guest_count: z.int().gte(1).nullish(),
  requested_date: z.iso.date().nullish(),
  requested_time: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
    .nullish(),
  event_id: z.int().nullish(),
  event_slug: z.string().nullish(),
  per_page: z.int().gte(1).lte(100).nullish(),
  page: z.int().gte(1).lte(100000).nullish(),
  is_favorite: z.boolean().optional(),
  userId: z.number().nullish()
})

export type SearchSearchQuery = z.output<typeof SearchSearchQuerySchema>

export const SearchSearchSuccessSchema = z.strictObject({
  data: StoreSearchResultsPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type SearchSearchSuccess = z.output<typeof SearchSearchSuccessSchema>

export const SearchTagsSuccessSchema = z.strictObject({
  data: z.object({
    groups: z.array(z.string()),
    tags: z.record(z.string(), z.array(TagDtoSchema))
  }),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type SearchTagsSuccess = z.output<typeof SearchTagsSuccessSchema>

export const StoreShowQuerySchema = z.object({
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/),
  userId: z.number().nullish(),
  requested_date: z.iso.date().nullish(),
  requested_time: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
    .nullish(),
  include_reviews: z.string().optional().default('false')
})

export type StoreShowQuery = z.output<typeof StoreShowQuerySchema>

export const StoreShowSuccessSchema = z.strictObject({
  data: PublicStoreDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreShowSuccess = z.output<typeof StoreShowSuccessSchema>

export const StoreAvailabilityCheckQuerySchema = z.object({
  store_id: z.union([z.int().gte(1), z.string()]),
  order_type: OrderTypeSchema,
  check_menu: z.boolean().optional(),
  address: z.string().max(255).nullish(),
  requested_date: z.iso.date(),
  requested_time: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  menu_id: z.int().nullish(),
  'menu_ids[]': z.array(z.int()).optional(),
  guest_count: z.int().gte(1).optional().default(1),
  subtotal: z.number().gte(0).nullish(),
  order_total: z.number().gte(0).nullish(),
  lat: z.number().gte(-90).lte(90).nullish(),
  lng: z.number().gte(-180).lte(180).nullish()
})

export type StoreAvailabilityCheckQuery = z.output<typeof StoreAvailabilityCheckQuerySchema>

export const StoreAvailabilityCheckSuccessSchema = z.union([
  z.strictObject({
    data: StoreAvailabilityMenuCheckResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StoreAvailabilityAvailableResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StoreAvailabilityLeadTimeResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StoreAvailabilityPastTimeResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StoreAvailabilityOperatingHoursResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StoreAvailabilityUnavailableSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StoreAvailabilityDeliveryRadiusResultSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type StoreAvailabilityCheckSuccess = z.output<typeof StoreAvailabilityCheckSuccessSchema>

export const StoreReviewGoogleReviewsQuerySchema = z.object({
  slug: z
    .string()
    .max(255)
    .regex(/^[a-z0-9-]+$/)
    .optional(),
  store_id: z.int().gte(1).optional(),
  page: z.int().gte(1).optional(),
  rating: z.union([z.int().gte(1).lte(5), z.enum(['all'])]).optional(),
  sort: z.enum(['helpful', 'oldest']).optional()
})

export type StoreReviewGoogleReviewsQuery = z.output<typeof StoreReviewGoogleReviewsQuerySchema>

export const StoreReviewGoogleReviewsSuccessSchema = z.union([
  z.strictObject({
    data: GoogleReviewListingPageSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StoreReviewListingPageSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type StoreReviewGoogleReviewsSuccess = z.output<typeof StoreReviewGoogleReviewsSuccessSchema>

export const StoreMenusQuerySchema = z.object({
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/),
  menu_type: z.union([z.string(), z.enum(['all'])]).nullish(),
  order_type: OrderTypeSchema.nullish(),
  requested_date: z.iso.date().nullish(),
  requested_time: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/)
    .nullish()
})

export type StoreMenusQuery = z.output<typeof StoreMenusQuerySchema>

export const StoreMenusSuccessSchema = z.strictObject({
  data: PublicStoreMenuCatalogSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreMenusSuccess = z.output<typeof StoreMenusSuccessSchema>

export const StoreReviewIndexQuerySchema = z.object({
  slug: z
    .string()
    .max(255)
    .regex(/^[a-z0-9-]+$/)
    .optional(),
  store_id: z.int().gte(1).optional(),
  page: z.int().gte(1).optional(),
  rating: z.union([z.int().gte(1).lte(5), z.enum(['all'])]).optional(),
  sort: z.enum(['helpful']).optional()
})

export type StoreReviewIndexQuery = z.output<typeof StoreReviewIndexQuerySchema>

export const StoreReviewIndexSuccessSchema = z.strictObject({
  data: StoreReviewListingPageSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreReviewIndexSuccess = z.output<typeof StoreReviewIndexSuccessSchema>

export const StoreReviewShowPathSchema = z.object({
  token: z.string()
})

export type StoreReviewShowPath = z.output<typeof StoreReviewShowPathSchema>

export const StoreReviewShowSuccessSchema = z.strictObject({
  data: StoreReviewFormSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreReviewShowSuccess = z.output<typeof StoreReviewShowSuccessSchema>

export const StoreReviewSubmitTokenReviewRequestSchema = SubmitStoreReviewRequestSchema

export type StoreReviewSubmitTokenReviewRequest = z.output<
  typeof StoreReviewSubmitTokenReviewRequestSchema
>

export const StoreReviewSubmitTokenReviewPathSchema = z.object({
  token: z.string()
})

export type StoreReviewSubmitTokenReviewPath = z.output<
  typeof StoreReviewSubmitTokenReviewPathSchema
>

export const StoreReviewSubmitTokenReviewSuccessSchema = z.strictObject({
  data: StoreReviewSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreReviewSubmitTokenReviewSuccess = z.output<
  typeof StoreReviewSubmitTokenReviewSuccessSchema
>

export const StoreSameBrandStoresQuerySchema = z.object({
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/),
  max_distance: z.number().gte(1).lte(500).nullish()
})

export type StoreSameBrandStoresQuery = z.output<typeof StoreSameBrandStoresQuerySchema>

export const StoreSameBrandStoresSuccessSchema = z.strictObject({
  data: SameBrandStoresSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreSameBrandStoresSuccess = z.output<typeof StoreSameBrandStoresSuccessSchema>

export const StoreReviewStoreRequestSchema = StoreReviewCreateRequestSchema

export type StoreReviewStoreRequest = z.output<typeof StoreReviewStoreRequestSchema>

export const StoreReviewStorePathSchema = z.object({
  store: z.int()
})

export type StoreReviewStorePath = z.output<typeof StoreReviewStorePathSchema>

export const StoreReviewStoreSuccessSchema = z.strictObject({
  data: StoreReviewSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type StoreReviewStoreSuccess = z.output<typeof StoreReviewStoreSuccessSchema>

export const StripeWebhookRequestSchema = z.object({
  id: z.string(),
  type: z.string()
})

export type StripeWebhookRequest = z.output<typeof StripeWebhookRequestSchema>

export const StripeWebhookHeaderSchema = z.object({
  'Stripe-Signature': z.string()
})

export type StripeWebhookHeader = z.output<typeof StripeWebhookHeaderSchema>

export const StripeWebhookSuccessSchema = z.union([
  z.strictObject({
    data: z.null(),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: StripeWebhookAcknowledgementSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type StripeWebhookSuccess = z.output<typeof StripeWebhookSuccessSchema>

export const MenuSupportRequestSchema = SubmitMenuSupportRequestSchema

export type MenuSupportRequest = z.output<typeof MenuSupportRequestSchema>

export const MenuSupportSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type MenuSupportSuccess = z.output<typeof MenuSupportSuccessSchema>

export const TwoFactorTestAssistChallengeCodeHeaderSchema = z.object({
  'X-Challenge-Token': z.string()
})

export type TwoFactorTestAssistChallengeCodeHeader = z.output<
  typeof TwoFactorTestAssistChallengeCodeHeaderSchema
>

export const TwoFactorTestAssistChallengeCodeSuccessSchema = z.strictObject({
  data: TwoFactorTestAssistCodeSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorTestAssistChallengeCodeSuccess = z.output<
  typeof TwoFactorTestAssistChallengeCodeSuccessSchema
>

export const TwoFactorTestAssistStepUpCodeSuccessSchema = z.strictObject({
  data: TwoFactorTestAssistCodeSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorTestAssistStepUpCodeSuccess = z.output<
  typeof TwoFactorTestAssistStepUpCodeSuccessSchema
>

export const TwoFactorChallengeRequestSchema2 = TwoFactorChallengeRequestSchema

export type TwoFactorChallengeRequest2 = z.output<typeof TwoFactorChallengeRequestSchema2>

export const TwoFactorChallengeSuccessSchema = z.strictObject({
  data: SessionTokenResultSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorChallengeSuccess = z.output<typeof TwoFactorChallengeSuccessSchema>

export const UserAccessProfileSuccessSchema = z.strictObject({
  data: UserDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type UserAccessProfileSuccess = z.output<typeof UserAccessProfileSuccessSchema>

export const PasswordConfirmationStoreRequestSchema = ConfirmPasswordRequestSchema

export type PasswordConfirmationStoreRequest = z.output<
  typeof PasswordConfirmationStoreRequestSchema
>

export const PasswordConfirmationStoreSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PasswordConfirmationStoreSuccess = z.output<
  typeof PasswordConfirmationStoreSuccessSchema
>

export const UserConfirmTwoFactorRequestSchema = ConfirmTwoFactorRequestSchema

export type UserConfirmTwoFactorRequest = z.output<typeof UserConfirmTwoFactorRequestSchema>

export const UserConfirmTwoFactorSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type UserConfirmTwoFactorSuccess = z.output<typeof UserConfirmTwoFactorSuccessSchema>

export const TwoFactorSettingsConfirmRequestSchema = ConfirmTwoFactorAuthenticationRequestSchema

export type TwoFactorSettingsConfirmRequest = z.output<typeof TwoFactorSettingsConfirmRequestSchema>

export const TwoFactorSettingsConfirmSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorSettingsConfirmSuccess = z.output<typeof TwoFactorSettingsConfirmSuccessSchema>

export const UserAccessLogoutOtherSessionsRequestSchema = LogoutOtherSessionsRequestSchema

export type UserAccessLogoutOtherSessionsRequest = z.output<
  typeof UserAccessLogoutOtherSessionsRequestSchema
>

export const UserAccessLogoutOtherSessionsSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type UserAccessLogoutOtherSessionsSuccess = z.output<
  typeof UserAccessLogoutOtherSessionsSuccessSchema
>

/**
 * Notification IDs to delete from the authenticated user inbox.
 */
export const NotificationInboxDestroyRequestSchema = z.object({
  notifications: z.array(z.string()).min(1)
})

export type NotificationInboxDestroyRequest = z.output<typeof NotificationInboxDestroyRequestSchema>

export const NotificationInboxDestroySuccessSchema = z.strictObject({
  data: NotificationInboxClearSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type NotificationInboxDestroySuccess = z.output<typeof NotificationInboxDestroySuccessSchema>

export const NotificationInboxIndexQuerySchema = z.object({
  page: z.int().gte(1).optional(),
  per_page: z.int().gte(1).lte(100).optional(),
  unread_only: z.boolean().optional()
})

export type NotificationInboxIndexQuery = z.output<typeof NotificationInboxIndexQuerySchema>

export const NotificationInboxIndexSuccessSchema = z.object({
  data: z.array(NotificationInboxDtoSchema),
  links: z.object({
    first: z.string(),
    last: z.null(),
    next: z.string().nullable(),
    prev: z.string().nullable()
  }),
  meta: z.object({
    current_page: z.int(),
    current_page_url: z.string(),
    from: z.int().nullable(),
    path: z.string(),
    per_page: z.int(),
    to: z.int().nullable()
  })
})

export type NotificationInboxIndexSuccess = z.output<typeof NotificationInboxIndexSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const NotificationInboxMarkAllAsReadRequestSchema = z.record(z.string(), z.unknown())

export type NotificationInboxMarkAllAsReadRequest = z.output<
  typeof NotificationInboxMarkAllAsReadRequestSchema
>

export const NotificationInboxMarkAllAsReadSuccessSchema = z.strictObject({
  data: NotificationInboxMarkAllReadSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type NotificationInboxMarkAllAsReadSuccess = z.output<
  typeof NotificationInboxMarkAllAsReadSuccessSchema
>

export const NotificationInboxUnreadCountSuccessSchema = z.strictObject({
  data: NotificationInboxUnreadCountSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type NotificationInboxUnreadCountSuccess = z.output<
  typeof NotificationInboxUnreadCountSuccessSchema
>

export const NotificationInboxMarkAsReadRequestSchema = MarkNotificationAsReadRequestSchema

export type NotificationInboxMarkAsReadRequest = z.output<
  typeof NotificationInboxMarkAsReadRequestSchema
>

export const NotificationInboxMarkAsReadPathSchema = z.object({
  notification: z.string()
})

export type NotificationInboxMarkAsReadPath = z.output<typeof NotificationInboxMarkAsReadPathSchema>

export const NotificationInboxMarkAsReadSuccessSchema = z.strictObject({
  data: NotificationInboxDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type NotificationInboxMarkAsReadSuccess = z.output<
  typeof NotificationInboxMarkAsReadSuccessSchema
>

export const PasswordSettingsUpdateRequestSchema = UpdatePasswordRequestSchema

export type PasswordSettingsUpdateRequest = z.output<typeof PasswordSettingsUpdateRequestSchema>

export const PasswordSettingsUpdateSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PasswordSettingsUpdateSuccess = z.output<typeof PasswordSettingsUpdateSuccessSchema>

export const PhoneVerifyRequestSchema = CheckPhoneVerificationRequestSchema

export type PhoneVerifyRequest = z.output<typeof PhoneVerifyRequestSchema>

export const PhoneVerifySuccessSchema = z.union([
  z.strictObject({
    data: PhoneVerifiedSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.null(),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type PhoneVerifySuccess = z.output<typeof PhoneVerifySuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PhoneVerifyResendRequestSchema = z.record(z.string(), z.unknown())

export type PhoneVerifyResendRequest = z.output<typeof PhoneVerifyResendRequestSchema>

export const PhoneVerifyResendSuccessSchema = z.union([
  z.strictObject({
    data: PhoneVerificationCooldownSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.null(),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type PhoneVerifyResendSuccess = z.output<typeof PhoneVerifyResendSuccessSchema>

export const PhoneVerifyStatusSuccessSchema = z.strictObject({
  data: PhoneVerificationStatusSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PhoneVerifyStatusSuccess = z.output<typeof PhoneVerifyStatusSuccessSchema>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const TwoFactorSettingsDisableRequestSchema = z.record(z.string(), z.unknown())

export type TwoFactorSettingsDisableRequest = z.output<typeof TwoFactorSettingsDisableRequestSchema>

export const TwoFactorSettingsDisableSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorSettingsDisableSuccess = z.output<typeof TwoFactorSettingsDisableSuccessSchema>

export const TwoFactorSettingsEnableRequestSchema = z.object({
  force: z.boolean().optional().default(false)
})

export type TwoFactorSettingsEnableRequest = z.output<typeof TwoFactorSettingsEnableRequestSchema>

export const TwoFactorSettingsEnableSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorSettingsEnableSuccess = z.output<typeof TwoFactorSettingsEnableSuccessSchema>

export const TwoFactorSettingsQrCodeSuccessSchema = z.strictObject({
  data: TwoFactorQrCodeSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorSettingsQrCodeSuccess = z.output<typeof TwoFactorSettingsQrCodeSuccessSchema>

export const TwoFactorSettingsRecoveryCodesSuccessSchema = z.strictObject({
  data: z.array(z.string()),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorSettingsRecoveryCodesSuccess = z.output<
  typeof TwoFactorSettingsRecoveryCodesSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const TwoFactorSettingsRegenerateRecoveryCodesRequestSchema = z.record(
  z.string(),
  z.unknown()
)

export type TwoFactorSettingsRegenerateRecoveryCodesRequest = z.output<
  typeof TwoFactorSettingsRegenerateRecoveryCodesRequestSchema
>

export const TwoFactorSettingsRegenerateRecoveryCodesSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorSettingsRegenerateRecoveryCodesSuccess = z.output<
  typeof TwoFactorSettingsRegenerateRecoveryCodesSuccessSchema
>

export const TwoFactorSettingsSecretKeySuccessSchema = z.strictObject({
  data: TwoFactorSecretKeySchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type TwoFactorSettingsSecretKeySuccess = z.output<
  typeof TwoFactorSettingsSecretKeySuccessSchema
>

export const WebhooksTwilioInboundRequestSchema = z.object({
  Body: z.string().optional(),
  From: z.string().optional()
})

export type WebhooksTwilioInboundRequest = z.output<typeof WebhooksTwilioInboundRequestSchema>

export const WebhooksTwilioInboundSuccessSchema = z.literal(
  '<?xml version="1.0" encoding="UTF-8"?><Response></Response>'
)

export type WebhooksTwilioInboundSuccess = z.output<typeof WebhooksTwilioInboundSuccessSchema>

export const WebhooksTwilioStatusRequestSchema = z.object({
  ErrorCode: z.string().optional(),
  MessageSid: z.string().optional(),
  MessageStatus: z.string().optional()
})

export type WebhooksTwilioStatusRequest = z.output<typeof WebhooksTwilioStatusRequestSchema>

export const WebhooksTwilioStatusSuccessSchema = z.strictObject({
  data: z.null(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type WebhooksTwilioStatusSuccess = z.output<typeof WebhooksTwilioStatusSuccessSchema>

export const PartnerShowSuccessSchema = z.strictObject({
  data: PartnerSummaryDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerShowSuccess = z.output<typeof PartnerShowSuccessSchema>

export const PartnerUpdateRequestSchema = UpdatePartnerRequestSchema

export type PartnerUpdateRequest = z.output<typeof PartnerUpdateRequestSchema>

export const PartnerUpdateSuccessSchema = z.strictObject({
  data: PartnerSummaryDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PartnerUpdateSuccess = z.output<typeof PartnerUpdateSuccessSchema>

export const PaymentOnboardingListSuccessSchema = z.strictObject({
  data: z.array(MerchantOnboardingDtoSchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentOnboardingListSuccess = z.output<typeof PaymentOnboardingListSuccessSchema>

export const PaymentOnboardingStoreRequestSchema = StoreConnectedAccountRequestSchema

export type PaymentOnboardingStoreRequest = z.output<typeof PaymentOnboardingStoreRequestSchema>

export const PaymentOnboardingStoreSuccessSchema = z.union([
  z.strictObject({
    data: MerchantOnboardingDtoSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.object({
      entity_type: z.literal('merchant_onboarding')
    }),
    success: z.literal(true)
  }),
  z.strictObject({
    data: MerchantOnboardingDtoSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.object({
      entity_type: z.literal('merchant_onboarding')
    }),
    success: z.literal(true)
  })
])

export type PaymentOnboardingStoreSuccess = z.output<typeof PaymentOnboardingStoreSuccessSchema>

export const PaymentOnboardingAllSuccessSchema = z.strictObject({
  data: z.array(MerchantOnboardingDtoSchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentOnboardingAllSuccess = z.output<typeof PaymentOnboardingAllSuccessSchema>

export const PaymentOnboardingCompletedSuccessSchema = z.strictObject({
  data: z.array(MerchantOnboardingDtoSchema),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentOnboardingCompletedSuccess = z.output<
  typeof PaymentOnboardingCompletedSuccessSchema
>

export const PaymentOnboardingShowForPayableQuerySchema = z.object({
  payable_type: PayableTypeSchema,
  payable_id: z.int().gte(1)
})

export type PaymentOnboardingShowForPayableQuery = z.output<
  typeof PaymentOnboardingShowForPayableQuerySchema
>

export const PaymentOnboardingShowForPayableSuccessSchema = z.strictObject({
  data: MerchantOnboardingWithChildrenDtoSchema.nullable(),
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentOnboardingShowForPayableSuccess = z.output<
  typeof PaymentOnboardingShowForPayableSuccessSchema
>

export const PaymentOnboardingModelsWithoutMerchantPathSchema = z.object({
  payable: PayableTypeSchema
})

export type PaymentOnboardingModelsWithoutMerchantPath = z.output<
  typeof PaymentOnboardingModelsWithoutMerchantPathSchema
>

export const PaymentOnboardingModelsWithoutMerchantSuccessSchema = z.union([
  z.strictObject({
    data: z.array(StoreSummarySchema),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.array(BrandSummarySchema),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.array(PartnerSummaryDtoSchema),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  }),
  z.strictObject({
    data: z.array(z.string()).length(0),
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.null(),
    success: z.literal(true)
  })
])

export type PaymentOnboardingModelsWithoutMerchantSuccess = z.output<
  typeof PaymentOnboardingModelsWithoutMerchantSuccessSchema
>

export const PaymentOnboardingShowPathSchema = z.object({
  onboarding: z.int().gte(0)
})

export type PaymentOnboardingShowPath = z.output<typeof PaymentOnboardingShowPathSchema>

export const PaymentOnboardingShowSuccessSchema = z.strictObject({
  data: MerchantOnboardingWithChildrenDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type PaymentOnboardingShowSuccess = z.output<typeof PaymentOnboardingShowSuccessSchema>

export const PaymentOnboardingChangeBusinessTypeRequestSchema = ChangeBusinessTypeRequestSchema

export type PaymentOnboardingChangeBusinessTypeRequest = z.output<
  typeof PaymentOnboardingChangeBusinessTypeRequestSchema
>

export const PaymentOnboardingChangeBusinessTypePathSchema = z.object({
  onboarding: z.int().gte(0)
})

export type PaymentOnboardingChangeBusinessTypePath = z.output<
  typeof PaymentOnboardingChangeBusinessTypePathSchema
>

export const PaymentOnboardingChangeBusinessTypeSuccessSchema = z.strictObject({
  data: MerchantOnboardingDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('merchant_onboarding')
  }),
  success: z.literal(true)
})

export type PaymentOnboardingChangeBusinessTypeSuccess = z.output<
  typeof PaymentOnboardingChangeBusinessTypeSuccessSchema
>

/**
 * This operation intentionally accepts no JSON request body; the action is identified by the URL and its path/query parameters.
 */
export const PaymentOnboardingAssignParentRequestSchema = z.record(z.string(), z.unknown())

export type PaymentOnboardingAssignParentRequest = z.output<
  typeof PaymentOnboardingAssignParentRequestSchema
>

export const PaymentOnboardingAssignParentPathSchema = z.object({
  parent: z.int().gte(0),
  child: z.int().gte(0)
})

export type PaymentOnboardingAssignParentPath = z.output<
  typeof PaymentOnboardingAssignParentPathSchema
>

export const PaymentOnboardingAssignParentSuccessSchema = z.strictObject({
  data: MerchantOnboardingDtoSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.object({
    entity_type: z.literal('merchant_onboarding')
  }),
  success: z.literal(true)
})

export type PaymentOnboardingAssignParentSuccess = z.output<
  typeof PaymentOnboardingAssignParentSuccessSchema
>

export const PaymentOnboardingCreateChildRequestSchema = PayableConnectedAccountRequestSchema

export type PaymentOnboardingCreateChildRequest = z.output<
  typeof PaymentOnboardingCreateChildRequestSchema
>

export const PaymentOnboardingCreateChildPathSchema = z.object({
  parent: z.int().gte(0)
})

export type PaymentOnboardingCreateChildPath = z.output<
  typeof PaymentOnboardingCreateChildPathSchema
>

export const PaymentOnboardingCreateChildSuccessSchema = z.union([
  z.strictObject({
    data: MerchantOnboardingDtoSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.object({
      entity_type: z.literal('merchant_onboarding')
    }),
    success: z.literal(true)
  }),
  z.strictObject({
    data: MerchantOnboardingDtoSchema,
    message: z.string().nullable(),
    result_code: ResultCodeSchema,
    result_params: z.object({
      entity_type: z.literal('merchant_onboarding')
    }),
    success: z.literal(true)
  })
])

export type PaymentOnboardingCreateChildSuccess = z.output<
  typeof PaymentOnboardingCreateChildSuccessSchema
>

export const UserAccessAccessSuccessSchema = z.strictObject({
  data: UserAccessSchema,
  message: z.string().nullable(),
  result_code: ResultCodeSchema,
  result_params: z.null(),
  success: z.literal(true)
})

export type UserAccessAccessSuccess = z.output<typeof UserAccessAccessSuccessSchema>
